export const messages = {
  en: {
    router: {
      root: 'Root',
      index: 'Index',
      page: 'Page',
      home: 'Home',
      database: 'Resource center',
      consult: 'Consulting Services',
      about: 'About Us',
      community: 'Open Source Community',
      productSchedulX: 'Product - SchedulX',
      productCostPilot: 'Product - CostPilot',
      productInfraPilot: 'Product - InfraPilot',
      productAIPilot: 'Product - AIPilot',
      productAidigitalHuman: 'Product - AI Digital Human',
      productPrivateAidigitalHuman: 'Product - Private AI Digital Human',
      planOperation: 'Solution - Intelligent Operation',
      planTrusteeship: 'Solution - Operation Trusteeship',
      planCost: 'Solution - Cost Optimization',
      planStable: 'Solution - Peak Traffic Handling',
      planMigrate: 'Solution - East Data West Computing',
      planActive: 'Solution - Multi-Active Deployment',
      news: 'News',
      newsDetail: 'News Detail',
      license: 'License',
      personal: 'Personal',
      minijump: 'MiniJump',
      book: 'Whitepaper',
      bookIndustry: 'Whitepaper - Serverless Industry',
      bookCostOptimization: 'Whitepaper - IT Cost Optimization',
      bookDevOps: 'Whitepaper - DevOps Solution',
      overseasEN: 'Overseas - English Version',
      overseasENHome: 'Overseas - English Version - Homepage',
      default: 'Default'
    },
    modal: {
      submit: 'Submit',
      contactTitle: 'Contact Galaxy Future',
      contactDescription: 'Leave your contact information and we will get in touch within 1 business day',
      name: 'Name',
      namePlaceholder: 'Please enter your name',
      phone: 'Phone Number',
      phonePlaceholder: 'Please enter your phone number',
      email: 'Email',
      emailPlaceholder: 'Please enter your email',
      company: 'Company',
      companyPlaceholder: 'Please enter company/school',
      position: 'Position',
      positionPlaceholder: 'Please enter your position',
      requirement: 'Description',
      requirementPlaceholder: 'Please describe your requirements',
      other: 'Other',
      otherPlaceholder: 'Please enter other information',
      submitSuccess: 'Submission successful',
      operationTypes: {
        freeUse: 'Clicked free trial button',
        reserve: 'Clicked schedule consultation button',
        deployment: 'Clicked schedule private deployment button',
        demo: 'Clicked schedule consultation button',
        demoCostPilot: 'Clicked schedule consultation (CostPilot) button',
        learnMore: 'Clicked Serverless solution button',
        freeUseCostPilot: 'Clicked free trial (CostPilot) button',
        demoCustomerCases: 'Clicked schedule consultation (customer cases) button',
        productAidigitalHuman: 'Clicked interactive digital human platform (SaaS) contact us button',
        productPrivateAidigitalHuman: 'Clicked interactive digital human platform (private) schedule technical demo button',
        productPrivateAidigitalHumanGetPlan: 'Clicked interactive digital human platform (private) get solution now button'
      },
      submissionFields: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        company: 'Company/School',
        position: 'Position',
        requirement: 'Requirement Description',
        other: 'Other'
      }
    },
    page: {
      digitalHuman: {
        panelLabel: 'Digital Human Assistant',
        openLabel: 'Open digital human assistant',
        miniInputAria: 'Type a question to open the assistant',
        inputPlaceholder: 'Type your question',
        unmuteTip: 'Unmute to hear the digital human',
        muteTip: 'Mute the digital human voice',
        unmuteAria: 'Unmute',
        muteAria: 'Mute',
        endTip: 'End conversation and disconnect',
        endAria: 'End conversation',
        restoreTip: 'Restore window size',
        widenTip: 'Enlarge window for easier reading',
        restoreAria: 'Restore window',
        widenAria: 'Enlarge window',
        collapseTip: 'Collapse the assistant',
        closeAria: 'Close assistant',
        identityAria: 'Current identity and browsing location',
        browsing: 'Browsing {title}',
        siteFallback: 'Official Site',
        retry: 'Retry',
        messagesAria: 'Conversation history',
        connecting: 'Connecting to the digital human…',
        welcomeTitle: 'Hello! How can I help you?',
        welcomeLine1: 'Ask about products and solutions,',
        welcomeLine2: 'or what you are browsing right now.',
        quickAria: 'Quick questions',
        reconnect: 'Reconnect',
        leadText: 'Need a tailored solution?',
        leadBtn: 'Book a Demo ↗',
        dismissAria: 'Dismiss',
        interrupt: 'Interrupt answer',
        switchToText: 'Switch to text input',
        switchToVoice: 'Switch to voice input',
        consultAria: 'Question',
        send: 'Send',
        answeringDots: 'Answering…',
        listeningDots: 'Listening…',
        holdToTalk: 'Hold to talk',
        tapToTalk: 'Tap to talk',
        disclaimer: 'Some content is AI-generated; please refer to actual service information.',
        avatarAria: 'Digital human assistant avatar',
        avatarAlt: 'Digital human assistant',
        idleVideoAria: 'Digital human idle video',
        aiBadge: 'AI Assistant',
        statusConnecting: 'Connecting…',
        statusOnline: 'Online',
        statusIdle: 'Standby',
        statusPreparing: 'Preparing…',
        statusThinking: 'Thinking…',
        statusSpeaking: 'Answering',
        statusReconnecting: 'Reconnecting…',
        statusDestroyed: 'Disconnected',
        answerTimeout: 'Timed out waiting for a reply. The service may be busy, please retry.',
        loadingChat: 'Loading chat component',
        slowSuffix: ', network is slow…',
        prepareFailed: 'Failed to prepare the digital human: {message}',
        chatLoadFailed: 'Failed to load chat component: {message}',
        initFailed: 'Connection failed: {message}',
        connectFailed: 'Failed to connect to the digital human',
        thinking: 'Thinking…',
        serverBusy: 'The digital human service is temporarily busy (server fallback reply), please retry.',
        echoRemoved: 'This content cannot be displayed.',
        authExpired: 'Your service authorization has expired, please retry.',
        connectionUnavailable: 'Connection is temporarily unavailable, please reconnect.',
        sessionNotReady: 'Session configuration not ready: {message}, please retry.',
        voiceUnavailableHttp: 'The microphone is unavailable on this HTTP page; please use HTTPS (localhost works for local development). You can still ask by text.',
        voiceUnavailableSupport: 'This browser does not support microphone capture; please switch browsers or ask by text.',
        micConnecting: 'Connecting…',
        micOpening: 'Turning on the microphone…',
        releaseToSend: 'Release to send',
        tapToStop: 'Tap to stop',
        waitConnect: 'Waiting for connection',
        hintConnecting: 'Connecting you to the digital human…',
        hintPreparing: 'Preparing your question…',
        hintPreparingWait: 'Getting ready, please wait…',
        hintEnded: 'This conversation has ended',
        hintAnswering: 'Answering · tap the left button to interrupt',
        hintListeningTouch: 'Listening · release to send',
        hintListening: 'Listening · sent automatically when you finish',
        hintVoiceTouch: 'Hold to talk, release to send',
        hintVoice: 'Tap to start talking',
        hintInputTouch: 'Type a question · tap the left button for voice',
        hintInput: 'Enter to send · tap the left button for voice',
        micDenied: 'Microphone access is not allowed. Please enable it in your browser site settings, or ask by text.',
        micNotFound: 'No microphone detected. Please connect one, or ask by text.',
        micStartFailed: 'Unable to start voice conversation: {message}'
      },
      homeNew: {
        hero: {
          label: 'GALAXY FUTURE · AI DIGITAL HUMAN',
          btnTrial: 'Try for Free',
          formPlaceholder: 'Enter phone number to book a demo',
          formBtn: 'Book a Demo',
          titlePre: 'Empowering Enterprises with',
          titleAccent: 'AI Digital Humans',
          titlePost: 'for Digital Transformation',
          desc: 'Galaxy Future specializes in enterprise-grade solutions including AI digital humans, digital employees and AR tour guides, integrating multiple domestic LLMs with a multi-agent architecture to help enterprises cut costs, boost efficiency, elevate customer experience and build lasting digital assets.',
          btnSolutions: 'Explore Solutions',
          btnDemo: 'Book a Demo',
          f1n: 'Low Latency',
          f1d: 'Real-time voice dialogue',
          f2n: 'Multi-language',
          f2d: 'CN/EN/FR/RU switching',
          f3n: '500+ Avatars',
          f3d: 'Full-style customization',
          f4n: 'RAG Knowledge',
          f4d: 'Enterprise knowledge base',
          f5n: 'Multi-terminal',
          f5d: 'Screens, apps and more',
          f6n: 'Private Deploy',
          f6d: 'Data stays in-domain'
        },
        stickyCta: {
          badge: 'Free trial · 1-on-1 consultant',
          text: 'Book a demo now and get a tailored industry solution with a free assessment',
          placeholder: 'Enter phone number',
          btn: 'Book Now'
        },
        stats: {
          s1v: '50+',
          s1l: 'Benchmark clients served',
          s2v: '6',
          s2l: 'National invention patents granted',
          s3v: '75%',
          s3l: 'Overall cost reduction',
          s4v: '10x',
          s4l: 'Faster R&D delivery',
          note: 'Statistics as of September 2026, based on actual operating data from delivered projects.'
        },
        products: {
          label: 'CORE PRODUCTS',
          title: 'Core Products',
          sub: 'Platform-level capability products — usable independently or combined into industry solutions.',
          more: 'Learn More',
          p1n: 'Digital Human IP Customization',
          p1d: 'High-fidelity 3D/2.5D digital human avatars — build your exclusive brand IP once and reuse it across every terminal.',
          p2n: 'Real-Time Dialogue Engine',
          p2d: 'Integrating multiple domestic LLMs with a multi-agent architecture for millisecond-level responses and natural multi-turn dialogue.',
          p3n: 'Multimodal Interaction',
          p3d: 'Photo interaction, quiz games, expressions and motions — rich interactive play modes that bring digital humans to life.',
          p4n: 'Knowledge Management',
          p4d: 'A RAG-enhanced enterprise knowledge base that continuously accumulates business knowledge assets and understands your business better over time.',
          p5n: 'Multi-Terminal Adaptation',
          p5d: 'Covers kiosks, large screens, apps and mini-programs — deploy once and reach every terminal.',
          p6n: 'Hardware Terminal Matrix',
          p6d: 'Self-developed hardware including digital human kiosks and holographic pods — ready out of the box for rapid deployment.'
        },
        solutions: {
          label: 'SOLUTIONS',
          title: 'Industry Solutions',
          sub: 'Four core scenarios — ready-to-use digital human solutions for enterprises of different scales and industries.',
          more: 'View Solution',
          s1n: 'Digital Store Manager',
          s1t: 'Large Chains',
          s1d: 'AI digital store managers for chain stores — smart greeting, product narration and membership operation in one.',
          s2n: 'Digital Employee',
          s2t: 'SOEs & Government',
          s2d: 'Digital employees for state-owned enterprises and government agencies — policy Q&A and service guidance, online 24/7.',
          s3n: 'Digital Tour Guide',
          s3t: 'Museums & Scenic Areas',
          s3d: 'AR navigation combined with digital human narration for immersive smart tour experiences.',
          s4n: 'Digital Boss',
          s4t: 'SMBs',
          s4d: 'An AI digital boss for small and medium merchants — own your exclusive digital human at low cost for easier marketing and customer acquisition.'
        },
        cases: {
          label: 'BENCHMARK CASES',
          title: 'Benchmark Cases',
          sub: 'Behind every number is real, measurable business growth for our clients.',
          detail: 'View Case Details',
          c1i: 'Museum',
          c1n: 'Du Fu Thatched Cottage',
          c1r: 'Visitor dwell time +60%',
          c2i: 'Rail Transit',
          c2n: 'A Metro Smart Customer Service',
          c2r: '65%+ of station inquiries diverted',
          c3i: 'Cultural Tourism IP',
          c3n: 'Datong Mulan',
          c3r: 'Visitor check-in rate +40%'
        },
        clients: {
          label: 'OUR CLIENTS',
          title: 'Trusted Partners',
          sub: 'Building the AI digital human ecosystem with industry-leading partners.',
          l1n: 'Yantai Zhongke',
          l2n: 'Zhipu AI',
          l3n: 'Diting Vision',
          l4n: 'Yunshang AI',
          l5n: 'Qingxiao Tech',
          l6n: 'Maitu AI',
          l7n: 'Shiyi Tech',
          l8n: 'Gulian',
          l9n: 'Realsee'
        },
        cta: {
          title: 'Start Your AI Digital Human Journey',
          desc: 'Book a demo now and let Galaxy Future tailor an AI digital human solution for your enterprise.',
          btn1: 'Book a Demo',
          btn2: 'Try for Free',
          contact: "Contact: 0592-3396506 {'|'} market{'@'}galaxy-future.com"
        },
        advantages: {
          label: 'CORE ADVANTAGES',
          title: 'Core Advantages',
          sub: 'A self-developed technology foundation proven by real deployments — every delivery is verifiable.',
          a1v: '50+',
          a1t: 'Benchmark Clients',
          a1d: 'Real deployments across tourism, retail, finance, education, government-enterprise and more.',
          a2v: '6',
          a2t: 'National Invention Patents',
          a2d: 'A self-developed foundation with underlying patents in precision measurement, shared computing and more.',
          a3v: '75%',
          a3t: 'Overall Cost Reduction',
          a3d: 'Platform-based production and multi-terminal reuse sharply reduce the cost of owning digital humans.',
          a4v: '10x',
          a4t: 'Faster R&D Delivery',
          a4d: 'Standardized processes shorten delivery cycles from days to hours.',
          note: 'Statistics as of September 2026, based on actual operating data from delivered projects.'
        }
      },
      productCenter: {

            details: {
                  btn: 'Book a Demo',
                  phonePlaceholder: 'Enter phone number to book',
                  d1: {
                        name: 'Digital Human IP Customization',
                        tag: 'Full-chain customization of 2D/3D avatars, voices, and motions',
                        ab1n: '2D/3D Avatar Modeling',
                        ab1d: 'High-fidelity 2D/3D digital human modeling in realistic, cartoon, and Chinese-style looks',
                        ab2n: 'Voice Cloning',
                        ab2d: 'Voice sampling and cloning for a branded exclusive timbre with emotional speech expression',
                        ab3n: 'Motion & Expression Driving',
                        ab3d: 'Facial expression capture plus body motion driving with natural, smooth lip-sync',
                        ab4n: 'Background Management',
                        ab4d: 'Customizable display backgrounds with image, video, and virtual-scene switching',
                        ab5n: 'Brand IP Customization',
                        ab5d: 'Enterprise brand IP customization, fully branded from avatar to voice',
                        ab6n: 'Asset Library Management',
                        ab6d: 'Unified management of digital human assets; avatars, voices, motions, and backgrounds are reusable and composable',
                        adv1: '500+ ready-to-use digital human roles',
                        adv2: '90%+ lower production cost and shorter delivery',
                        adv3: 'SaaS and on-premise dual deployment modes',
                  },
                  d2: {
                        name: 'Real-Time Conversation Engine',
                        tag: 'Full ASR+NLP+TTS chain with web and voice multi-channel access',
                        ab1n: 'ASR Speech Recognition',
                        ab1d: 'Accurate recognition of Chinese, English, and dialects with hot-word, replacement, and sensitive-word configuration; low latency, high accuracy',
                        ab2n: 'NLP Semantic Understanding',
                        ab2d: 'Intent recognition, emotion detection, and entity extraction for deep understanding of user semantics',
                        ab3n: 'TTS Speech Synthesis',
                        ab3d: 'Natural multi-timbre speech synthesis with emotional expression; voice cloning for branded timbres',
                        ab4n: 'Intercom & Volume Management',
                        ab4d: 'Single-shot and continuous intercom modes with interruption support and real-time volume control',
                        ab5n: 'Multi-Language & Language Settings',
                        ab5d: 'Real-time switching among Chinese, English, French, Russian, and more; customizable default language',
                        ab6n: 'Connectivity',
                        ab6d: 'ARTC and WebRTC connection modes for low-latency real-time audio and video transmission',
                        adv1: 'End-to-end low latency, stutter-free conversations',
                        adv2: 'SaaS and on-premise dual deployment modes',
                        adv3: 'On-premise deployment keeps data in-domain for security',
                  },
                  d3: {
                        name: 'Multimodal & Interaction',
                        tag: 'All-scenario interaction modes for ads, livestream, games, and demos',
                        ab1n: 'Ad Interaction Mode',
                        ab1d: 'Brand-driven engagement with QR-code participation, lucky draws, and coupon distribution to boost in-store conversion',
                        ab2n: 'Livestream Interaction Mode',
                        ab2d: 'Non-stop digital human livestreaming with bullet-chat interaction, product narration, and smart selling',
                        ab3n: 'Game Interaction Mode',
                        ab3d: 'Quiz, lottery, level-clearing, and knowledge games that educate through play and raise engagement',
                        ab4n: 'Mini-Program Controller',
                        ab4d: 'WeChat mini-program remote control of the digital human with one-tap position, face, and voice settings',
                        ab5n: 'Demo & Position Management',
                        ab5d: 'Self-service product and solution narration triggered by visitors, with freely schedulable digital human positions',
                        ab6n: 'Visual & Photo Interaction',
                        ab6d: 'Face recognition and motion-sensing interaction; photo moments with digital humans drive social sharing and secondary brand exposure',
                        adv1: '6 interaction modes, flexibly combined on demand',
                        adv2: 'SaaS and on-premise dual deployment modes',
                        adv3: 'Full-chain interaction tracking for measurable results',
                  },
                  d4: {
                        name: 'Knowledge Management',
                        tag: 'RAG retrieval augmentation plus intelligent enterprise knowledge-base building',
                        ab1n: 'RAG Retrieval-Augmented Generation',
                        ab1d: 'Precise answers grounded in the enterprise knowledge base, reducing LLM hallucinations',
                        ab2n: 'Automatic Knowledge Building',
                        ab2d: 'Unified multi-source data ingestion automatically builds a structured knowledge base with continuous updates',
                        ab3n: 'Intelligent Document Parsing',
                        ab3d: 'Smart parsing of PDF and Word documents with automatic extraction of key information and knowledge points',
                        ab4n: 'Knowledge-Graph Reasoning',
                        ab4d: 'Entity-relation extraction and knowledge-graph construction for relational reasoning and deep Q&A',
                        ab5n: 'Knowledge Updates & Whitelisting',
                        ab5d: 'Knowledge versioning with continuous updates; whitelists control accessible knowledge scope',
                        ab6n: 'Resident Knowledge & Memory',
                        ab6d: 'In-memory residency accelerates retrieval; context memory and conversation history are traceable',
                        adv1: 'Millions of documents searched in seconds',
                        adv2: 'On-premise deployment keeps data in-domain for security',
                        adv3: 'Knowledge accuracy above 95%',
                  },
                  d5: {
                        name: 'Multi-Terminal Adaptation',
                        tag: 'Full coverage across large screens, H5, phone, AR, smart hardware, and SDK',
                        ab1n: 'Large Screen / Hologram Cabinet / Tablet',
                        ab1d: 'Unified adaptation for floor-standing screens, hologram cabinets, and tablets with consistent touch interaction',
                        ab2n: 'H5 / Mini-Program Adaptation',
                        ab2d: 'Mobile web, WeChat mini-program, and official-account embedding — lightweight access, no download required',
                        ab3n: 'Phone / Voice Robot',
                        ab3d: 'Outbound calls, customer service, and voice navigation; pure-voice interaction covers phone channels',
                        ab4n: 'AR Device Adaptation',
                        ab4d: 'AR glasses, AR projection, and other augmented-reality terminals for immersive digital human experiences',
                        ab5n: 'Smart Hardware Terminals',
                        ab5d: 'Xiaoxing Box AI hardware (usable as an AI toy) plus projector interaction and wall interaction',
                        ab6n: 'SDK Integration',
                        ab6d: 'Developer SDK for fast integration, embedding digital human capabilities into your own apps, systems, and platforms',
                        adv1: 'Develop once, deploy to every terminal, manage centrally',
                        adv2: 'SaaS and on-premise dual deployment modes',
                        adv3: 'Consistent experience and interconnected data across terminals',
                  },
                  d6: {
                        name: 'Hardware Terminal Matrix',
                        tag: 'Xiaoxing Box series plus full-terminal adaptation brings digital humans into real spaces',
                        ab1n: 'Xiaoxing Box · Chinese Sages',
                        ab1d: 'Built-in sages such as Confucius, Laozi, Li Bai, and Du Fu with deep Q&A on a traditional-culture knowledge base',
                        ab2n: 'Xiaoxing Box · Hua Mulan',
                        ab2d: 'City culture IP customization for cultural-tourism promotion, multilingual service, and interactive photos',
                        ab3n: 'Floor-Standing Large Screen',
                        ab3d: 'Classic 43-65 inch floor-standing screens for exhibition halls, lobbies, and stores',
                        ab4n: 'Hologram Cabinet',
                        ab4d: 'Holographic presentation on transparent media — the top choice for science museums and premium exhibitions',
                        ab5n: 'Tablets & Mobile Screens',
                        ab5d: 'Portable mobile terminals for flexible deployment across roadshows and rotating locations',
                        ab6n: 'Custom Hardware Integration',
                        ab6d: 'Projector adaptation, desktop all-in-one machines, and customized hardware integration',
                        adv1: 'Integrated hardware and software, ready out of the box',
                        adv2: 'Produce once, publish to multiple terminals',
                        adv3: 'SaaS and on-premise dual deployment modes',
                  },
            },
        banner: {
          title: 'Six Core Product Modules',
          sub: 'From digital human IP customization to hardware terminals — one-stop coverage of the digital human lifecycle',
          feat1: 'Digital Human IP · Fully customizable face, voice and background',
          feat2: 'Real-Time Conversation Engine · Single/continuous intercom + ARTC/WebRTC',
          feat3: 'Knowledge Management · Document parsing + whitelist + resident knowledge base',
          feat4: 'Multimodal Interaction · Ads, live-streaming, presentation and mini-game modes',
          feat5: 'Multi-Terminal Adaptation · Large screen / hologram / tablet / H5 / phone / SDK',
          feat6: 'Hardware Terminal Matrix · Vertical screens, hologram cabinets, tablets and mobile for every scenario',
          card1t: 'Digital Human IP Customization',
          card1d: 'Fully customizable face, voice and background with 2D/3D avatar generation',
          card2t: 'Real-Time Conversation Engine',
          card2d: 'Single/continuous intercom with ARTC + WebRTC low latency',
          card3t: 'Knowledge Management',
          card3d: 'Intelligent document parsing, whitelist plus resident knowledge base',
          card4t: 'Multi-Terminal Adaptation',
          card4d: 'Full coverage of large screen / hologram / tablet / H5 / phone / SDK',
          stat1n: '6 Core Modules',
          stat1l: 'Covering the digital human lifecycle',
          stat2n: '20+ Features',
          stat2l: 'From IP customization to hardware terminals',
          stat3n: '2 Delivery Modes',
          stat3l: 'SaaS + private deployment',
          stat4n: 'Full-Terminal Coverage',
          stat4l: 'Large screen / hologram / tablet / H5 / SDK',
          envLabel: 'TRY NOW',
          env1n: 'Env 34 · Enterprise',
          env1d: 'Full-featured enterprise workspace',
          env2n: 'Env 36 · Personal',
          env2d: 'Lightweight personal edition',
        },
        products: {
          label: 'CORE PRODUCTS',
          title: 'Six Foundational Technology Products',
          sub: 'Modular full-chain capabilities: digital human avatars, conversation engine, knowledge management, multi-terminal adaptation and hardware terminals',
          p1n: 'Digital Human IP Customization',
          p1d: 'Full-dimensional digital human creation, from appearance to voice',
          p1c1: '2D/3D avatar modeling',
          p1c2: 'Voice cloning',
          p1c3: 'Motion driving',
          p1c4: 'Brand IP customization',
          p2n: 'Real-time Conversation Engine',
          p2d: 'Low-latency, human-like real-time voice conversation',
          p2c1: 'ASR speech recognition',
          p2c2: 'NLP semantic understanding',
          p2c3: 'TTS speech synthesis',
          p2c4: 'Web conversation embedding',
          p3n: 'Multimodal Interaction',
          p3d: 'Interactive play engine covering all marketing scenarios',
          p3c1: 'Ad interaction mode',
          p3c2: 'Live-stream interaction mode',
          p3c3: 'Mini-game interaction',
          p3c4: 'Presentation mode',
          p4n: 'Knowledge Management',
          p4d: 'Intelligent construction and application of enterprise knowledge assets',
          p4c1: 'RAG retrieval augmentation',
          p4c2: 'Automatic knowledge-base construction',
          p4c3: 'Intelligent document parsing',
          p4c4: 'Knowledge graph',
          p5n: 'Multi-terminal Adaptation',
          p5d: 'Develop once, reach users on every terminal',
          p5c1: 'Large-screen / holographic cabinet adaptation',
          p5c2: 'H5 / mini programs',
          p5c3: 'Phone voice bots',
          p5c4: 'SDK integration',
          p6n: 'Hardware Terminal Matrix',
          p6d: 'Integrated software-hardware delivery for offline scenarios',
          p6c1: 'Vertical large-screen terminals',
          p6c2: 'Holographic display cabinets',
          p6c3: 'Tablet terminals',
          p6c4: 'Custom hardware integration',
        },
        avatars: {
          title: 'Digital Human Avatar Library',
          sub: '500+ digital human roles, supporting full-style customization: 2D lifelike replication, 3D high-fidelity realism, chibi cartoon and more',
        },
        cta: {
          bannerTitle: 'Book Product Customization',
          bannerDesc: 'Whether it is a single product purchase or a multi-product industry solution, we can tailor it to your needs',
          bannerBtn1: 'Book Customization',
          bannerBtn2: 'Try for Free',
        },
      },
      productTerminal: {
        hero: {
          label: 'XIAOXING BOX',
          title1: 'Xiaoxing Box',
          title2: 'Pocket-Sized AI Digital Human Device',
          desc: 'Warm AI companionship anytime, anywhere — chat face to face with historical figures. 45 built-in digital human roles accompany kids aged 3~12 as they grow.',
          btn1: 'Contact Us',
          metricsLabel: 'KEY SPECS',
          m1v: '45',
          m1l: 'Digital Human Roles',
          m2v: '85g',
          m2l: 'Total Weight',
          m3v: '4h',
          m3l: 'Continuous Dialogue',
          m4v: '3~12',
          m4l: 'Age Range',
        },
        features: {
          label: 'OVERVIEW',
          title: 'Three Core Values',
          sub: 'A pocket-sized AI digital human device that redefines learning companionship for kids',
          f1t: 'AI Digital Humans',
          f1d: '45 built-in digital human roles across six categories — poets, historical figures and mythological characters — for face-to-face conversations with the greats.',
          f2t: 'Pocket-Sized',
          f2d: 'Palm-sized at just 85g — slip it into a pocket and go. Start a conversation at home, at school or on a trip.',
          f3t: 'Smart Interaction',
          f3d: 'Voice wake-up and natural multi-turn dialogue. It understands kids\u2019 whimsical ideas and responds with warmth.',
        },
        showcase: {
          label: 'DESIGN',
          title: 'Small Body, Big World',
          sub: 'A palm-sized 85g device with a complete AI digital human system inside',
          m1v: '45',
          m1l: 'Digital Human Roles',
          m2v: '85g',
          m2l: 'Total Weight',
          m3v: '4h',
          m3l: 'Continuous Dialogue',
          m4v: '7 Days',
          m4l: 'Standby Time',
        },
        functions: {
          label: 'FEATURES',
          title: 'Five Core Features for Growing Up Together',
          sub: 'More than a toy — an AI learning companion for kids',
          f1t: 'Smart Dialogue',
          f1d: 'Voice wake-up, natural conversation and multi-turn interaction with warm answers',
          f2t: 'Knowledge Q&A',
          f2d: 'Encyclopedic knowledge and historical stories answering every "why"',
          f3t: 'Multimodal Interaction',
          f3d: 'LED expressive animations for vivid, immersive companionship',
          f4t: 'Translation Mode',
          f4d: 'Auto-detected Chinese-English translation and multilingual learning',
          f5t: 'Learning Mode',
          f5d: 'Learn English naturally while chatting',
        },
        compare: {
          label: 'VERSIONS',
          title: 'Two Versions for Different Needs',
          sub: 'Choose the version that suits you best',
          tag: 'Recommended',
          unit: '/unit',
          wifiName: 'WiFi Version',
          g4Name: '4G Version',
          priceW: '¥129',
          priceG: '¥199',
          w1: '2.4GHz WiFi connectivity',
          w2: 'For home and school WiFi environments',
          w3: 'Full AI dialogue capabilities',
          w4: '45 digital human roles',
          w5: 'Knowledge-integrated learning system',
          w6: 'LED expressive animation display',
          g1: 'Built-in eSIM covering all three major carriers',
          g2: 'Online anywhere, no WiFi needed',
          g3: 'Nationwide data, ready out of the box',
          g4: 'Top button switches 4G/WiFi with one tap',
          g5: 'Full AI dialogue capabilities',
          g6: '45 digital human roles + knowledge system',
        },
        flow: {
          label: 'HOW IT WORKS',
          title: 'Up and Running in Four Steps',
          sub: 'Ready out of the box — no complex setup',
          s1t: 'Power On',
          s1d: 'Long-press the side button to power on; the LED lights up',
          s2t: 'Connect',
          s2d: 'The WiFi version joins WiFi; the 4G version connects automatically',
          s3t: 'Chat',
          s3d: 'Wake by voice, pick a favorite digital human and start talking',
          s4t: 'Grow',
          s4d: 'Learn naturally through conversation with the knowledge system',
        },
        knowledge: {
          label: 'HIGHLIGHT',
          title1: 'Knowledge-Integrated System',
          title2: 'Learning Woven into Conversation',
          desc: 'Like a friend mentioning something in passing — kids learn without noticing. No interrupting, no forcing, no lecturing, no testing.',
          t1: 'Encyclopedia',
          t2: 'Classics',
          t3: 'Languages',
          t4: 'Science',
          p1: 'Catch what the kid says first',
          p2: 'Bring up knowledge naturally',
          p3: 'No interrupting or lecturing',
          p4: 'Seamless learning',
        },
        specs: {
          label: 'SPECS',
          title: 'Technical Specifications',
          s1l: 'Dimensions',
          s1v: '65×65×45mm',
          s2l: 'Weight',
          s2v: '~85g',
          s3l: 'Battery',
          s3v: '500mAh Li-ion',
          s4l: 'Battery Life',
          s4v: '~4h continuous dialogue',
          s5l: 'Standby',
          s5v: '~7 days',
          s6l: 'Charging',
          s6v: 'Type-C, ~1.5h',
          s7l: 'Microphone',
          s7v: 'Dual-mic array with noise reduction',
          s8l: 'Age Range',
          s8v: 'Kids 3-12',
        },
        cta: {
          title: 'Growing Up with AI Companionship',
          desc: 'Contact us now to learn more about Xiaoxing Box',
          btn: 'Contact Us',
        },
      },
      solutionCenter: {
        banner: {
          title: 'Four Industry Solutions',
          sub: 'Tiered by customer segment — every solution covers positioning, pain points, value and an implementation path.',
        },
        ov: {
          title1: 'Empower Enterprises',
          title2: 'with AI Digital Humans',
          sub: 'Multi-LLM and multi-agent architecture with full-stack capabilities in digital human IP, real-time conversation and knowledge management — SaaS by default, private deployment supported',
          btn1: 'Try for Free',
          btn2: 'View Products',
          metricsLabel: 'CORE METRICS',
          m1n: '4',
          m1t: 'Industry Solutions',
          m1d: 'Store Manager · Workforce · Tour Guide · Boss',
          m2n: '6',
          m2t: 'National Invention Patents',
          m2d: 'Full-stack self-developed · LLM + Agent + Serverless',
          m3n: '8',
          m3t: 'Customer Scenarios',
          m3d: 'Retail chains · SOEs · Cultural sites · Education · Finance · Media · Government · SMBs',
          m4n: '50+',
          m4t: 'Benchmark Clients',
          m4d: 'Du Fu Thatched Cottage · Suzhou Metro · QianNianZhou · Nippon Paint · KeliHua · Jinling Primary School',
          solsLabel: 'SOLUTIONS · Four Industry Solutions',
          sol1n: 'AI Store Manager',
          sol1t: 'Chain Retail Digitalization',
          sol1d: 'For kitchen/bath, home, building material, appliance and apparel chains — consistent deployment, smart greeting, product narration and promotion',
          sol2n: 'AI Workforce',
          sol2t: 'SOE & Government Services',
          sol2d: 'For SOEs and government institutions — guidance, business inquiry, internal services and operations support, 7×24 online',
          sol3n: 'AI Tour Guide',
          sol3t: 'Immersive Cultural Tourism',
          sol3d: 'For scenic spots, museums and exhibition halls — interactive narration, multilingual guides and AR experiences',
          sol4n: 'AI Boss',
          sol4t: 'Multilingual SMB Operations',
          sol4d: 'For Yiwu markets, small shops and restaurants — multilingual reception, product introduction and order guidance',
        },
        common: {
          painTitle: 'Core Pain Points',
          valueTitle: 'Solution Value',
          pathTitle: 'Implementation Path',
          caseTitle: 'Benchmark Case',
          demoBtn: 'Book a Demo',
          featuresTitle: 'Key Features',
          othersTitle: 'Explore Other Solutions',
          detailBtn: 'Learn More',
          roleBefore: 'Before',
          roleAfter: 'Now',
        },
        sol1: {
          tag: 'SOLUTION 01',
          name: 'Digital Store Manager · Large Retail Chains',
          pos: 'A store-intelligence solution for retail chains — giving every store a gold-medal store manager that never goes offline, turning every step from walk-in to repurchase into a followable service.',
          tagsLabel: 'Applicable Scenarios',
          t1: 'Kitchen & Bath',
          t2: 'Home Furnishing',
          t3: 'Building Materials',
          t4: 'Appliances',
          t5: 'Apparel',
          p1: 'At peak hours staff are overwhelmed and stores go unattended at lunch or after closing — about 30% of interested walk-ins leave without ever being greeted',
          p2: 'What customers asked, wanted and worried about lives in sales reps\' heads; when someone leaves, the information is gone for good',
          p3: 'A "let me think about it" means no follow-up — about 70% of slow-decision customers are poached by competitors during the comparison window',
          p4: 'After payment the store goes dark — no one answers for installation or maintenance, so repurchase and referrals never happen',
          v1: '24/7 reception plus automated touchpoints across nine journey nodes — customers stay engaged online even after the store closes',
          v2: '360° customer profiles plus personalized H5 proposals — tripling decision efficiency',
          v3: 'Gold-medal manager expertise replicated at scale; existing pay is untouched and only incremental gains are shared, so everyone earns more',
          v4: 'Customer satisfaction up 40% and repurchase rate up 25% — after-sales turns from going dark into long-term engagement',
          s1n: '8%-30%',
          s1l: 'Revenue growth range',
          s2n: '400%+',
          s2l: 'Per-store ROI',
          s3n: '2-3 Months',
          s3l: 'Average payback period',
          s4n: '7×24',
          s4l: 'Always-on service',
          crumb: 'Solutions · AI Digital Store Manager',
          bf1: 'HQ unified management with consistent digital human deployment across all stores',
          bf2: 'Smart in-store greeting, product explanation and promotion guidance',
          bf3: '7×24 uninterrupted service, reducing labor costs',
          bf4: 'Real-time data sync keeps HQ on top of every store\'s operations',
          bf5: 'Differentiated content configuration for each store',
          bc1t: 'Three-Terminal Data Collection',
          bc1d: 'Kiosk + handheld + H5 — 8 types of customer data captured',
          bc2t: 'Nine-Touchpoint Follow-Up',
          bc2d: 'Automated reach from first visit to repurchase, no customer missed',
          bc3t: 'Staff Incentive Mechanism',
          bc3d: 'Service quality bonus plus incremental commission — income only grows',
          bc4t: '360° Customer Profile',
          bc4d: 'Personalized service plans generated from real customer data',
          st1n: 'Stop the Bleeding',
          st1d: 'Months 1-2',
          st2n: 'Incentives in Action',
          st2d: 'Months 2-3',
          st3n: 'Scale & Flywheel',
          st3d: 'Month 3+',
          c1: 'A home-furnishing retail chain: showroom digital humans delivering smart shopping guidance and product narration',
          c2: 'Pilot program: 6-10 stores with ¥30-50K annual investment per store, real ROI verified in 3 months — stop anytime if targets are missed',
          f1t: 'Three-Terminal Data Capture',
          f1d: 'In-store kiosks chat naturally like a friend — no pitching, no pressure; sales reps log details on handheld terminals anytime; customers keep interacting via H5/mini-program after leaving — all flowing into one unified profile.',
          f2t: '360° Customer Profile',
          f2d: 'Automatically records eight categories: basic profile, needs, real pain points, budget range, timeline, key decision-makers, concerns and competitor comparisons.',
          f3t: 'Automated Touchpoints Across Nine Nodes',
          f3d: 'Pre-sale proposal walkthroughs and 3/7-day decision reminders, in-sale real-time construction progress, post-sale 7-day check-ins, maintenance reminders and anniversary care — via WeChat, SMS and H5.',
          f4t: 'Personalized H5 Proposal',
          f4d: 'Six modules in one package: product picks, bundled solutions, risk disclosure, process steps, transparent pricing and maintenance — with the AI store manager always on.',
          f5t: 'Incremental Staff Incentives',
          f5d: 'Service-quality awards plus incremental commissions and profit sharing: sales reps +20-30% monthly, store managers +30-50% annually, installers +15-25% monthly — nothing deducted, only gains shared.',
          f6t: 'Manager Dashboard',
          f6d: 'Traffic, conversion and ticket size each up 10% compound into real growth; see the weak links of every store at a glance — from gut-feel management to data-driven precision.',
          loopTitle: 'Core Logic: A Closed Loop from Capture to Repurchase',
          loopSub: 'Not just proposal generation — four progressive steps; the first three lay the groundwork, the fourth gives it soul',
          l1n: 'Information Capture',
          l1d: 'From the moment a customer walks in, every detail is captured and settled automatically — no more relying on staff memory',
          l2n: 'Full-journey Follow-up',
          l2d: 'From walk-in to repurchase, the system follows up at every node — no customer ever falls through',
          l3n: 'Staff Alignment',
          l3d: 'Not policing people but helping them — aligned incentives turn frontline resistance into initiative',
          l4n: 'Personalized Service',
          l4d: 'Proposals built on real information that genuinely help customers avoid pitfalls and build trust',
          ledgerTitle: 'Single-store P&L — Growth You Can Calculate',
          ledgerSub: 'Conservative estimate based on a store with ¥5M annual revenue growing 15%',
          b1n: '+¥750K',
          b1d: 'Revenue growth (conservative 15%)',
          b2n: '+¥225K',
          b2d: 'Gross profit increase (30% margin)',
          b3n: '+¥30-50K',
          b3d: 'Fewer complaints, cancellations and rework losses',
          b4n: '¥200-220K',
          b4d: 'Annual net gain per store; benchmark stores reach ¥370-400K',
          ledgerNote: 'Basis: 30% is a stretch target for qualified benchmark stores, not a guaranteed floor; all figures follow a conservative, deliverable basis.',
          nodesTitle: 'Nine Automated Touchpoints — No Broken Links',
          nodesSub: 'Reach customers via WeChat, SMS, H5 and mini-program — slow-decision customers stay engaged instead of slipping away',
          ph1t: 'Pre-sale · Nurture',
          ph1r: 'Nodes 01-05 · Walk-in to Compare',
          ph1d: 'Thank-you messages with proposal links, proposal walkthroughs, 3/7-day decision reminders, limited-time offers',
          ph2t: 'In-sale · Transparency',
          ph2r: 'Nodes 06-07 · Order to Install',
          ph2d: 'Order confirmation and scheduling, real-time construction progress, acceptance check and usage guide',
          ph3t: 'After-sale · Long-term Engagement',
          ph3r: 'Nodes 08-09 · Support to Repurchase',
          ph3d: '7-day check-ins, maintenance reminders, anniversary care, extended warranty and referral recommendations',
          n1: 'Walk-in',
          n2: 'Inquiry',
          n3: 'Proposal',
          n4: 'Leave',
          n5: 'Compare',
          n6: 'Order',
          n7: 'Install',
          n8: 'Support',
          n9: 'Repurchase',
          rolesTitle: 'Not Policing People — Helping Them Earn',
          rolesSub: 'Systems used to fail because they policed people; this one helps everyone earn more, so everyone wants in',
          r1n: 'Sales Rep',
          r1r: 'Frontline Closer',
          r1g: '+20-30%',
          r1gl: 'Monthly income',
          r1b: 'Customer details lived in memory — one lapse lost a deal; follow-ups depended on personal discipline',
          r1a: 'AI remembers everything and follows up automatically; reps simply close with warmth — commission 2%→3% plus service-quality awards',
          r2n: 'Store Manager',
          r2r: 'Store Operator',
          r2g: '+30-50%',
          r2gl: 'Annual income',
          r2b: 'Managed by gut feel, guessing who performed, always playing firefighter',
          r2a: 'Dashboards expose every weak link for precise management; incremental profit sharing turns managers into coaches',
          r3n: 'Installer',
          r3r: 'Delivery & Service Frontline',
          r3g: '+15-25%',
          r3gl: 'Monthly income',
          r3b: 'Work waited on urging and coordination; pay was opaque and late',
          r3a: 'Smart scheduling cuts idle waiting; good reviews prioritize orders — gold-medal rates up 10-20%',
          lv1n: 'Traffic Lever',
          lv1d: '24/7 reception and after-hours lead capture recover lost and referral traffic',
          lv2n: 'Conversion Lever',
          lv2d: 'Personalized proposals, transparent pricing, full-journey touchpoints, human-AI teaming',
          lv3n: 'Ticket-size Lever',
          lv3d: 'Bundles, service packages and sensible upgrades — added value, not added price',
          lvResult: '1.1 × 1.1 × 1.1 = 1.33, i.e. +33% revenue (conservative basis: 8%-20% baseline, 20%-30% for benchmark stores)',
          st1a: 'Acceptance: traffic loss -20%, profile completeness ≥70%, usage ≥80%',
          st2a: 'Acceptance: clear gains in conversion, ticket size and NPS; proactive frontline usage',
          st3a: 'Acceptance: per-store ROI on target, replicable SOPs formed, scaling begins',
        },
        sol2: {
          tag: 'SOLUTION 02',
          name: 'Digital Employee · SOEs & Government',
          pos: 'Standardized, auditable digital labor — a privately deployed AI workforce for state-owned enterprises and government agencies that truly takes up the job: thinking, executing end to end and getting smarter with use.',
          tagsLabel: 'Typical Roles',
          t1: 'Smart Customer Service',
          t2: 'Expense Reimbursement',
          t3: 'Ops Duty',
          t4: 'Office Assistant',
          p1: 'High-frequency repetitive work — hotline support, expense claims, data entry — consumes large amounts of manpower as labor costs keep rising',
          p2: 'Service quality varies from person to person; business practices are inconsistent and standardization is difficult',
          p3: 'Duty roles face heavy 24/7 availability pressure, especially nights and holidays',
          p4: 'Long onboarding cycles; hard-won knowledge is difficult to pass on',
          v1: 'Digital employees take over high-frequency repetitive work end to end, cutting labor costs by 30%+',
          v2: 'Always-on service around the clock lifts business efficiency by 50%+, with proactive alerts that bring data to people',
          v3: '100% standardized, fully auditable service',
          v4: 'On-premise deployment with domestic-stack compatibility and perpetual licensing — data never leaves your network',
          s1n: '30%+',
          s1l: 'Labor cost savings',
          s2n: '50%+',
          s2l: 'Business efficiency gain',
          s3n: '100%',
          s3l: 'Service standardization',
          crumb: 'Solutions · AI Workforce',
          bf1: 'Smart guidance in government halls — process navigation and application-material checklists',
          bf2: 'Internal-service digital employees — one-stop IT, HR and finance support',
          bf3: 'Proven benchmark deployments — service fully standardized and auditable',
          bf4: 'Private deployment — data stays in-domain, secure and controllable',
          bf5: 'Multilingual service for international scenarios',
          bc1t: 'Service Guidance',
          bc1d: 'Process navigation and application-material checklists',
          bc2t: 'Smart Business Inquiry',
          bc2d: 'Real-time Q&A on policies, regulations and case progress',
          bc3t: 'Internal Service Support',
          bc3d: 'One-stop internal consulting for IT ops, HR and finance',
          bc4t: 'Operations Dashboard',
          bc4d: 'Visualized service data for evidence-based decisions',
          st1n: 'Small-scope Pilot',
          st1d: '3 Months',
          st2n: 'Scaled Rollout',
          st2d: '6-12 Months',
          st3n: 'Enterprise-wide Coverage',
          st3d: 'Ongoing',
          c1: 'A metro smart customer service: live since May 2026 with bilingual 24/7 service covering nearly 200 cultural-tourism spots along the lines — the first digital employee integrating transport, culture, commerce and tourism in China\'s urban rail industry',
          f1t: 'Smart Customer Service',
          f1d: 'Answers calls and messages around the clock; routine questions resolved automatically, complex ones handed to humans seamlessly.',
          f2t: 'Expense Reimbursement',
          f2d: 'Invoice recognition, claim review and fee verification fully automated, with 99%+ accuracy in authenticity and duplicate checks — finance staff freed from paperwork review.',
          f3t: 'Ops Duty',
          f3d: 'Late-night inspections, fault alerts and emergency response always online — knowledge-retrieval efficiency up 70%+, fault-handling efficiency up 50%+.',
          f4t: 'Office Assistant',
          f4d: 'Drafts documents, searches materials and writes meeting minutes through natural language — zero learning curve.',
          f5t: 'On-Premise + Domestic Stack',
          f5d: 'Supports Ascend computing, Kunpeng/Phytium CPUs, Kylin/UOS operating systems and domestic LLMs — perpetual license with no recurring subscription, data never leaves your network.',
          f6t: 'MLPS Level-3 Compliance',
          f6d: 'End-to-end encryption in transit and at rest, fully auditable operations and role-based access control.',
          loopTitle: 'Long-term Value: The Data Flywheel',
          loopSub: 'A one-time investment that keeps paying off — the more data accumulates, the smarter the AI gets',
          l1n: 'Data Accumulation',
          l1d: 'Every transaction settles into your private knowledge base — every service feeds the system',
          l2n: 'Continuous Evolution',
          l2d: 'The more data, the smarter the AI — a digital colleague that keeps getting more capable',
          l3n: 'Sharper Service',
          l3d: 'Responses grow more precise while business practices stay consistently on-standard',
          l4n: 'Happier Users',
          l4d: 'Satisfaction drives more usage and more data — the flywheel accelerates',
          ledgerTitle: 'Value Ledger — Cost Down, Efficiency Up, Quality Standardized',
          ledgerSub: 'Based on live SOE deployments — pilot first, verify, then scale',
          b1n: '30%+',
          b1d: 'Labor cost savings across high-frequency roles',
          b2n: '50%+',
          b2d: 'Business efficiency gain with 24/7 always-on service',
          b3n: '99%+',
          b3d: 'Accuracy in invoice authenticity and duplicate checks',
          b4n: '12-18 Months',
          b4d: 'Payback period — net gains every year after that',
          ledgerNote: 'Basis: start with a small pilot, verify real results in 3 months, then decide the rollout scale — investment and risk stay under control. Data security: private deployment (data never leaves your domain) + tiered permissions + full-link audit trails — safer than public cloud.',
          rolesTitle: 'Not Replacing People — Freeing Them from Repetitive Work',
          rolesSub: 'AI takes the standardized, high-frequency, 24/7 work; people move on to judgment and creation',
          r1n: 'Customer Service',
          r1r: 'High-frequency Frontline',
          r1g: '-30%',
          r1gl: 'Labor cost',
          r1b: 'Eight-hour shifts with delayed responses; quality varied by person and training took months',
          r1a: 'Answers calls and messages 24/7 — routine questions resolved automatically, complex ones handed to humans seamlessly',
          r2n: 'Finance Staff',
          r2r: 'Document Review Backbone',
          r2g: '99%+',
          r2gl: 'Check accuracy',
          r2b: 'Invoice recognition, claim review and fee verification all manual — costly and error-prone',
          r2a: 'The full review pipeline runs automatically — finance staff freed from paperwork review',
          r3n: 'Ops Duty',
          r3r: '24/7 Watch Floor',
          r3g: '+50%',
          r3gl: 'Fault-handling efficiency',
          r3b: 'Heavy overnight inspection and duty pressure — nights and holidays hard to staff',
          r3a: 'Inspections, alerts and emergency response always online; knowledge-retrieval efficiency up 70%+',
          st1a: 'Acceptance: 1-2 pilot scenarios run end to end, cost and efficiency targets met, data never leaves the intranet',
          st2a: 'Acceptance: replication across roles and departments succeeds; accuracy and service stability on target',
          st3a: 'Acceptance: enterprise-wide coverage achieved; the data flywheel turns and AI capability keeps growing',
        },
        sol3: {
          tag: 'SOLUTION 03',
          name: 'Digital Tour Guide · Museums, Scenic Areas & Halls',
          pos: 'Exclusive IP that tells your cultural story — a digital tour-guide solution for museums, scenic areas and exhibition halls: not a replacement for docents, but a dedicated cultural guide online 24/7.',
          tagsLabel: 'Key Features',
          t1: 'Exclusive IP Customization',
          t2: 'Location-triggered Narration',
          t3: 'LLM Voice Q&A',
          t4: 'Personalized Route Planning',
          t5: 'Operations Dashboard',
          t6: 'AR Virtual-Real Fusion',
          p1: 'Professional docents cost ¥80-150K per person a year — visitors queue 30+ minutes in peak season while staff sit idle in the off-season',
          p2: 'Traditional audio guides recite scripts and cannot answer personal questions — children, seniors and foreign visitors are underserved',
          p3: 'Human narration only covers opening hours — nights, closing days and remote exhibits go unserved',
          p4: 'Visitor interests, dwell time and frequent questions go uncollected, leaving operations decisions without evidence',
          v1: 'An exclusive cultural IP digital human for every venue, online 24/7',
          v2: 'AR + digital human immersive guidance lifts visitor dwell time by 40%+',
          v3: 'Dashboard-driven operations turn visitor behavior into an operational asset',
          v4: 'Four deployment modes — Bluetooth beacon, mini-program, AR and 32-inch kiosk — standard features live in as fast as 7 days',
          s1n: '60-70%',
          s1l: 'Docent cost reduction',
          s2n: '+28%',
          s2l: 'Secondary spending conversion',
          s3n: '92%+',
          s3l: 'Visitor satisfaction',
          s4n: '24/7',
          s4l: 'Always-on guidance',
          crumb: 'Solutions · AI Tour Guide',
          bf1: 'Interactive digital-human narration with multilingual guidance',
          bf2: 'AR guidance — an immersive virtual-real experience',
          bf3: 'Benchmark venue deployments including Du Fu Thatched Cottage',
          bf4: 'Custom tour routes and narration content',
          bf5: 'Better visitor experience, less pressure on human docents',
          bc1t: 'Beacon Positioning',
          bc1d: 'Bluetooth beacons with 1-3 m accuracy — narration follows visitors, stick-and-play',
          bc2t: 'Mini-Program Scan',
          bc2d: 'Wake the guide with a WeChat scan — zero barrier',
          bc3t: 'AR Virtual-Real Fusion',
          bc3d: 'AR glasses and phone AR — 3D artifact restoration and scene overlays',
          bc4t: 'Mobile Kiosk',
          bc4d: 'A 32-inch movable terminal for reception, interaction, guidance, translation and narration',
          st1n: 'Exhibit Mapping',
          st1d: '2 Weeks',
          st2n: 'AR Content Production',
          st2d: '2-3 Weeks',
          st3n: 'Joint Debugging',
          st3d: '1 Week',
          st4n: 'Trial Operation',
          st4d: '2 Weeks',
          st5n: 'Official Opening',
          st5d: 'Ongoing',
          c1: 'Du Fu Thatched Cottage: 7.2M annual visitors, its digital Du Fu selected as a national 2025 cultural-tourism digitalization innovation showcase',
          c2: 'Datong Mulan: selected among the ten benchmark cases of the Shanxi Cultural Expo',
          c3: 'Aihui History Exhibition Hall: historical-figure digital human narration bringing cultural heritage to life',
          f1t: 'Exclusive Digital-Human IP',
          f1d: 'Built on each venue\'s cultural DNA in hyper-realistic 3D, cartoon or historical-figure styles — a unique face for every venue telling its own cultural story.',
          f2t: 'Location-Triggered Narration',
          f2d: 'Bluetooth 5.0 beacons plus GPS with 1-3 meter accuracy, stick-and-play deployment and 12-month battery life — narration follows visitors around, adapting by age and interest.',
          f3t: 'LLM Voice Q&A',
          f3d: 'Free conversation grounded in a venue-specific knowledge base with real-time translation across Chinese, English, French, Russian, and more — real AI, not recordings.',
          f4t: 'Personalized Route Planning',
          f4d: 'Optimal routes by time, interest and stamina, with crowd avoidance and recommendations for dining and merchandise spending.',
          f5t: 'Operations Dashboard',
          f5d: 'Heat maps, dwell time, frequent questions and satisfaction fully visualized — visitor data becomes an operational asset.',
          f6t: 'AR Virtual-Real Fusion',
          f6d: 'Supported on AR glasses and phone AR alike — 3D artifact restoration and historical-scene overlays for an immersive experience.',
          loopTitle: 'Core Logic: Narration + Interaction + Data + Operations in One Loop',
          loopSub: 'AI digital humans as the entry point — visitor behavior settles into an operational asset',
          l1n: 'Smart Narration',
          l1d: 'Location-triggered, age- and interest-adaptive — narration follows visitors around',
          l2n: 'Free Interaction',
          l2d: 'LLM voice Q&A with real-time multilingual translation — a personal answer for every visitor',
          l3n: 'Data Capture',
          l3d: 'Dwell time, frequent questions and heat maps collected across the full journey',
          l4n: 'Operations Optimization',
          l4d: 'Dashboards drive exhibit tuning and precision marketing, feeding back into better narration',
          ledgerTitle: 'Venue Ledger — Returns You Can Measure',
          ledgerSub: 'Cost down, efficiency up, revenue and quality up — every value point backed by data',
          b1n: '60-70%',
          b1d: 'Docent cost reduction; annual upkeep at one fifth of a human team',
          b2n: '+28%',
          b2d: 'Secondary-spending conversion; merchandise and dining revenue up',
          b3n: '92%+',
          b3d: 'Visitor satisfaction, with dwell time up 40%+',
          b4n: '6-12 Months',
          b4d: 'Payback period for a standard single-venue project',
          ledgerNote: 'Source: consolidated public operating data from Dunhuang Academy, the Palace Museum, Henan Museum and other projects. Three flexible pricing models: one-time purchase + annual O&M (¥130-750K) / SaaS subscription (¥30-150K/yr) / revenue-sharing (zero deployment fee, sharing secondary-spending income) — payback in 6-12 months.',
          rolesTitle: 'One Digital Docent, Every Visitor Served',
          rolesSub: 'Uniform scripts used to underserve children, seniors and foreign visitors — now narration adapts to each audience',
          r1n: 'Children & Families',
          r1r: 'Young Explorers',
          r1g: '63%',
          r1gl: 'Instant knowledge absorption',
          r1b: 'Script-reciting guides left children bored — seen once, forgotten immediately',
          r1a: 'Cartoon-style storytelling and age-based narration make kids ask about artifacts on their own',
          r2n: 'Foreign Visitors',
          r2r: 'International Guests',
          r2g: 'CN/EN/JP/KR',
          r2gl: 'Real-time translation',
          r2b: 'Limited language coverage forced visitors onto translation apps with a poor experience',
          r2a: 'Native-language interfaces and voice Q&A — zero-barrier visits for guests from anywhere',
          r3n: 'Researchers & Deep Explorers',
          r3r: 'Knowledge Seekers',
          r3g: '+40%',
          r3gl: 'Average dwell time',
          r3b: 'One-size-fits-all scripts could not answer in-depth follow-up questions',
          r3a: 'A venue-specific knowledge base supports multi-turn deep dives into excavation details and craftsmanship',
          st1a: 'Acceptance: exhibit inventory and knowledge-base content confirmed',
          st2a: 'Acceptance: digital-human IP and AR content approved on style and accuracy',
          st3a: 'Acceptance: positioning accuracy within 1-3 meters; Q&A accuracy on target',
          st4a: 'Acceptance: trial operation hits satisfaction and stability targets',
          st5a: 'Acceptance: official opening with continuous operations and data review in place',
        },
        sol5: {
          tag: 'SOLUTION 05',
          name: 'Smart Terminals · XiaoXing Box & Mimi Box',
          pos: 'A dual-hardware terminal matrix built on our self-developed private digital-human platform — one engine serving both bulk gov-enterprise and edutainment procurement and long-term whole-family companionship.',
          tagsLabel: 'Terminals & Capabilities',
          t1: 'XiaoXing Box · Portable AI Terminal',
          t2: 'Mimi Box · Glasses-free 3D Hologram',
          t3: 'Zhonghua Book Guofeng IP Library',
          t4: 'Multi-dialect Voice Interaction',
          t5: 'On-premise Deployment',
          t6: 'Elderly Care & Family Companionship',
          t7: 'Hardware Management Platform',
          t8: 'OTA Remote Upgrades',
          p1: 'Strict data-security and compliance requirements rule out public-cloud options',
          p2: 'Repeated hardware and content development is costly and slow, with IP assets that cannot be reused',
          p3: 'Single-scenario terminals cannot cover the full cycle from outdoor edutainment to home companionship',
          p4: 'Content safety is uncontrollable — children and elderly scenarios have zero tolerance for harmful content',
          v1: 'One digital-human engine reused across both terminals — no duplicated IP development',
          v2: 'Serverless elastic compute cuts computing costs to one tenth of the industry norm and multiplies R&D efficiency tenfold',
          v3: 'Self-developed real-time lip-sync technology reduces service costs by 75%',
          v4: 'Tiered channel coverage — XiaoXing Box scales volume while Mimi Box lifts ticket size, outdoor and home ecosystems complementing each other',
          s1n: '<$30',
          s1l: 'XiaoXing Box hardware cost',
          s2n: '75%',
          s2l: 'Service cost reduction',
          s3n: '50+',
          s3l: 'Gov-enterprise clients served',
          s4n: '<$450',
          s4l: 'Mimi Box hardware cost',
          crumb: 'Products · Smart Terminals',
          bf1: 'XiaoXing Box: an affordable lightweight terminal designed for children\'s education and edutainment',
          bf2: 'Mimi Box: a premium holographic terminal for family companionship and elderly care',
          bf3: 'One self-developed digital-human engine reused across both terminals — author once, publish everywhere',
          bf4: 'Private deployment — data stays inside your network, meeting MLPS and government security requirements',
          bf5: 'Exclusive Zhonghua Book Guofeng IP library — content for every age group',
          bc1t: 'XiaoXing Box · Chinese Sages',
          bc1d: 'Built-in Confucius, Li Bai and Du Fu avatars with deep traditional-culture Q&A',
          bc2t: 'XiaoXing Box · Mulan',
          bc2d: 'Custom city-culture IP for tourism promotion, multilingual service and photo interaction',
          bc3t: 'Mimi Box · Family Digital Human',
          bc3d: 'Rebuild holographic family members from photos for remote family interaction',
          bc4t: 'Full-scenario Content Safety',
          bc4d: 'Smart filtering blocks hallucinations and harmful content — safe for kids and seniors',
          st1n: 'Model Selection',
          st1d: 'Direct custom / channel standard',
          st2n: 'IP & Content Customization',
          st2d: '2-4 Weeks',
          st3n: 'Hardware Integration',
          st3d: '1-2 Weeks',
          st4n: 'Delivery & Operations',
          st4d: 'Hardware + SaaS subscription',
          c1: 'A metro smart customer service: in-station smart guidance and service terminal',
          c2: 'Nanjing Kelihua Middle School and more: renewing year after year, proving customer stickiness',
          c3: 'China Publishing Group and other Fortune Global 500 enterprises: internal smart Q&A terminals',
          c4: 'A major state-owned bank\'s Beijing branch: an intelligent, high-efficiency financial service window',
          f1t: 'XiaoXing Box · Portable AI Terminal',
          f1d: 'Battery-powered and wearable, or embedded in toys as an AI core, backed by low-latency cloud inference and a massive IP character library — hardware costs under ¥200, built for bulk procurement.',
          f2t: 'Mimi Box · Glasses-free 3D Hologram',
          f2d: 'A patented optical film renders a floating 3D figure on a high-definition holographic display; rebuild a holographic digital human of family members from photos, with a built-in NPU for local offline compute.',
          f3t: 'Smart Care for Seniors Living Alone',
          f3d: 'An auditory sensing module detects falls in real time and alerts children\'s phones automatically, with health consultation, remote holographic calls and one-touch help.',
          f4t: 'Zhonghua Book Guofeng IP Library',
          f4d: 'Exclusive Chinese-sage and Guofeng digital-human IP licensing — one IP reused across both terminals, no duplicate development.',
          f5t: 'Private Platform Foundation',
          f5d: 'Data stays inside your network, meeting MLPS and government data-security requirements, with built-in content risk control against hallucinations and harmful output.',
          f6t: 'Multimodal Voice Interaction',
          f6d: 'Multi-dialect recognition, smart noise reduction and multi-turn dialogue, deeply integrated with Volcano Engine and Alibaba Cloud.',
          f7t: 'Hardware Management Platform',
          f7d: 'Unified device management, remote status monitoring, remote content distribution, OTA upgrades and fault alerts — fleet-scale deployment without worries.',
          f8t: 'Dual-Drive Business Model',
          f8d: 'Direct custom projects (private platform + batch terminal customization, from ¥100K to seven figures) alongside channel-standard delivery (standard hardware + SaaS subscription, ¥30-200K out of the box).',
          ledgerTitle: 'Platform Ledger — One Engine, Two Terminals',
          ledgerSub: 'Serverless elastic compute plus self-developed real-time lip-sync — leading on both cost and efficiency',
          b1n: '1/10',
          b1d: 'Computing cost at one tenth of the industry norm',
          b2n: '75%',
          b2d: 'Service cost cut by self-developed real-time lip-sync',
          b3n: '10×',
          b3d: 'R&D efficiency gain, backed by 6 core invention patents',
          b4n: '50+',
          b4d: 'Gov-enterprise clients across transit, finance, tourism, energy and education',
          ledgerNote: 'Revenue model: hardware sales + SaaS subscriptions + custom development — XiaoXing Box scales volume under ¥200, Mimi Box anchors the premium home tier under ¥3,000, with digital-human content and features on continuous subscription.',
          loopTitle: 'Synergy: A Complete Digital-Human Terminal Ecosystem',
          loopSub: 'Tiered channels × IP reuse × scenario complementarity — not two isolated products, but one ecosystem',
          l1n: 'Tiered Channel Coverage',
          l1d: 'Schools and cultural-tourism SMBs buy XiaoXing Box at scale; premium homes and elder-care institutions adopt Mimi Box at higher ticket sizes',
          l2n: 'IP Reuse Cuts Costs',
          l2d: 'The same sage and Guofeng IPs fit both terminals — no duplicated character development, much lower production and operating costs',
          l3n: 'Complementary Scenarios',
          l3d: 'XiaoXing Box serves outdoor edutainment and on-the-go use; Mimi Box anchors long-term home companionship',
          l4n: 'Recurring Subscription Revenue',
          l4d: 'Beyond hardware sales, digital-human content and features subscribe continuously — customer lifetime value keeps growing',
          st1a: 'Acceptance: delivery model (direct custom / channel standard) and target scenarios confirmed',
          st2a: 'Acceptance: exclusive IP avatar and knowledge-base content approved',
          st3a: 'Acceptance: hardware integration complete; online and offline interaction verified stable',
          st4a: 'Acceptance: batch delivery done; content subscription and O&M mechanisms in operation',
        },
        sol4: {
          tag: 'SOLUTION 04',
          name: 'Digital Boss · SMB Merchants',
          pos: 'One agent for inquiries and quoting — a lightweight digital-boss solution for SMB merchants: reception, quoting, follow-up and retention, nothing dropped; a digital employee, not a decoration.',
          tagsLabel: 'Key Features',
          t1: '24/7 Online',
          t2: 'Multilingual Interaction',
          t3: 'Instant Quotation',
          t4: 'Customer Management',
          t5: 'WhatsApp Integration',
          t6: 'Localization',
          t7: 'AI Live Selling',
          t8: 'Dual Hardware',
          p1: 'Time-zone gaps slow overseas inquiry responses — midnight and holiday inquiries go unanswered',
          p2: 'High multilingual communication costs — serving buyers in their mother tongue is hard',
          p3: 'Manual quoting is slow and error-prone — orders slip away',
          p4: 'Customers leave with departing sales staff — quotes and follow-up records never settle',
          v1: 'A 24/7 trade assistant that never closes — night-time deals up 30%',
          v2: '30+ languages in real time with bilingual side-by-side display and instant quotes',
          v3: 'WhatsApp integration with localized operations',
          v4: 'Customer assets all settle in the company system — they stay when people leave',
          s1n: '24/7',
          s1l: 'Always online',
          s2n: '30+',
          s2l: 'Languages switched in real time',
          s3n: '300%+',
          s3l: 'Order-handling efficiency',
          s4n: '<¥20K',
          s4l: 'Per-store entry investment',
          crumb: 'Solutions · AI Boss',
          bf1: 'Automated multilingual reception serving buyers worldwide',
          bf2: 'Product intro, price inquiry and order guidance in one flow',
          bf3: 'Low-cost fast deployment — no technicians required',
          bf4: 'Open 24/7 — never miss a customer',
          bf5: 'Lightweight access via WeChat mini-programs and more',
          bc1t: 'Multilingual Real-time Chat',
          bc1d: '30+ languages with bilingual display — buyers operate in their mother tongue',
          bc2t: '24-hour Smart Service',
          bc2d: 'Auto-replies to price and stock inquiries at night, capturing leads',
          bc3t: 'AI Live Streaming',
          bc3d: 'Cloned merchant avatar and voice — 24/7 nonstop live selling',
          bc4t: 'Smart Reception & Recommendation',
          bc4d: 'Motion-sensing greeting, product catalogs and digital business cards',
          st1n: 'Requirement Alignment',
          st1d: '1 Week',
          st2n: 'Knowledge & Quote Setup',
          st2d: '1-2 Weeks',
          st3n: 'Channel Integration',
          st3d: '1 Week',
          st4n: 'Go-live & Operations',
          st4d: 'Ongoing',
          c1: 'A benchmark coatings-industry client: a 24/7 multilingual WhatsApp agent with localization for India and other overseas markets',
          c2: 'A Yiwu merchant: five rounds of late-night AI dialogue closed a $22M Middle East order',
          c3: 'A 23-stall Yiwu pilot: marketing costs down 58%, export volume up 52%',
          f1t: '24/7 Always Online',
          f1d: 'Cross-time-zone inquiries answered in seconds, nights and holidays included — auto-replies on price and stock with lead capture, night-time deals up 30%.',
          f2t: '30+ Languages in Real Time',
          f2d: 'Interface-level switching across 30+ languages with bilingual side-by-side display — buyers operate in their mother tongue, zero barriers worldwide.',
          f3t: 'Instant Smart Quotation',
          f3d: 'Every inquiry gets a professional quote in seconds — no more waiting, no more manual errors.',
          f4t: 'Customer Relationship Management',
          f4d: 'Inquiries, quotes and follow-ups all persist — customer assets survive staff turnover.',
          f5t: 'Deep WhatsApp Integration',
          f5d: 'Serve customers where they already are — mainstream overseas channels connected in one stop.',
          f6t: 'Localized Operations',
          f6d: 'Adapts to the language habits and business culture of each target market, making global trade feel local.',
          f7t: 'AI Digital-Human Live Streaming',
          f7d: 'Clone the merchant\'s avatar and voice for 24/7 nonstop live selling — low cost, highly stable, multi-platform streaming.',
          f8t: 'Business Review & Daily Briefing',
          f8d: 'Daily digests of inquiries, conversions and customer tiers pushed to your phone — grasp the business in one minute.',
          f9t: 'Hardware Matrix · Dual Form Factors',
          f9d: 'Entry 32-inch mobile screen, plug-and-play for stalls, expos and storefronts; flagship 43-inch light-field 3D display with 178° glasses-free 3D for premium booths.',
          loopTitle: 'Core Logic: A Closed Loop from Inquiry to Customer Asset',
          loopSub: 'Videos bring the buyers in — Digital Boss catches them: reception, quoting, follow-up and retention, nothing dropped',
          l1n: 'Inquiry Reception',
          l1d: '24/7 multilingual instant replies — inquiries at midnight and across time zones never missed',
          l2n: 'Instant Quoting',
          l2d: 'AI generates a precise, professional quote in 3 seconds — no more manual price lookups',
          l3n: 'Automated Follow-up',
          l3d: 'SOP-driven follow-ups run while you sleep, with timely touchpoints across the decision window',
          l4n: 'Customer Retention',
          l4d: 'Every contact settles into the company system — customer assets survive staff turnover',
          ledgerTitle: 'Single-store Ledger — Is It Worth It? Do the Math',
          ledgerSub: 'Conservative estimate based on a wholesale stall with ¥1.5M annual revenue at a 15% net margin',
          b1n: '+¥120K',
          b1d: 'Night & time-zone inquiries captured (annual revenue gain)',
          b2n: '+¥150K',
          b2d: 'Expansion to 30+ language customers (~10% revenue growth)',
          b3n: '+¥45K',
          b3d: 'Systematic customer records lift repurchase from 20% to 25%',
          b4n: '≈¥47K',
          b4d: 'Total annual profit gain; first-year investment under ¥20K, payback in ~5 months',
          ledgerNote: 'Basis: revenue gains estimated forward, then converted to profit at a flat 15% net margin to avoid double counting; an extra ¥80-150K/year in content and staffing savings is not included. Three flexible pricing options: hardware buyout (under ¥20K, ¥3-5K annual O&M from year two) / managed subscription (¥999/mo) / pay-for-results (billed by valid inquiries and live-stream hours) — 7-day free trial, pay only after you see results.',
          st1a: 'Acceptance: target markets and core scenarios confirmed; product and pricing materials ready',
          st2a: 'Acceptance: knowledge-base answers accurate; quotes generated in seconds without errors',
          st3a: 'Acceptance: WhatsApp and other channels connected end to end, multilingual translation verified',
          st4a: 'Acceptance: 24/7 automated reception runs stably; lead capture and conversion data reviewable',
        },
        cta: {
          title: 'Not sure which solution fits you?',
          desc: 'Book a one-on-one demo — our solution experts will tailor a digital-transformation path for your industry and business scenarios.',
          btn1: 'Book a Demo',
          btn2: 'Try for Free',
        },
      },
      caseCenter: {
        banner: {
          label: 'CASES',
          title: 'Benchmark Customer Cases',
          sub: 'Serving 50+ benchmark clients across tourism, retail, finance, education, government-enterprise and media, covering every digital human scenario',
          btn1: 'Book a Demo',
          btn2: 'Try for Free',
          metricsLabel: 'KEY METRICS',
          m1n: '50+',
          m1t: 'Benchmark Clients',
          m1d: 'Tourism, retail, finance, education, gov-enterprise & media',
          m2n: '8',
          m2t: 'Industries Covered',
          m2d: 'Museums, government, retail, education and more',
          m3n: '6',
          m3t: 'Scenarios Live',
          m3d: 'Guiding, customer service, marketing & teaching',
          m4n: '99%',
          m4t: 'Client Satisfaction',
          m4d: 'Delivery quality & ops assurance',
          tagsLabel: 'INDUSTRIES',
          t1: 'Tourism & Museums',
          t2: 'City Culture',
          t3: 'Rail Transit',
          t4: 'Sports Venues',
          t5: 'Smart Education',
          t6: 'Publishing & Media',
          t7: 'Finance & Banking',
          t8: 'Retail Stores',
          g1: 'End-to-end delivery support',
          g2: '7×24 ops response',
          g3: 'Private deployment ready',
          g4: 'Measurable, auditable results'
        },
        cases: {
          c1tag: 'Retail Store',
          c1n: 'A Home Retail Chain',
          c1s: 'Digital store manager: chibi digital human in the corporate showroom for product narration and Q&A, reinventing in-store reception',
          c1v1: '8%-30%',
          c1l1: 'Revenue growth range',
          c2tag: 'Tourism · Museum',
          c2n: 'Du Fu Thatched Cottage Museum',
          c2s: 'Li Bai and Du Fu digital humans with interactive multilingual poetry narration, bringing the poets to life in the hall',
          c2v1: '+60%',
          c2l1: 'Visitor dwell time',
          c3tag: 'City Culture',
          c3n: 'Datong · Mulan Culture',
          c3s: 'Mulan digital human as city culture ambassador with interactive historical narration — a new city culture icon',
          c3v1: '+40%',
          c3l1: 'Visitor check-in rate',
          c4tag: 'Rail Transit',
          c4n: 'A Metro · Smart Customer Service',
          c4s: 'Transit digital employee: smart guidance + tourism promotion + multilingual service + work-order routing across every channel',
          c4v1: '65%+',
          c4l1: 'Station inquiries diverted',
          c4v2: '90%+',
          c4l2: 'Faster response for foreign visitors',
          c5tag: 'Sports Venue',
          c5n: 'Beijing Workers\' Stadium',
          c5s: 'Smart venue guidance with interactive event information queries, built for event-day peak crowds',
          c5v1: '50K+',
          c5l1: 'Spectators served per event day',
          c6tag: 'Smart Education',
          c6n: 'Kelihua Middle School · Shaoyang University',
          c6s: 'Historical-figure digital humans in classrooms and university showrooms — AI-integrated teaching in two scenarios',
          c6v1: '3-Year',
          c6l1: 'University partnership program',
          c6v2: 'Model',
          c6l2: 'Smart-campus demonstration project',
          c7tag: 'Culture · Publishing',
          c7n: 'Zhonghua Book Company · A National Cultural Publishing Institution',
          c7s: '15 Chinese sage digital humans + OCR-based ancient-book restoration system',
          c7v1: '5,000+',
          c7l1: 'On-site event interactions',
          c7v2: '1M+',
          c7l2: 'Social-media reach',
          c8tag: 'Finance · Banking',
          c8n: 'A Financial Industry Leader',
          c8s: 'Digital employee: exhibition docent at the CISCE booth, covering supply-chain finance, cross-border services, digital and green finance in CN/EN/FR/RU',
          c8v1: '7,400',
          c8l1: 'Peak daily conversations during the expo',
          c9tag: 'Tourism · Museum',
          c9n: 'Aihui History Museum · Sabusu',
          c9s: 'General Sabusu digital human narration with interactive historical Q&A for an immersive visit',
          c9v1: 'First',
          c9l1: 'Digital docent of Aihui\'s historical figure'
        },
        logos: {
          label: 'TRUSTED BY INDUSTRY LEADERS',
          titlePre: 'The shared choice of',
          titleAccent: '50+',
          titlePost: 'benchmark clients',
          l1n: 'A Financial Industry Leader',
          l1i: 'Finance · Banking',
          l2n: 'Du Fu Thatched Cottage Museum',
          l2i: 'Tourism · Museum',
          l3n: 'A Rail Transit Leader',
          l3i: 'Transit · Rail',
          l4n: 'Zhonghua Book Company',
          l4i: 'Culture · Publishing',
          l5n: 'Datong · Mulan Culture',
          l5i: 'Tourism · History',
          l6n: 'Huizhou · Dongpo Culture',
          l6i: 'Tourism · Historical Figure',
          l7n: 'Beijing Workers\' Stadium',
          l7i: 'Sports · Venue',
          l8n: 'Kelihua Middle School',
          l8i: 'Education · Middle School',
          l9n: 'Shaoyang University',
          l9i: 'Education · University',
          l10n: 'Aihui History Museum · Sabusu',
          l10i: 'Tourism · History'
        },
        cta: {
          title: 'Give Your Brand an Exclusive Digital Human',
          desc: 'From avatar design and knowledge bases to on-site deployment, we deliver ready-to-use digital human solutions end to end — your brand could be the next benchmark case.',
          btn1: 'Book a Demo',
          btn2: 'Try for Free'
        }
      },
      techCenter: {
        banner: {
          label: 'TECHNOLOGY',
          titlePre: 'Full-Stack Self-Developed',
          titleAccent: 'Technology Foundation',
          desc: 'LLM + Agent + Serverless — full-chain technical capabilities from perception to decision to execution, building a solid technology foundation for enterprise-grade AI applications.',
          demo: 'Book a Demo',
          trial: 'Try for Free',
          imageAlt: 'Galaxy Future full-stack technology architecture'
        },
        chain: {
          label: 'TECH CHAIN',
          title: 'Full-Chain Technology Pipeline',
          sub: 'From voice perception to intelligent decision-making to avatar execution — five tightly connected stages powering natural, fluid human-machine interaction.',
          f1t: 'Speech Recognition ASR',
          f1d: 'Accurate multi-language and multi-dialect recognition',
          f2t: 'Semantic Understanding NLU',
          f2d: 'Intent recognition, multi-turn dialogue management',
          f3t: 'Intelligent Decision-Making',
          f3d: 'LLM reasoning, multi-agent collaboration',
          f4t: 'Speech Synthesis TTS',
          f4d: 'Emotional voice expression',
          f5t: 'Avatar Driving',
          f5d: '2D / 3D / chibi-style rendering',
          m1v: 'Low Latency',
          m1l: 'Interaction response speed',
          m2v: '50+',
          m2l: 'Concurrent dialogue channels',
          m3v: '2K',
          m3l: 'Ultra-HD realistic rendering'
        },
        platform: {
          label: 'PLATFORM',
          title: 'Three Core Platform Capabilities',
          sub: 'A platform-based technology foundation that makes enterprise AI delivery more secure, more business-aware and more brand-distinctive.',
          pf1n: 'PLATFORM 01',
          pf1t: 'Secure Private Deployment',
          pf1d: 'Supports both on-premise and cloud deployment, with configurable data isolation and permission management to keep enterprise data assets safe.',
          pf2n: 'PLATFORM 02',
          pf2t: 'Business-Aware Intelligence',
          pf2d: 'Integrates multiple domestic LLMs with RAG-enhanced enterprise knowledge bases, deeply understanding industry scenarios to deliver ready-to-use business outcomes.',
          pf3n: 'PLATFORM 03',
          pf3t: 'Exclusive Brand IP',
          pf3d: 'High-fidelity 3D and 2.5D human-grade digital avatars with self-developed lip-sync technology — build once and publish to every terminal.'
        },
        core: {
          label: 'CORE TECHNOLOGY',
          title: 'Five Core Technologies',
          sub: 'A full-stack self-developed technology system covering models, compute, operations, cost and ecosystem — supporting enterprise AI adoption at scale.',
          c1t: 'LLM + Agent',
          c1d: 'On-demand agent orchestration with automatic decomposition and collaborative execution of complex tasks, plus multi-source cross-validation for reliable results.',
          c2t: 'Serverless',
          c2d: 'Elastic scaling, pay-as-you-go pricing and second-level capacity expansion, letting enterprises focus on business innovation instead of infrastructure.',
          c3t: 'Intelligent Operations',
          c3d: 'AIOps fault prediction and self-healing with full-link observability, keeping systems stable around the clock.',
          c4t: 'FinOps',
          c4d: 'Cost visualization and optimization recommendations that continuously improve resource utilization, ensuring every unit of compute pays off.',
          c5t: 'AI App Market',
          c5d: 'A ready-to-use ecosystem of industry agent applications that accelerates enterprise AI adoption at scale.'
        },
        patents: {
          label: 'QUALIFICATIONS',
          title: 'Patents & Qualifications',
          sub: 'All core technologies are self-developed, backed by national invention patents and multiple software copyrights — a complete IP system.',
          patentn: '6',
          patentt: 'National Invention Patents Granted',
          patentd: 'Covering core cloud-native and AI infrastructure domains such as resource scheduling, performance stress testing and cross-cloud data transfer.',
          patenti1: 'Precise Measurement',
          patenti2: 'Compute Sharing Pool',
          patenti3: 'Rapid Specification Stress Testing',
          patenti4: 'Rapid Traffic Stress Testing',
          patenti5: 'Cross-Cloud Data Logistics',
          softn: '8',
          softt: 'Software Copyrights',
          softd: 'Software copyrights for proprietary platforms and core engines, building a complete product IP moat.',
          softi1: 'AIPilot LLM Application Platform',
          softi2: 'InfraPilot Serverless Platform',
          softi3: 'Data Logistics Engine'
        },
        security: {
          label: 'SECURITY',
          title: 'Information Security System',
          sub: 'From compliance certification to encryption algorithms, from data boundaries to access control — an enterprise-grade security line of defense.',
          s1t: 'Classified Protection Level 3',
          s1d: 'Certified to China\'s national MLPS Level 3 standard',
          s2t: 'SM Cryptographic Encryption',
          s2d: 'End-to-end encryption with national cryptographic algorithms',
          s3t: 'Data Stays In-Domain',
          s3d: 'Private deployment keeps data inside the enterprise network',
          s4t: 'Tenant Isolation & Permissions',
          s4d: 'Multi-tenant data isolation with fine-grained access control'
        },
        cta: {
          bannerTitle: 'Empower Your Business with Full-Stack Technology',
          bannerDesc: 'Whether on-premise or in the cloud, we deliver a secure, stable and scalable AI technology foundation. Book a demo to learn more.',
          bannerBtn1: 'Book a Demo',
          bannerBtn2: 'Try for Free'
        }
      },
      aboutCenter: {
        banner: {
          label: 'ABOUT US',
          title: 'About Galaxy Future',
          sub: 'Focused on AI digital human technology — empowering every enterprise with its own digital workforce.'
        },
        intro: {
          label: 'COMPANY PROFILE',
          title: 'Bringing AI into Real Enterprise Business Scenarios',
          p1: 'Galaxy Future is a technology company focused on enterprise-grade solutions including AI digital humans, digital employees and digital-human tour guides. By combining leading domestic LLMs with a multi-agent architecture, we are committed to bringing AI technology into real enterprise business scenarios.',
          p2: 'Our core team comes from leading internet companies and AI labs. We have served 50+ benchmark clients across culture & tourism, retail, finance, education and government & enterprise sectors, earning long-term trust through reliable delivery.',
          indTitle: 'INDUSTRIES SERVED',
          ind1: 'Culture & Tourism',
          ind2: 'Retail',
          ind3: 'Finance',
          ind4: 'Education',
          ind5: 'Government & Enterprise',
          imgAlt: 'Galaxy Future AI digital human'
        },
        structure: {
          label: 'DUAL ENTITY',
          title: 'Dual-Entity Synergy',
          sub: 'Technology R&D and commercialization drive each other — ensuring continuous innovation of the underlying technology as well as high-quality project delivery and long-term operation.',
          s1tag: 'TECHNOLOGY R&D ENTITY',
          s1name: 'Galaxy Future',
          s1desc: 'Focused on fundamental AI digital human research and product innovation, building core technology barriers.',
          s1i1: 'AI digital human core technology',
          s1i2: 'LLM R&D and integration',
          s1i3: 'AR interaction technology',
          s2tag: 'COMMERCIALIZATION ENTITY',
          s2name: 'Galaxy Nongchao',
          s2desc: 'Commercialization for government and enterprise clients, covering the full cycle from business development to long-term operation.',
          s2i1: 'Government & enterprise client expansion',
          s2i2: 'Project delivery and implementation',
          s2i3: 'Operation and service support'
        },
        history: {
          label: 'MILESTONES',
          title: 'Our Journey',
          sub: 'From education to culture & tourism, and on to digital human productization — Galaxy Future keeps evolving.',
          y1: '2024',
          y1t: 'Starting in Education',
          y1d: 'Started in education scenarios, launched AI digital-human teaching assistants and interactive learning applications, validating the product prototype and market fit.',
          y2: '2025',
          y2t: 'Deepening in Culture & Museums',
          y2d: 'Deepened our presence in culture, museum and tourism scenarios, delivering benchmark digital-human guide and AR interaction projects while building industry know-how and delivery methodology.',
          y3: '2026',
          y3t: 'Digital Human Productization',
          y3d: 'Launched standardized digital human SaaS products and a scenario-based solution matrix, starting enterprise-grade delivery at scale.'
        },
        stats: {
          s1v: '500+',
          s1l: 'Digital human character library',
          s2v: '90%+',
          s2l: 'Production cost reduction',
          s3v: '50+',
          s3l: 'Benchmark clients',
          s4v: '6',
          s4l: 'Invention patents'
        },
        team: {
          label: 'CORE TEAM',
          title: 'A Core Team from Leading Internet Companies',
          desc: 'Our core team comes from leading internet companies and AI labs such as Weibo and ByteDance, with deep expertise in both technology R&D and large-scale commercialization. We understand technology — and real enterprise business.',
          srcTitle: 'TEAM BACKGROUNDS',
          src1: 'Weibo',
          src2: 'ByteDance',
          src3: 'Leading AI Labs',
          capTitle: 'Core Capability Matrix',
          cap1: '3D digital human modeling & driving',
          cap2: 'AI LLM R&D and integration',
          cap3: 'AR spatial interaction',
          cap4: 'SaaS system development',
          cap5: 'Commercialization and operation'
        },
        ip: {
          label: 'INTELLECTUAL PROPERTY',
          title: 'Intellectual Property & Qualifications',
          sub: 'Fully self-developed core technology with a complete IP system — a solid foundation for enterprise-grade partnerships.',
          i1n: '6',
          i1t: 'National Invention Patents',
          i1d: 'Covering core technologies in digital human generation, driving and interaction.',
          i2n: '8',
          i2t: 'Software Copyrights',
          i2d: 'Covering the digital human SaaS platform and scenario-based product matrix.',
          i3n: 'End-to-End',
          i3t: 'Data Security Assurance',
          i3d: 'Private deployment and data isolation supported, safeguarding enterprise data assets across the full chain.'
        },
        office: {
          label: 'OFFICES',
          title: 'Our Offices',
          sub: 'Based in Beijing and Hangzhou — close to our clients, quick to respond.',
          o1tag: 'BEIJING HQ',
          o1name: 'Wangjing CapitaMall',
          o1d: 'Group headquarters, housing core R&D, product design and operations management.',
          o2tag: 'HANGZHOU BRANCH',
          o2name: 'Huanglong Future Center',
          o2d: 'East China regional center, housing project delivery, client service and ecosystem partnership functions.'
        },
        contact: {
          label: 'CONTACT US',
          title: 'Get in Touch',
          phoneLabel: 'BUSINESS PHONE',
          emailLabel: 'BUSINESS EMAIL',
          addrLabel: 'ADDRESS',
          addr: 'Room 903, CapitaMall Wangjing, Beijing',
          trialTitle: 'Free SaaS Trial',
          trialDesc: 'The digital human SaaS version is now open for free trial — register to experience digital human creation, knowledge base configuration and multi-terminal publishing end to end.',
          demo: 'Book a Demo',
          trial: 'Try for Free'
        }
      },
      menu: {
        home: 'Home',
        products: 'Products',
        productsOverview: 'Product Center',
        cases: 'Customer Cases',
        tech: 'Technology',
        techArch: 'Digital Human Architecture',
        resources: 'Knowledge',
        contact: 'Contact Us',
        interactiveDigitalHumanSaaS: 'Interactive Digital Human Platform (SaaS)',
        interactiveDigitalHumanPrivate: 'Interactive Digital Human Platform (On-Premise)',
        aiPlatform: 'AI Application Platform AIPilot',
        aiHostingPlatform: 'AI Hosting Platform InfraPilot',
        saasServices: 'SaaS Services',
        aiDigitalHuman: 'AI Interactive Digital Human',
        aiAppMarket: 'AI Application Marketplace',
        solutions: 'Solutions',
        solutionsOverview: 'Solutions Overview',
        solutionRetail: 'Digital Store Manager · Retail Chains',
        solutionGovernment: 'Digital Employee · Gov & SOE',
        solutionMuseum: 'Digital Docent · Museums & Venues',
        solutionMerchant: 'Digital Owner · SMB',
        productTerminal: 'Smart Terminal · Xiaoxing Box',
        operationTrusteeship: 'Operation Trusteeship',
        costOptimization: 'Cost Optimization',
        documentation: 'Documentation',
        productManual: 'Product Manual',
        schedulxManual: 'SchedulX Product Manual (PDF)',
        aiPlatformManual: 'AI Application Platform AIPilot Manual',
        aiHostingPlatformManual: 'AI Hosting Platform InfraPilot Manual',
        aiDigitalHumanManual: 'Mimi Box Product Manual',
        whitepapers: 'White Papers',
        serverlessWhitepaper: 'Serverless White Paper',
        costOptimizationWhitepaper: 'IT Cost Optimization White Paper',
        devOpsWhitepaper: 'Operations Solutions White Paper',
        hybridDeploymentWhitepaper: 'Hybrid On/Off-Premise Deployment White Paper',
        about: 'About Us',
        companyProfile: 'Company Profile',
        news: 'Latest News'
        ,
        personal: 'Personal Edition',
        more: 'More',
        minijump: 'MiniJump'
      },
      menuDesc: {
        productsOverview: 'Overview of six foundational products',
        solutionsOverview: 'Overview of four industry solutions',
        solutionRetail: 'A gold-medal store manager that never goes offline',
        solutionGovernment: 'Standardized, auditable digital workforce',
        solutionMuseum: 'Tell cultural stories with exclusive IP',
        solutionMerchant: 'One agent for inquiries, quotes and follow-up',
        productTerminal: 'Pocket-sized AI digital human device',
        interactiveDigitalHumanSaaS: 'SaaS subscription, ready to use',
        interactiveDigitalHumanPrivate: 'On-premise, data stays in-domain',
        personal: 'Mimi Box holographic digital human',
        techArch: 'Self-developed technology foundation',
        aiDigitalHuman: 'Try the AI digital human online',
        aiAppMarket: 'Ready-to-use industry agents',
        aiPlatform: 'LLM application platform',
        aiHostingPlatform: 'Serverless hosting platform',
        operationTrusteeship: 'AIOps managed operations',
        costOptimization: 'FinOps cost optimization',
        schedulxManual: 'Product manual PDF download',
        aiDigitalHumanManual: 'Mimi Box user manual',
        aiPlatformManual: 'AIPilot platform manual',
        aiHostingPlatformManual: 'InfraPilot platform manual',
        serverlessWhitepaper: 'Serverless white paper',
        costOptimizationWhitepaper: 'IT cost optimization white paper',
        devOpsWhitepaper: 'DevOps solution white paper',
        hybridDeploymentWhitepaper: 'Hybrid deployment white paper',
        companyProfile: 'About the company and team',
        news: 'Latest news and updates'
      },
      productAidigitalHuman: {
        title: 'Galaxy-Future │ AI Interactive Digital Human Platform',
        titleNext: 'Next-Gen AI Digital Human Platform',
        subtitle1: 'Galaxy Future leverages patented technologies to enable the end-to-end lifecycle of AI digital humans — from creation and operation to commercialization — transforming them into instantly reusable, scalable digital assets.',
        subtitle1Next: 'Real-time voice · Low-cost IP · Multi-scenario AI',
        description1: ``,
        description1Next: 'galaxy-future AI digital humans feature multi-modal interaction (voice/text/image), affordable high-fidelity IP creation, and multi-device compatibility. Empowering smart upgrades for IP management, cultural tourism, education, and diverse scenarios.',
        freeTrial: 'Start Free (SaaS)',
        downloadEnterprise: 'Download Enterprise Edition',
        downloadPersonal: 'Download Personal Edition',
        downloadCloud: 'Download Cloud Edition',
        contactUs: 'Get in Touch',
        jumpToPersonal: 'Personal Edition Website',
      },
      homeAnchor: {
        coreProducts: 'Core Products',
        highlightFeatures: 'Highlight Features',
        patentTech: 'Patented Technologies',
        commercialSolutions: 'Commercial Solutions'
      },
      homeCore: {
        digitalHumanTitle: 'AI Interactive Digital Human Platform',
        digitalHumanSubtitle: 'Providing high-fidelity, tailored AI digital humans',
        digitalHumanText: `Supports intelligent dialogue, emotion recognition, and multi-modal interaction.  
Perfect for exhibitions, marketing, guided explanations, education, and more – proven to effectively boost user experience and engagement.  
AI digital humans are not just visual and behavioral innovation, but high-efficiency productivity tools.`,
        learnMore: 'Learn More',
        aiPlatformTitle: 'AI Application Platform',
        aiPlatformSubtitle: 'Provides complete development toolchain and open APIs',
        aiPlatformText: 'Enables rapid building and deployment of AI-driven applications. Supports flexible integration and secondary development, helping enterprises efficiently implement customized AI solutions.'
      },
      homeHighlight: {
        title: 'Core Advantages',
        ipOperation: 'Full-Scenario Digital Human IP Operations',
        ipOperationList: [
          'One digital human system seamlessly applied across customer service, live streaming, marketing, and more',
          'High reusability and cross-industry adaptability',
          'End-to-end service from character design to operations'
        ],
        completeFeatures: 'Comprehensive Functionality',
        completeFeaturesList: [
          'Supports speech recognition, emotional expression, and multi-turn dialogues',
          'Highly customizable agent development platform',
          'Supports multiple interaction modes and business logic',
          'Full-stack technical capabilities from speech recognition to emotion computing'
        ],
        richExpressions: 'Rich Expressions & Movements',
        richExpressionsList: [
          'Natural movements: blinking, nodding, gestures',
          'Hundreds of preset motion libraries',
          'Customizable expressions and body language for lifelike interactions',
          'Extensive pre-designed character library with personalization options'
        ],
        powerfulPlatform: 'Powerful Agent Platform',
        powerfulPlatformList: [
          'Highly customizable and extensible with advanced intelligence',
          'Supports multi-model and API integrations, custom agents',
          'Adaptable to multiple scenarios with easy upgrades'
        ],
        fastDelivery: 'Rapid Delivery',
        fastDeliveryList: [
          'Standardized processes and comprehensive admin dashboard',
          'Project delivery cycles can be shortened to days'
        ],
        selfService: 'Self-Service Capability',
        selfServiceList: [
          'Self-managed and independently configurable with visual tools',
          'Non-technical users can easily handle daily operations',
          'User-managed and maintain systems autonomously, reducing operational costs'
        ],
        easyExpansion: 'Easy Expansion',
        easyExpansionList: [
          'Modular design supports flexible scaling',
          'Meets diverse scenario requirements'
        ],
        costEffective: 'Cost-Effective',
        costEffectiveList: [
          'Annual service starting from a few thousand USD',
          'Affordable AI digital humans for all industries',
          'Flexible service models for cost-effective AI solutions'
        ],
        patentedTech: 'Based on Patented Technology',
        patentedTechList: [
          'Backed by six national invention patents',
          'Guaranteed technological leadership'
        ],
        freeTrial: 'Start Free (SaaS)',
        downloadEnterprise: 'Download Enterprise Edition',
        downloadPersonal: 'Download Personal Edition',
        downloadCloud: 'Download Cloud Edition',
        contactUs: 'Get in Touch'
      },
      homePlan: {
        title: 'Patented Technical Capabilities',
        preciseMeasurement: 'Precise Measurement',
        computingPool: 'Compute Resource Pooling',
        rapidBenchmark: 'Rapid Specification Benchmarking',
        trafficTesting: 'Rapid Traffic Load Testing',
        crossCloudData: 'Cross-Cloud Data Logistics',
        preciseMeasurementText: [
          'Extract business decision metrics',
          'Real-time precise measurement',
          'Enhance ease of adjusting computing resources',
          'Reduce computing resource usage costs'
        ],
        computingPoolText: [
          'Hybrid on/off-premise deployment',
          'Dynamic scheduling of service clusters',
          'Improve cluster resource utilization'
        ],
        rapidBenchmarkText: [
          'Quickly identify optimal target servers for performance matching',
          'Improve software runtime efficiency',
          'Reduce server costs'
        ],
        trafficTestingText: [
          'Test server clusters using live production traffic',
          'High-accuracy test results',
          'Reduce load testing cycle from months to under a week'
        ],
        crossCloudDataText: [
          'Massive public network data transfer',
          '10TB in 10 minutes',
          'Lower data migration costs'
        ]
      },
      homeCase: {
        case_title: "Commercial Solutions",
        case_title_1: "Digital IP Operation Service",
        case_1_1: "For: Culture & Tourism, Brands, MCNs",
        case_1_2: "Fully managed digital-human IP operations: from character positioning and content strategy to monetization—compound your IP value exponentially.",
        case_1_3: "Worldview & storyline design",
        case_1_4: "Managed service support",
        case_1_5: "Professional operation guidance",
        case_1_6: "Subscription-based revenue",
        case_btn_1: "Free Trial",

        case_title_2: "SaaS Subscription Service",
        case_2_1: "Target Users: Enterprises, SMEs",
        case_2_2: "SaaS subscription model (Basic / Professional / Enterprise)",
        case_2_3: "Flexible monthly/annual billing options",
        case_2_4: "Customized Service Packages",
        case_btn_2: "Schedule Consultation",

        case_title_3: "Channel Partner Program",
        case_3_1: "For: Tech providers, Content operators, Resellers",
        case_3_2: "Channel partners can set pricing and share technical profits.",
        case_3_3: "More engagement, more discounts",
        case_btn_3: "Try Now",
      },
      homePartners: {
        title: 'Strategic Partners',
        subtitle: 'Collaborating with industry-leading companies to co-create the future of AI digital humans',
        partners: {
          dtkj: '谛听视界',
          yrzn: '匀熵智能'
        }
      },
      becomePartner: {
        title_1_1: 'Become a Channel Partner',
        subtitle_1_1: 'Join Our Partnership Program',
        description_1_1: 'Whether you’re a tech service provider, channel partner, or content operator, we welcome you to join us.',
        applyButton: 'Apply for Partnership Now',
        benefit_1_title: 'Exclusive Reseller Policies',
        benefit_2_title: 'Technical Training Support',
        benefit_3_title: 'Channel Discount System',
        benefit_4_title: 'Co-Branding Promotion'
      },
      footer: {
        businessConsult: 'Business Inquiry:',
        emailConsult: 'Email Inquiry:',
        address: 'Contact Address:',
        addressDetail: 'Room 903, CapitaMall Wangjing, Beijing',
        categories: {
          product: 'Products',
          saas: 'SaaS Services',
          solutions: 'Solutions',
          about: 'About Us'
        },
        links: {
          interactiveDigitalHumanSaaS: 'Interactive Digital Human Platform (SaaS)',
          interactiveDigitalHumanPrivate: 'Interactive Digital Human Platform (On-Premise)',
          aiPlatform: 'AI Application Platform AIPilot',
          aiHostingPlatform: 'AI Hosting Platform InfraPilot',
          aiDigitalHuman: 'AI Interactive Digital Human',
          aiAppMarket: 'AI Application Marketplace',
          operationTrusteeship: 'Operation Trusteeship',
          costOptimization: 'Cost Optimization',
          companyIntro: 'Company Introduction',
          contactUs: 'Contact Us',
          joinUs: 'Join Us'
        },
        qr: {
          businessConsult: 'Business Inquiry',
          videoChannel: 'WeChat Video Account',
          miniProgram: 'WeChat Mini Program'
        },
        social: {
          weibo: 'Galaxy Future Official Weibo',
          zhihu: 'Galaxy Future Official Zhihu',
          bilibili: 'Galaxy Future Official Bilibili',
          github: 'Galaxy Future GitHub',
          gitee: 'Galaxy Future Gitee'
        }
      },
      nav: {
        register: 'Register',
        login: 'Login',
        loginRegister: 'Login / Register',
        freeTrial: 'Try Free',
        aiAppMarket: 'AI Application Marketplace',
        aiAppHosting: 'AI Application Hosting',
        backToV1: 'Back to Classic',
        logout: 'Logout'
      },
      upgrade: {
        guide: 'Quick Tip',
        guideTip: 'Click "Back to Classic" here anytime to return to the previous site.',
        guideKnow: 'Got It'
      },
      productAidigitalHumanRole: {
        featuredTitle: "Featured Digital Human Characters",
        human_1: "Li Bai",
        human_2: "Luna",
        human_3: "Wukong",
        human_4: "Qingning Sunny",
        animal_1: "Cat Huaying",
        animal_2: "Mengbao Dun",
        human_5: "Sun Simiao",
        human_6: "Confucius",
        human_7: "Chang’e",
        human_8: "Ruby",
        human_9: "Lin Xiyue",
        animal_3: "Duck Doudou",
        human_10: "Aelia Star Dream",
        human_11: "Gentong",
        human_12: "Neon Feather",
        human_13: "Crimson Flame",
        human_14: "Rainbow Flame"
      },
      coreFeatures: {
        title: 'Core Features',
        subtitle: 'Leading Architecture ▸ Ultimate Interaction Experience ▸ New Human-Machine Interaction Paradigm',
        feature1: {
          title: 'Real-Time Voice Dialogue',
          text1: 'Natural language conversation supporting multiple languages, dialects, multi-round dialogues, interruption handling, and multimodal interaction',
          text2: 'Hundreds of voice options for high-fidelity, real-time interaction'
        },
        feature2: {
          title: 'Low-Cost Digital Human Creation',
          text1: 'Reduces digital human creation cost by over 90%, offers hundreds of pre-set characters',
          text2: 'Supports 2K HD resolution and dozens of expressions/movements'
        },
        feature3: {
          title: 'Advanced AI Agent & Knowledge Base Support',
          text1: 'Supports complex intent recognition, dozens of interaction modes',
          text2: 'Supports RAG + web search + custom knowledge base, memory retention, and multi-round conversations'
        }
      },
      verticalIP: {
        title: 'Vertical IP Operations',
        subtitle: 'Focus on vertical scenarios to build sustainable, commercializable digital IP portfolios',
        subtitle2: 'Diverse Customization × Strong Expression × High Efficiency & Low Cost = Sustainable Growth Super Digital Assets',
        feature1: {
          title: '2D/3D Digital Human Creation',
          text1: 'Multiple styles: realistic, cartoon, anime — fully customizable',
          text2: 'Professional support: character design, voice cloning, custom knowledge base',
          text3: 'Applications: vertical IPs, virtual avatars, mascots'
        },
        feature2: {
          title: 'Rich Movements & Expressions',
          text1: 'Seamless synchronization: facial expressions, gestures, body movements',
          text2: 'Vast motion library + micro-expression customization',
          text3: 'Talents galore: poetry, singing, dancing, costume changes'
        },
        feature3: {
          title: 'Low-Cost Efficient Operations',
          text1: 'One-stop service: digital human interaction, content operations, monetization',
          text2: 'Lower barriers: empower all industries with lightweight operations',
          text3: 'Professional support: content creation, event planning, operational training'
        }
      },
      intelligentInteraction: {
        title: 'Intelligent Agent Interaction',
        subtitle1: '“Make AI Conversations Warm: Custom Knowledge Base × Fun Interactions × Open Platform”',
        subtitle2: '“All-Round AI Companion: Learns • Jokes • Evolves”',
        subtitle3: '“Education Quests × Marketing Engagement × Cultural Heritage: One Platform Activates All Scenarios”',
        feature1: {
          title: 'Productized, User-Friendly Knowledge Base',
          text1: 'Supports custom knowledge bases, knowledge base whitelists',
          text2: 'Supports role-based and team-based knowledge bases',
          text3: 'Hundreds of voice options for high-fidelity real-time interaction'
        },
        feature2: {
          title: 'Diverse Interaction Modes',
          text1: 'Live streaming / surveys / quests / poetic games / idiom challenges / teaching modes',
          text2: 'Supports culture, marketing, education, and other scenarios'
        },
        feature3: {
          title: 'Flexible & Extensible Agent Platform',
          text1: 'Supports multi-model/API integration, custom agents',
          text2: 'Adaptable to multiple scenarios with easy upgrades'
        }
      },
      verticalSolutions: {
        title: 'Vertical Industry Solutions',
        subtitle: 'Deeply tailored to various industry scenarios, providing professional solutions',
        features: {
          business: {
            title: 'Commerce',
            text1: 'Live-stream selling, 24/7 virtual in-store hosts',
            text2: 'Hundreds of IPs available as hosts'
          },
          education: {
            title: 'Education',
            text1: 'AI interactive experiences, campus Q&A, AI tutors, virtual lecturers, interactive classrooms',
            text2: 'Makes learning more engaging and efficient'
          },
          cultureMuseum: {
            title: 'Culture & Museums',
            text1: 'Historical figure revival, artifact animation, digital guides',
            text2: 'Brings cultural heritage to life with immersive experiences'
          },
          cultureTravel: {
            title: 'Cultural Tourism',
            text1: 'Cultural IP ambassadors, scenic area guides, holographic immersive experiences',
            text2: 'Enhances visitor experience and promotes regional culture'
          },
          exhibition: {
            title: 'Exhibitions',
            text1: 'Smart guides and interactive experiences for museums, science centers, exhibition halls',
            text2: 'Creates high-tech, futuristic display spaces'
          },
          companionship: {
            title: 'Companionship',
            text1: 'Family companionship, emotional interaction, elderly care, children’s education partners',
            text2: 'Provides warm, empathetic AI companionship'
          }
        },
        buttons: {
          freeTrial: 'Start Free (SaaS)',
          downloadEnterprise: 'Download Enterprise Edition',
          downloadPersonal: 'Download Personal Edition',
          downloadCloud: 'Download Cloud Edition',
          contactUs: 'Get in Touch'
        }
      },
      featuredCases: {
        title: 'Flagship Client Cases',
        list_title_1: 'Datong Mulan Digital Human',
        list_description_1: 'Bring historical figures to life, empowering IP creation that resonates emotionally',
        list_sub_title_1: 'Cultural Tourism Promotion',
        list_sub_content_1: 'Combines online promotion with offline景区互动 (scenic area interaction) — digital human tours, cultural storytelling, photo interactions — enhancing cultural tourism outreach.',

        list_title_2: 'Campus Digital Human',
        list_description_2: 'Empower new educational scenarios with AI digital humans — integrating campus governance and teaching assistance',
        list_sub_title_2: 'Campus Applications',
        list_sub_content_2: 'Campus announcements, student Q&A, moral education lectures — improving campus management efficiency and interactivity.',

        list_title_3: 'Workers’ Stadium Grillo',
        list_description_3: 'Stadium mascot digital human — boosting promotions and answering match questions',
        list_sub_title_3: 'Event Services',
        list_sub_content_3: 'Real-time match updates and interactive Q&A — enhancing fan engagement and intelligent experience.',

        list_title_4: 'Aihui Historical Exhibition Hall',
        list_description_4: 'Digital guide for historical/cultural exhibitions',
        list_sub_title_4: 'Museum Guiding',
        list_sub_content_4: 'Multilingual artifact explanations and historical reenactments — interactive guided tours and educational experiences — enhancing cultural dissemination and visitor immersion.',

        list_title_5: 'Lingnan Dongpo Digital Human',
        list_description_5: 'Reviving historical figures to empower cultural attractions',
        list_sub_title_5: 'Cultural Promotion',
        list_sub_content_5: 'Promotes Lingnan culture through local events, explaining Su Dongpo and Lingnan culture — aiding local brand building.'
      },
      interactiveDevices: {
        title: 'Support for Diverse Interactive Devices',
        subtitle: 'Full-scenario coverage to meet high-end digital human needs across industries and settings',
        table: {
          productName: 'Product Name',
          productDescription: 'Product Description'
        },
        devices: {
          mobileScreen: {
            name: 'Companion Mobile Screen',
            description: 'Ideal for mobile companionship and guiding'
          },
          cabinetDigitalHuman: {
            name: 'Standalone Digital Human Kiosk',
            description: 'Upright integrated design'
          },
          holographicDigitalHuman: {
            name: 'Holographic Digital Human Kiosk',
            description: 'Bare-eye 3D holographic projection for futuristic interaction'
          },
          transparentScreen: {
            name: 'Transparent Screen Digital Human Kiosk',
            description: 'Transparent screen tech for futuristic experiences'
          },
          aiBuddhaShrine: {
            name: 'AI Buddha Shrine',
            description: 'Fusion of traditional culture + AI tech — customized for religious/blessing scenarios'
          },
          projectorSolution: {
            name: 'Projector Solution',
            description: 'Large-scale projection for immersive, large-format displays'
          },
          holographicFan: {
            name: 'Holographic Fan Solution',
            description: 'All-day, borderless, high-brightness display'
          }
        },
        buttons: {
          freeTrial: 'Start Free (SaaS)',
          downloadEnterprise: 'Download Enterprise Edition',
          downloadPersonal: 'Download Personal Edition',
          downloadCloud: 'Download Cloud Edition',
          contactUs: 'Get in Touch'
        }
      },
      productPrivateAidigitalHuman: {
        banner: {
          title_1_1: 'Enterprise-Grade Private Digital Human Deployment',
          text_1_1: 'Secure & Controllable',
          text_1_2: 'Deep Customization',
          text_1_3: 'Flexible Scalability',
          button_1_1: 'Get Solution Now',
          button_1_2: 'Schedule Technical Demo'
        }
      },
      productPrivateAidigitalHumanProduct: {
        feature: {
          advantage: {
            title_1_1: 'End-to-End Data Security',
            text_1_1: 'Encrypted storage via national encryption algorithms; GDPR/compliance with China’s Level 2 Protection Standards; data never leaves enterprise intranet',
            title_1_2: '100% Enterprise-Owned',
            text_1_2: 'Supports deep customization of appearance, knowledge base, and interaction logic; independent deployment of exclusive digital human system',
            title_1_3: 'Flexible Deployment Modes',
            text_1_3: 'Supports on-premise servers / private cloud / hybrid cloud deployments to meet varying enterprise needs'
          },
          framework: {
            title_2_1: 'Application Layer',
            text_2_1: 'Digital human interaction interface',
            title_2_2: 'Capability Layer',
            text_2_2: 'LLM + RAG + Agent Engine',
            title_2_3: 'Infrastructure Layer',
            text_2_3: 'Private deployment environment'
          },
          deploy: {
            title_3_1: 'Lightweight Edition',
            textArray_3_1_1: 'Single-server deployment',
            textArray_3_1_2: 'Supports 100 concurrent sessions',
            textArray_3_1_3: 'Ideal for SMEs',
            title_3_2: 'Enterprise Edition',
            textArray_3_2_1: 'Distributed cluster deployment',
            textArray_3_2_2: 'Supports tens of thousands of concurrent sessions',
            textArray_3_2_3: 'Ideal for large corporations',
            title_3_3: 'Hybrid Cloud Edition',
            textArray_3_3_1: 'Local + cloud collaboration',
            textArray_3_3_2: 'Elastic resource scaling',
            textArray_3_3_3: 'Ideal for multinational enterprises'
          }
        }
      },
      productContrast: {
        title: 'Private Deployment vs SaaS: Core Differences',
        columns: {
          function: 'Function Dimension',
          private: 'Private Deployment',
          saas: 'SaaS'
        },
        data: {
          function_1_1: 'Data Storage',
          private_1_1: 'Managed by enterprise',
          saas_1_1: 'Centrally stored in cloud',
          function_1_2: 'Customization Permissions',
          private_1_2: 'Source code level access',
          saas_1_2: 'Basic feature configuration',
          function_1_3: 'Response Speed',
          private_1_3: 'Millisecond response locally',
          saas_1_3: '1-3 second response via cloud',
          function_1_4: 'Compliance',
          private_1_4: 'Supports industry-specific certifications',
          saas_1_4: 'General compliance standards'
        }
      },
      product: {
        sectionTitles: {
          title_1_1: 'Core Advantages',
          title_1_2: 'Three-Layer Technical Architecture',
          title_1_3: 'Flexible Deployment Models'
        }
      },
      productAiPilotBanner: {
        title_1_1: 'Next-Gen Serverless-Powered',
        title_1_2: 'Galaxy Future AI Application Platform — AIPilot',
        description_1_1: 'Effortlessly manage the ever-growing landscape of AI applications and large models. AIPilot unifies scheduling of GPU/CPU resources across cloud and on-premise environments. Supporting large model inference, it integrates with 8+ major LLM providers’ APIs, enabling enterprises to rapidly, efficiently, and cost-effectively embed AI into diverse production scenarios. Leveraging patented technologies, AIPilot can deploy 20 popular AI applications on an 8-core 16GB laptop — allowing enterprises to build proprietary AI engines for as little as 10,000 RMB.',
        button_1_1: 'Deploy Free'
      },
      productAiPilotWorth: {
        title_1_1: 'Desktop-Grade Generative AI Application Platform',
        description_1_1: 'Offers rich, popular AI applications compatible with leading domestic LLMs, delivering plug-and-play convenience',
        button_1_1: 'Deploy Free',
        feature: {
          title_1_1: 'Curated AI Applications',
          text_1_1: 'The platform continuously updates with trending AI tools — knowledge base, smart customer service, BI analytics, icon design, PDF summarization — ready to install and use, instantly boosting team AI productivity.',
          title_1_2: 'Multi-Model Support',
          text_1_2: 'With one account, access various models from multiple LLM providers — text, multimodal, embedding models — choose the best-performing model for optimal results.',
          title_1_3: 'Multi-Environment Support',
          text_1_3: 'Install on personal computers, compatible with domestic innovation platforms and servers. Supports Windows, macOS, Linux.'
        }
      },
      productAiPilotFeatured: {
        title_1_1: 'Featured AI Applications',
        button_1_1: 'Deploy Free',
        category: {
          title_1_1: 'Writing Assistants',
          title_1_2: 'Academic & Education',
          title_1_3: 'Data Analysis',
          title_1_4: 'Knowledge Base Agents',
          title_1_5: 'Open-Source LLMs'
        },
        apps: {
          name_1_1: 'AlBot',
          text_1_1: 'Document assistant, Q&A',
          name_1_2: 'Novel',
          text_1_2: 'Notion-style writing assistant',
          name_1_3: 'WordFlow',
          text_1_3: 'Writing assistant, AI translation, AI prompts',
          name_1_4: 'AIAcademic',
          text_1_4: 'Academic paper writing assistant',
          name_1_5: 'AlTutor',
          text_1_5: 'All-in-one AI tutor, personalized course planning',
          name_1_6: 'yakGPT',
          text_1_6: 'Expert role-based Q&A',
          name_1_7: 'DBGPT',
          text_1_7: 'BI analysis tool directly connected to databases',
          name_1_8: 'ChartGPT',
          text_1_8: 'Text-to-chart generator',
          name_1_9: 'Dify',
          text_1_9: 'Build native AI applications easily',
          name_1_10: 'Baichuan-7B',
          text_1_10: 'Supports Chinese/English, 4096 context window',
          name_1_11: 'Llama2_7B',
          text_1_11: 'Meta’s large language model',
          name_1_12: 'DevOps-Model',
          text_1_12: 'DevOps lifecycle Q&A'
        },

      },
      productAiPilotPrice: {
        title_1_1: 'AIPilot Product Pricing',
        about: 'Approx.',
        discount: 'Discount',
        freeDeployment: 'Free Deployment',
        note_1_1: 'Note: Managed version pricing based on actual cloud server rates',
        plans: {
          title_1_1: 'Single-Machine Deployment',
          title_1_2: 'Cluster Deployment',
          title_1_3: 'Domestic Innovation Appliance',
          title_1_4: 'Single-Machine Managed',
          title_1_5: 'Cluster Managed'
        },
        features: {
          license: 'License',
          permanentUpgrade: 'Permanent Upgrades',
          users: 'Users',
          users_1_1: '3',
          users_1_2: '100',
          apps: 'Apps',
          apps_1_1: '10',
          apps_1_2: '50',
          models: 'LLM Integrations',
          models_1_1: '9',
          models_1_2: '9',
          cpu: 'CPU Specs',
          cpu_1_1: '8 Cores',
          cpu_1_2: '8 Cores',
          cpu_1_3: '8 Cores*3',
          memory: 'Memory',
          memory_1_1: '16GB',
          memory_1_2: '16GB',
          memory_1_3: '16GB*3',
          storage: 'Storage',
          storage_1_1: '500G',
          storage_1_2: '500G',
          storage_1_3: '500G*3',
          software: 'AIPilot Software Standalone Edition',
          software_1_1: '',
          network: 'Network',
          network_1_1: '5Mbps',
          network_1_2: '5Mbps*3',
          validity: 'Server Validity',
          validity_1_1: '1 Year',
          validity_1_2: '1 Year'
        }
      },
      productInfraPilotBanner: {
        titleLine1: 'InfraPilot',
        titleLine2: 'Galaxy Future AI Hosting Platform',
        description: 'Powered by patented technologies, InfraPilot enables Serverless transformation of AI applications and LLM inference without code modification. It supports minute-level application deployment, automatic GPU/CPU scheduling, zero-touch operations, and automated cost governance. Manage all internal AI applications and LLMs in one place, building an efficient AI development and LLM inference platform that dramatically boosts R&D efficiency.',
        registerButton: 'Register for Start Free (SaaS)',
        openSourceButton: 'Try Open Source Version',
        deploymentButton: 'Schedule Private Deployment'
      },
      productInfraPilotFeature: {
        title_1_1_1: 'Product Value',
        feature_title_1_1_1_1: 'Zero Modification',
        feature_text_1_1_1_1: 'Uses patented non-intrusive log collection technology, freeing developers from language/framework constraints. Submit release code only — build distributed, self-governing systems with auto-scaling, pay-per-use, and self-healing capabilities at low cost.',
        feature_title_1_1_1_2: 'Zero Maintenance',
        feature_text_1_1_1_2: 'Fully automates deployment, release, performance, and stability governance. Developers need no manual config for logs, compute specs, or scale — reduces 90%+ manual ops, config, and release work.',
        feature_title_1_1_1_3: 'Low Cost',
        feature_text_1_1_1_3: 'End-to-end automation with patented benchmarking tech automatically identifies lowest-cost compute specs. Achieves elastic, on-demand pricing while maximizing resource utilization — optimizing cloud costs.',
        registerButton_1_1_1: 'Register for Start Free (SaaS)',
        deploymentButton_1_1_1: 'Schedule Private Deployment'
      },
      productInfraPilotCore: {
        title_1_1: 'Core Features',
        feature_title_1_1: 'Auto-Deployment',
        feature_text_1_1: 'Developers submit release code — InfraPilot auto-builds images, configures templates, and deploys applications.',
        feature_title_1_2: 'Rapid Benchmarking',
        feature_text_1_2: 'Identifies optimal specs for stable app performance, maintains high resource utilization, auto-configures scaling policies for elasticity.',
        feature_title_1_3: 'Application Monitoring',
        feature_text_1_3: 'Monitors availability metrics, detects fault types, intervenes promptly — achieving self-governance.',
        feature_title_1_4: 'Self-Healing',
        feature_text_1_4: 'Supports restart, degradation, rollback, traffic switching — enabling applications to run autonomously without supervision.',
        button_experience: 'Experience Online Now',
        button_deployment: 'Schedule Private Deployment'
      },
      productInfraPilotWhy: {
        title_1_1: 'Why Choose Galaxy Future InfraPilot?',
        feature_title_1_1: 'All-Scenario Ready',
        feature_text_1_1: 'Suitable for web backends, audio/video, data processing, IoT — deploy Serverless without function/container/microservice refactoring.',
        feature_title_1_2: 'Self-Healing',
        feature_text_1_2: 'Self-healing capabilities let enterprises build unsupervised systems — boosting stability and saving manpower.',
        feature_title_1_3: 'Open & Neutral',
        feature_text_1_3: 'Auto-adapts to Alibaba Cloud, Huawei Cloud, AWS — supports cross-cloud/cross-region data migration for open business environments.',
        button_experience: 'Experience Online Now',
        button_deployment: 'Schedule Private Deployment'
      },
      trusteeshipBanner: {
        title_1_1: 'Operation Trusteeship Solution',
        description: 'Leveraging cutting-edge full-stack Serverless tech and vast mixed-cloud compute governance experience, Galaxy Future launches “Mixed Cloud Compute Governance” services — reduce compute costs to 80% of current spend without architecture changes. With free Galaxy Future Serverless transformation, further reduce costs to 70% of current spend.',
        button_consult: 'Schedule Consultation'
      },
      trusteeshipValue: {
        title_1_1: 'Solution Value',
        description_1_1: 'As enterprise digital businesses continue to expand, cloud costs are rapidly increasing, creating an urgent need for optimized cloud cost management.',
        description_1_2: 'A McKinsey survey shows that compared to public cloud-only solutions, hybrid cloud can help customers achieve 2.5 times more business value, further strengthening enterprises\' expectations for hybrid cloud deployment.',
        description_2_1: 'Responding to market demands, Galaxy Future launches the Operation and Maintenance Hosting Solution.',
        description_2_2: 'By providing two models - "Hybrid Cloud Hosting" and "Serverless Hosting" - it comprehensively helps enterprises significantly reduce IT costs.',
        solution_title: 'Galaxy Future Operation and Maintenance Hosting Solution',
        hybrid_title: 'Hybrid Cloud Hosting Solution',
        hybrid_text: 'Computing costs reduced to',
        hybrid_discount: '8',
        hybrid_list_1: 'Migrate to Galaxy Future hybrid cloud platform, combining the rich product lines of public cloud with the low server costs of private cloud;',
        hybrid_list_2: 'Whether your monthly cloud consumption is ten thousand, one hundred thousand, or one million, computing costs can be reduced to 80% of the current price.',
        serverless_title: 'Serverless Hosting Solution',
        serverless_text: 'Computing costs reduced to',
        serverless_discount: '7',
        serverless_list_1: 'Migrate to Galaxy Future Serverless platform, achieving minute-level application deployment, unattended operation assurance, and automated cost governance;',
        serverless_list_2: 'One-stop management of various open source, self-developed, and commercial applications within the enterprise, building an intelligent and efficient enterprise cloud operating system, reducing computing costs to 70% of the current price.',
        service_scope_title: 'Service Scope',
        service_scope_text: 'Galaxy Future provides comprehensive computing services, offering independent VPC, as well as virtual machine and container computing power. The service period defaults to one year with prepayment mode, using the one-year computing discount price of public cloud as the price benchmark.',
        service_customer_title: 'Target Customers',
        service_customer_list_1: 'Customers using public cloud or hybrid cloud architecture;',
        service_customer_list_2: 'Customers needing significant IT cost reduction.',
        discount_unit: 'off'
      },
      trusteeshipHighlights: {
        title_1_1: 'Solution Highlights',
        feature_1_title: 'Security Assurance',
        feature_1_text: 'On public cloud resources, provides independent VPC for enterprises to ensure business isolation; on private cloud, uses standard virtualization technology for tenant isolation, offering exclusive physical machine resources for enterprises.',
        feature_2_title: 'Stability Assurance',
        feature_2_text: 'Enterprises can also choose to fully host their business on Galaxy Future\'s operation platform, with the platform enhancing business stability.',
        feature_3_title: 'Full Hosting One-Stop',
        feature_3_text: 'After thorough assessment and enterprise approval, Galaxy Future\'s expert team provides one-stop business transformation and migration; during migration, business remains unaffected with no service interruption, achieving seamless full hosting.',
        button_free: 'Start Free (SaaS)'
      },
      relevant: {
        defaultTitle: 'Related Content',
        buttonDefault: 'View Details',
        buttonFree: 'Get Free',
        products: {
          product_1_title: 'Cloud-Native Intelligent Operation Platform SchedulX',
          product_1_text: 'An intelligent operation platform with advanced Serverless capabilities, reducing over 90% of operational work through fully automated deployment, performance maintenance, and stability governance, achieving overall IT cost savings of up to 60%.',
          product_2_title: 'All-in-One Enterprise Cloud Cost Manager CostPilot',
          product_2_text: 'Provides deep cost insights, quickly generates cost reports, offers customized cost optimization suggestions from multiple perspectives, and delivers integrated optimization functions.',
          product_3_title: 'Universal Serverless Platform InfraPilot',
          product_3_text: 'A maintenance-free, highly available, pay-as-you-go elastic computing power scheduling platform that helps various web systems achieve Serverless transformation without modification.'
        },
        solutions: {
          plan_1_title: 'Intelligent Operations Solution',
          plan_1_text: 'Leverage precise metric measurement, rapid compute scheduling — automate intelligent operations, lower ops barriers, boost operational efficiency 10x.',
          plan_2_title: 'Cost Optimization Solution',
          plan_2_text: 'Deep cost insights, fine-grained compute governance — reduce IT costs up to 50% while maintaining business stability.',
          plan_3_title: 'East Data West Computing Solution',
          plan_3_text: 'Move network-insensitive workloads to western data centers — reduce investment/operational costs, improve efficiency, better empower digital business.'
        },
        news: {
          news_1_title: 'Revealed! 10TB Cross-Cloud/Cross-Region Transfer in 10 Minutes — Technical Deep Dive',
          news_1_text: 'Detailed breakdown of massive data migration using cloud-native tech.'
        },
        whitepapers: {
          book_1_title: 'Cost Optimization White Paper',
          book_1_text: 'From an operations lead’s perspective — explains methods to reduce IT resource costs, achieving up to 70% savings step-by-step.',
          book_2_title: 'Intelligent Operations Solution White Paper',
          book_2_text: 'Cloud-native DevOps tool ecosystem — delivers engineering efficiency and intelligent operations solutions for enterprises of all sizes and stages.'
        },
        others: {
          other_1_title: 'SchedulX Version Update',
          other_1_text: 'Adds K8s cost breakdown, ECS spec benchmarking, weekly cost reports, budgeting, health checks — beyond existing rapid benchmarking, object storage, and integrated management.'
        }
      },
      planCostBanner: {
        title_1_1: 'Cost Optimization Solution',
        description: 'Achieve deep cost insights via visualization, enable fine-grained compute governance — reduce IT costs up to 50% while maintaining business stability.',
        button_free: 'Start Free (SaaS)'
      },
      planCostFlow: {
        title_line1: 'Full Process Cost Management',
        title_line2: 'Ensuring Maximum Cloud Resource Utilization',
        tab_1_title: 'Cost Insight',
        tab_1_sub: 'Multi-cloud cost visualization, quickly identifying optimization points',
        tab_1_text: 'Galaxy Future provides unified panoramic display of cost data across multi-cloud environments, helping you gain comprehensive insights into cloud costs, providing strong basis for cost optimization, and offering daily, monthly, quarterly, and annual cost forecasts to help you allocate resources reasonably.',
        tab_2_title: 'Computing Power Governance',
        tab_2_sub: 'Multi-dimensional systematic cost reduction, ensuring stability',
        tab_2_text: 'Galaxy Future provides a complete computing power governance solution, using various advanced technical means to improve resource utilization and resource scheduling efficiency from multiple dimensions, achieving significant cost optimization while ensuring business high availability!',
        tab_3_title: 'Continuous Operation',
        tab_3_sub: 'Streamlined cost operation processes, sustainable cost reduction effects',
        tab_3_text: 'Covers the entire cost management process, from business planning, cost budgeting, to resource application, business launch, and routine monitoring, continuously evaluating the gap between current business costs and optimization goals, and taking operational measures to ensure the sustainability of cost optimization effects.',
        button_free: 'Start Free (SaaS)'
      },
      planCostWhy: {
        title_line1: 'Why Choose Galaxy Future',
        title_line2: 'Cost Optimization Solution?',
        feature_1_title: 'Comprehensive Cost Visualization',
        feature_1_text: 'Analyze and display cost status from multiple dimensions including cloud platforms, cloud products, business lines, and applications, efficiently identifying cost issues.',
        feature_2_title: 'Detailed Cost Breakdown',
        feature_2_text: 'Break down costs to specific applications, quickly and accurately locating businesses with the highest resource consumption, and clarifying optimization directions.',
        feature_3_title: 'Multi-dimensional Optimization Methods',
        feature_3_text: 'Provide cost optimization functions across multiple dimensions including server layer, container layer, and business layer, easily achieving optimization goals.',
        feature_4_title: 'Customized Optimization Solutions',
        feature_4_text: 'Based on cost insight results, tailor efficient optimization solutions for enterprises, achieving systematic and targeted cost optimization.',
        button_demo: 'Schedule Demo'
      },
      floatConnect: {
        phoneTitle: 'Welcome to Call for Consultation',
        fcAssistant: 'AI Assistant',
        fcPhone: 'Call Us',
        fcDemo: 'Book Demo',
        fcWechat: 'Scan QR',
        qmPhoneTitle: 'Request a Call Back',
        qmPhoneDesc: 'Our consultant will call you at your preferred time',
        qmDemoTitle: 'Book a Demo',
        qmDemoDesc: 'Our solution expert will call you within 3 hours',
        qmPhonePlaceholder: 'Enter your phone number',
        qmSubmit: 'Submit',
        qmSuccess: 'Submitted! Our consultant will contact you shortly.',
        qmPhoneError: 'Please enter a valid phone number',
        qmNow: 'Call now',
        qmNowDesc: 'Within 30 minutes',
        qmLater: 'Call later',
        qmLaterDesc: 'Pick a date & time slot',
        qmToday: 'Today',
        qmTomorrow: 'Tomorrow',
        qmDayAfter: 'Day after tomorrow',
        phoneNumber: '[AI CEO]0592-3396506',
        emailTitle: 'Welcome to Email for Consultation',
        wechatTitle: 'Scan QR Code for Online Consultation',
        saasService: 'SaaS Service',
        aiAssistant: 'AI Assistant',
        digitalHuman: 'AI Digital Human',
        digitalHumanTitle: 'AI Digital Human Interaction',
        digitalHumanShow: 'Talk with AI Digital Human',
        digitalHumanHide: 'Hide Digital Human',
        dhHint: 'I am your AI digital human. Click to talk with me!',
        dhLoading: 'Digital human is loading, please wait…',
        dhTimeout: 'Loading is slow. Please check your network and retry.',
        dhRetry: 'Retry',
        dhPermissionDenied: 'Microphone permission is off. Enable it in browser settings and refresh to use voice chat.'
      },
      chatbot: {
        title: 'AI Assistant',
        history: 'History',
        newChat: 'New Chat',
        historyChat: 'History Chat',
        replying: 'AI is replying...',
        copy: 'Copy',
        inputPlaceholder: 'Type a message...',
        replyingPlaceholder: 'AI is replying...',
        copySuccess: 'Copied to clipboard',
        retryLater: 'Something went wrong, please try again later.',
        newChatTitle: 'New Chat',
        greeting: 'Hello! I am your AI Assistant, how can I help you today?',
        suggestTitle: 'You can ask me:',
        suggest1: 'What scenarios does the AI digital human support?',
        suggest2: 'What customer cases do you have?',
        suggest3: 'How to integrate or cooperate?'
      }
    }
  },
  zh: {
    modal: {
      submit: '提交',
      contactTitle: '与星汉未来联系',
      contactDescription: '留下您的联系方式，我们将在1个工作日内和您联系',
      name: '姓名',
      namePlaceholder: '请填写姓名',
      phone: '手机号',
      phonePlaceholder: '请填写手机号',
      email: '邮箱',
      emailPlaceholder: '请填写邮箱',
      company: '企业/学校',
      companyPlaceholder: '请填写企业/学校',
      position: '职位',
      positionPlaceholder: '请填写职位',
      requirement: '需求描述',
      requirementPlaceholder: '请填写需求描述',
      other: '其他',
      otherPlaceholder: '请填写其他',
      submitSuccess: '提交成功',
      operationTypes: {
        freeUse: '点击免费试用按钮',
        reserve: '点击预约咨询按钮',
        deployment: '点击预约私有化部署按钮',
        demo: '点击预约咨询按钮',
        demoCostPilot: '点击预约咨询(CostPilot)按钮',
        learnMore: '点击Serverless解决方案按钮',
        freeUseCostPilot: '点击免费体验(CostPilot)按钮',
        demoCustomerCases: '点击预约咨询(客户案例)按钮',
        productAidigitalHuman: '点击互动数字人平台(SaaS)联系我们按钮',
        productPrivateAidigitalHuman: '点击互动数字人平台(私有化)预约技术演示按钮',
        productPrivateAidigitalHumanGetPlan: '点击互动数字人平台(私有化)立即获取方案按钮'
      },
      submissionFields: {
        name: '用户姓名',
        phone: '手机号',
        email: '邮箱',
        company: '企业/学校',
        position: '职位',
        requirement: '需求描述',
        other: '其他'
      }
    },
    router: {
      root: '根',
      index: '主页',
      page: '页面',
      home: '首页',
      database: '资料中心',
      consult: '咨询服务',
      about: '关于我们',
      community: '开源社区',
      productSchedulX: '产品-SchedulX',
      productCostPilot: '产品-CostPilot',
      productInfraPilot: '产品-InfraPilot',
      productAIPilot: '产品-AIPilot',
      productAidigitalHuman: '产品-AidigitalHuman',
      productPrivateAidigitalHuman: '产品-PrivateAidigitalHuman',
      planOperation: '解决方案-智能运维',
      planTrusteeship: '解决方案-运维托管',
      planCost: '解决方案-成本优化',
      planStable: '解决方案-高峰流量应对',
      planMigrate: '解决方案-东数西算',
      planActive: '解决方案-多活部署',
      news: '新闻',
      newsDetail: '新闻-详情',
      license: '许可证',
      personal: '个人版',
      minijump: '小程序跳转',
      book: '白皮书',
      bookIndustry: '白皮书-Serverless行业',
      bookCostOptimization: '白皮书-IT成本优化',
      bookDevOps: '白皮书-运维方案',
      overseasEN: '海外-英文版',
      overseasENHome: '海外-英文版-首页',
      default: '默认'
    },
    page: {
      digitalHuman: {
        panelLabel: '数字人客服',
        openLabel: '展开数字人客服',
        miniInputAria: '输入问题，展开客服',
        inputPlaceholder: '请输入你的问题',
        unmuteTip: '取消静音，播放数字人声音',
        muteTip: '静音，关闭数字人声音',
        unmuteAria: '取消静音',
        muteAria: '静音',
        endTip: '结束对话，断开本次连接',
        endAria: '结束对话',
        restoreTip: '还原窗口大小',
        widenTip: '放大窗口，方便阅读',
        restoreAria: '还原窗口',
        widenAria: '放大窗口',
        collapseTip: '收起客服，返回右下角',
        closeAria: '关闭客服',
        identityAria: '当前咨询身份与浏览位置',
        browsing: '正在浏览 {title}',
        siteFallback: '官网',
        retry: '重试',
        messagesAria: '对话记录',
        connecting: '正在连接数字人…',
        welcomeTitle: '您好，有什么可以帮您？',
        welcomeLine1: '聊聊产品、解决方案，',
        welcomeLine2: '或问问您正在看的内容。',
        quickAria: '快捷提问',
        reconnect: '重新连接',
        leadText: '需要专属方案？',
        leadBtn: '预约演示 ↗',
        dismissAria: '关闭提示',
        interrupt: '打断回答',
        switchToText: '切换文字输入',
        switchToVoice: '切换语音输入',
        consultAria: '咨询内容',
        send: '发送',
        answeringDots: '回答中…',
        listeningDots: '正在聆听…',
        holdToTalk: '按住说话',
        tapToTalk: '点击说话',
        disclaimer: '部分内容由 AI 生成，请以实际服务信息为准',
        avatarAria: '数字人客服头像',
        avatarAlt: '数字人客服形象',
        idleVideoAria: '数字人待机视频',
        aiBadge: 'AI 客服',
        statusConnecting: '连接中…',
        statusOnline: '在线',
        statusIdle: '待机中',
        statusPreparing: '准备中…',
        statusThinking: '思考中…',
        statusSpeaking: '回答中',
        statusReconnecting: '重连中…',
        statusDestroyed: '已断开',
        answerTimeout: '等待回答超时，数字人服务可能繁忙，请重试。',
        loadingChat: '加载对话组件',
        slowSuffix: '，网络较慢…',
        prepareFailed: '数字人准备失败：{message}',
        chatLoadFailed: '对话组件加载失败：{message}',
        initFailed: '连接失败：{message}',
        connectFailed: '数字人连接失败',
        thinking: '正在思考…',
        serverBusy: '数字人服务暂时繁忙（服务端兜底应答），请重试。',
        echoRemoved: '该内容暂无法显示',
        authExpired: '当前客服授权已失效，请重试。',
        connectionUnavailable: '连接暂时不可用，请重新连接。',
        sessionNotReady: '会话配置未就绪：{message}，请重试。',
        voiceUnavailableHttp: '当前 HTTP 页面无法使用麦克风，请通过 HTTPS 访问；本机开发可使用 localhost。您仍可输入文字提问。',
        voiceUnavailableSupport: '当前浏览器不支持麦克风采集，请换用支持的浏览器或输入文字提问。',
        micConnecting: '正在连接…',
        micOpening: '正在开启麦克风…',
        releaseToSend: '松开发送',
        tapToStop: '点击结束说话',
        waitConnect: '等待连接',
        hintConnecting: '正在为您连接数字人…',
        hintPreparing: '正在准备提问配置…',
        hintPreparingWait: '正在准备，请稍候…',
        hintEnded: '本次对话已结束',
        hintAnswering: '正在回答 · 可点左侧打断',
        hintListeningTouch: '正在聆听 · 松开发送',
        hintListening: '正在聆听 · 说完自动发送',
        hintVoiceTouch: '按住说话，松开发送',
        hintVoice: '点一下开始说话',
        hintInputTouch: '输入问题 · 点左侧切换语音',
        hintInput: 'Enter 发送 · 点左侧切换语音',
        micDenied: '麦克风权限未开启，请在浏览器的网站设置中允许访问麦克风，或输入文字提问。',
        micNotFound: '未检测到麦克风，请连接设备或输入文字提问。',
        micStartFailed: '无法开始语音对话：{message}'
      },
      homeNew: {
        hero: {
          label: 'GALAXY FUTURE · AI DIGITAL HUMAN',
          btnTrial: '注册体验',
          formPlaceholder: '输入手机号预约演示',
          formBtn: '预约演示',
          titlePre: '用',
          titleAccent: 'AI数字人',
          titlePost: '赋能企业数字化转型',
          desc: '星汉未来专注于AI数字人、数字员工、AR导览等企业级解决方案，融合多国产大模型与多智能体架构，帮助企业降本增效、提升客户体验、沉淀数字资产。',
          btnSolutions: '了解解决方案',
          btnDemo: '预约演示',
          f1n: '低延迟对话',
          f1d: '实时语音交互',
          f2n: '多语种交互',
          f2d: '中英法俄等实时切换',
          f3n: '500+形象库',
          f3d: '全风格专属定制',
          f4n: '知识库RAG',
          f4d: '企业知识精准应答',
          f5n: '多端适配',
          f5d: '大屏/APP/小程序',
          f6n: '私有化部署',
          f6d: '数据不出域'
        },
        stickyCta: {
          badge: '免费体验 · 专属顾问1V1咨询',
          text: '现在预约演示，免费获取专属行业解决方案与落地评估',
          placeholder: '请输入手机号',
          btn: '立即预约'
        },
        stats: {
          s1v: '50+',
          s1l: '服务标杆客户',
          s2v: '6项',
          s2l: '国家授权发明专利',
          s3v: '75%',
          s3l: '综合成本降低',
          s4v: '10倍',
          s4l: '研发交付提速',
          note: '数据统计截至2026年9月，基于已交付项目实际运营数据'
        },
        products: {
          label: 'CORE PRODUCTS',
          title: '核心产品',
          sub: '平台级底层能力产品，可独立使用，也可组合成行业解决方案。',
          more: '了解更多',
          p1n: '数字人IP定制',
          p1d: '高保真3D/2.5D数字人形象定制，一次打造专属品牌IP，全端复用。',
          p2n: '实时对话引擎',
          p2d: '融合多国产大模型与多智能体架构，毫秒级响应，多轮对话自然流畅。',
          p3n: '多模态与互动',
          p3d: '拍照合影、问答游戏、表情动作等丰富互动玩法，让数字人真正“活”起来。',
          p4n: '知识管理',
          p4d: 'RAG增强的企业知识库，持续沉淀业务知识资产，越用越懂业务。',
          p5n: '多端适配',
          p5d: '覆盖一体机、大屏、APP、小程序等终端形态，一次部署，全端触达。',
          p6n: '硬件终端矩阵',
          p6d: '数字人一体机、全息舱等自研硬件矩阵，开箱即用，快速落地。'
        },
        solutions: {
          label: 'SOLUTIONS',
          title: '行业解决方案',
          sub: '深耕四大核心场景，为不同规模与行业的企业提供开箱即用的数字人解决方案。',
          more: '查看方案',
          s1n: '数字店长',
          s1t: '大型连锁',
          s1d: '为连锁门店打造AI数字店长，智能迎宾、产品讲解、会员运营一体化。',
          s2n: '数字员工',
          s2t: '央国企政府',
          s2d: '面向央国企与政府机构的数字员工，政策解答、业务引导，7×24小时在线。',
          s3n: '数字导览员',
          s3t: '文博景区',
          s3d: 'AR导览结合数字人讲解，为文博景区提供沉浸式智慧导览体验。',
          s4n: '数字老板',
          s4t: '中小商户',
          s4d: '中小商户的AI数字老板，低成本拥有专属数字人，营销获客更轻松。'
        },
        cases: {
          label: 'BENCHMARK CASES',
          title: '标杆案例',
          sub: '每一个数字背后，都是客户真实可衡量的业务增长。',
          detail: '查看案例详情',
          c1i: '文博场馆',
          c1n: '杜甫草堂',
          c1r: '游客停留时长+60%',
          c2i: '轨道交通',
          c2n: '某地铁智能客服',
          c2r: '站内咨询分流65%+',
          c3i: '文旅IP',
          c3n: '大同木兰',
          c3r: '游客打卡率+40%'
        },
        clients: {
          label: 'OUR CLIENTS',
          title: '值得信赖的合作伙伴',
          sub: '与行业领先企业携手共建 AI 数字人生态。',
          l1n: '烟台中科',
          l2n: '智谱华章',
          l3n: '谛听视界',
          l4n: '匀熵智能',
          l5n: '清晓科技',
          l6n: '麦兔智能',
          l7n: '视颐科技',
          l8n: '古联公司',
          l9n: '如视科技'
        },
        cta: {
          title: '开启您的AI数字人之旅',
          desc: '现在预约演示，让星汉未来为您的企业量身定制AI数字人解决方案。',
          btn1: '预约演示',
          btn2: '免费体验',
          contact: "联系方式：0592-3396506 ｜ market{'@'}galaxy-future.com"
        },
        advantages: {
          label: 'CORE ADVANTAGES',
          title: '核心优势',
          sub: '全栈自研技术底座与真实落地验证，让每一次交付都有据可依。',
          a1v: '50+',
          a1t: '标杆客户验证',
          a1d: '覆盖文旅、零售、金融、教育、政企等多行业真实落地。',
          a2v: '6项',
          a2t: '国家授权发明专利',
          a2d: '全栈自研技术底座，精准度量、算力共享池等底层专利。',
          a3v: '75%',
          a3t: '综合成本降低',
          a3d: '平台化制作与多端复用，大幅降低数字人拥有成本。',
          a4v: '10倍',
          a4t: '研发交付提速',
          a4d: '标准化流程让交付周期从天级缩短到小时级。',
          note: '数据统计截至2026年9月，基于已交付项目实际运营数据'
        }
      },
      productCenter: {

            details: {
                  btn: '预约演示',
                  phonePlaceholder: '输入手机号预约',
                  d1: {
                        name: '数字人IP定制',
                        tag: '2D/3D形象、声音、动作全链路定制',
                        ab1n: '2D/3D形象建模',
                        ab1d: '高保真2D/3D数字人形象建模，支持写实/卡通/国风多风格',
                        ab2n: '声音克隆',
                        ab2d: '声音采样与克隆，定制品牌专属音色，情感化语音表达',
                        ab3n: '动作与表情驱动',
                        ab3d: '面部表情捕捉+身体动作驱动，口型同步自然流畅',
                        ab4n: '背景管理',
                        ab4d: '数字人展示背景自定义，支持图片/视频/虚拟场景背景切换',
                        ab5n: '品牌IP定制',
                        ab5d: '企业品牌IP形象定制，从形象到声音全链路品牌化',
                        ab6n: '资产库管理',
                        ab6d: '数字人资产统一管理，形象/声音/动作/背景可复用可组合',
                        adv1: '500+数字人角色库可快速选用',
                        adv2: '90%+制作成本降低，交付周期缩短',
                        adv3: '支持SaaS+私有化双模式部署',
                  },
                  d2: {
                        name: '实时对话引擎',
                        tag: 'ASR+NLP+TTS全链路，网页/语音多渠道接入',
                        ab1n: 'ASR语音识别',
                        ab1d: '中英文及多方言精准识别，支持热词/替换词/敏感词配置，低延迟高准确率',
                        ab2n: 'NLP语义理解',
                        ab2d: '意图识别+情绪识别+实体抽取，深度理解用户语义',
                        ab3n: 'TTS语音合成',
                        ab3d: '多音色自然语音合成，情感化表达，支持声音克隆定制品牌音色',
                        ab4n: '对讲与音量管理',
                        ab4d: '单次/连续对讲模式，连续对讲支持打断，音量实时调节控制',
                        ab5n: '多语种与语言设置',
                        ab5d: '中英法俄等多语言实时切换，语言设置可自定义默认语言',
                        ab6n: '连接方式',
                        ab6d: '支持ARTC和WebRTC两种连接方式，低延迟实时音视频传输',
                        adv1: '端到端低延迟，实时对话无卡顿',
                        adv2: '支持SaaS+私有化双模式部署',
                        adv3: '私有化部署数据不出域，保障安全',
                  },
                  d3: {
                        name: '多模态与互动',
                        tag: '广告/直播/游戏/演示等全场景互动模式',
                        ab1n: '广告互动模式',
                        ab1d: '品牌引流互动，扫码参与/抽奖/优惠券发放，提升到店转化',
                        ab2n: '直播互动模式',
                        ab2d: '数字人不间断直播，弹幕互动/商品讲解/智能带货',
                        ab3n: '游戏互动模式',
                        ab3d: '答题/抽奖/闯关/知识问答游戏，寓教于乐提升参与度',
                        ab4n: '小程序控制器',
                        ab4d: '微信小程序远程控制数字人，位置管理/面容与声音设置一键调节',
                        ab5n: '演示与位置管理',
                        ab5d: '产品/方案自助讲解，参观者触发交互，数字人位置可自由调度',
                        ab6n: '视觉与拍照互动',
                        ab6d: '人脸识别/体感互动，数字人合影社交分享，品牌二次曝光',
                        adv1: '6大互动模式灵活组合，按需配置',
                        adv2: '支持SaaS+私有化双模式部署',
                        adv3: '互动数据全链路埋点，效果可量化',
                  },
                  d4: {
                        name: '知识管理',
                        tag: 'RAG检索增强+企业知识库智能构建',
                        ab1n: 'RAG检索增强生成',
                        ab1d: '基于企业知识库精准回答，减少大模型幻觉',
                        ab2n: '企业知识自动构建',
                        ab2d: '多源数据统一接入，自动构建结构化知识库，支持持续更新',
                        ab3n: '文档智能解析',
                        ab3d: '支持PDF/Word文档智能解析，自动提取关键信息与知识点',
                        ab4n: '知识图谱推理',
                        ab4d: '实体关系抽取，知识图谱构建，支持关联推理与深度问答',
                        ab5n: '知识更新与白名单',
                        ab5d: '知识版本管理与持续更新，白名单控制可访问知识范围',
                        ab6n: '常驻知识库与记忆',
                        ab6d: '常驻内存加速检索，上下文记忆+历史对话记录可追溯',
                        adv1: '支持百万级文档秒级检索',
                        adv2: '私有化部署，数据不出域保障安全',
                        adv3: '知识准确率>95%',
                  },
                  d5: {
                        name: '多端适配',
                        tag: '大屏/H5/电话/AR/智能硬件/SDK全终端覆盖',
                        ab1n: '大屏/全息柜/平板',
                        ab1d: '立式大屏/全息展示柜/平板终端统一适配，触控交互体验一致',
                        ab2n: 'H5/小程序适配',
                        ab2d: '移动端网页/微信小程序/公众号嵌入，轻量接入无需下载',
                        ab3n: '电话/语音机器人',
                        ab3d: '外呼/客服/语音导航，纯语音交互覆盖电话渠道',
                        ab4n: 'AR设备适配',
                        ab4d: 'AR眼镜/AR投影等增强现实终端，沉浸式数字人体验',
                        ab5n: '智能硬件终端',
                        ab5d: '小星盒子AI硬件（可做AI玩具）+投影仪互动/墙面交互',
                        ab6n: 'SDK接入',
                        ab6d: '开发者SDK快速集成，将数字人能力嵌入自有APP/系统/平台',
                        adv1: '一次开发多端部署，统一管理',
                        adv2: '支持SaaS+私有化双模式部署',
                        adv3: '各端体验一致，数据互通',
                  },
                  d6: {
                        name: '硬件终端矩阵',
                        tag: '小星盒子系列 + 全终端适配，让数字人走进真实空间',
                        ab1n: '小星盒子·中华先贤',
                        ab1d: '内置孔子/老子/李白/杜甫等先贤形象，传统文化知识库深度问答',
                        ab2n: '小星盒子·花木兰',
                        ab2d: '城市文化IP定制，文旅推介/多语种服务/互动拍照',
                        ab3n: '立式大屏终端',
                        ab3d: '43-65寸经典立柜式大屏，展厅/大堂/门店通用',
                        ab4n: '全息展示柜',
                        ab4d: '透明介质全息呈现，科技馆/高端展陈首选',
                        ab5n: '平板与移动屏',
                        ab5d: '便携移动终端，巡展/多点位轮换灵活部署',
                        ab6n: '定制化硬件集成',
                        ab6d: '投影仪适配/桌面一体机/定制化硬件集成',
                        adv1: '软硬一体，开箱即用',
                        adv2: '一次制作，多终端发布',
                        adv3: '支持SaaS+私有化双模式部署',
                  },
            },
        banner: {
          title: '六大核心产品模块',
          sub: '从数字人IP定制到硬件终端，一站式覆盖数字人全生命周期',
          feat1: '数字人IP定制 · 面容声音背景全自定义',
          feat2: '实时对话引擎 · 单次/连续对讲+ARTC/WebRTC',
          feat3: '知识管理 · 文档解析+白名单+常驻知识库',
          feat4: '多模态互动 · 广告/直播/演示/小游戏全模式',
          feat5: '多端适配 · 大屏/全息/平板/H5/电话/SDK',
          feat6: '硬件终端矩阵 · 立式屏/全息柜/平板/移动端全场景覆盖',
          card1t: '数字人IP定制',
          card1d: '面容/声音/背景全自定义，2D/3D形象生成',
          card2t: '实时对话引擎',
          card2d: '单次/连续对讲，ARTC+WebRTC低延迟',
          card3t: '知识管理',
          card3d: '文档智能解析，白名单+常驻知识库',
          card4t: '多端适配',
          card4d: '大屏/全息/平板/H5/电话/SDK全端覆盖',
          stat1n: '六大核心模块',
          stat1l: '覆盖数字人全生命周期',
          stat2n: '20+功能点',
          stat2l: '从IP定制到硬件终端',
          stat3n: '两种交付模式',
          stat3l: 'SaaS+私有化部署',
          stat4n: '全端适配覆盖',
          stat4l: '大屏/全息/平板/H5/SDK',
          envLabel: '立即体验',
          env1n: '34环境 · 企业版',
          env1d: '企业级全功能在线体验',
          env2n: '36环境 · 个人版',
          env2d: '轻量个人版在线体验',
        },
        products: {
          label: 'CORE PRODUCTS',
          title: '六大底层技术产品',
          sub: '从数字人形象到对话引擎、知识管理、多端适配与硬件终端，全链路能力模块化输出',
          p1n: '数字人IP定制',
          p1d: '从形象到声音的全维度数字人打造',
          p1c1: '2D/3D形象建模',
          p1c2: '声音克隆',
          p1c3: '动作驱动',
          p1c4: '品牌IP定制',
          p2n: '实时对话引擎',
          p2d: '低延迟、拟人化的实时语音对话能力',
          p2c1: 'ASR语音识别',
          p2c2: 'NLP语义理解',
          p2c3: 'TTS语音合成',
          p2c4: '网页端对话嵌入',
          p3n: '多模态与互动',
          p3d: '覆盖营销全场景的互动玩法引擎',
          p3c1: '广告互动模式',
          p3c2: '直播互动模式',
          p3c3: '小游戏互动',
          p3c4: '演示模式',
          p4n: '知识管理',
          p4d: '企业知识资产的智能化构建与应用',
          p4c1: 'RAG检索增强',
          p4c2: '知识库自动构建',
          p4c3: '文档智能解析',
          p4c4: '知识图谱',
          p5n: '多端适配',
          p5d: '一次开发，全终端触达用户',
          p5c1: '大屏/全息柜适配',
          p5c2: 'H5/小程序',
          p5c3: '电话语音机器人',
          p5c4: 'SDK接入',
          p6n: '硬件终端矩阵',
          p6d: '软硬一体的线下场景交付方案',
          p6c1: '立式大屏终端',
          p6c2: '全息展示柜',
          p6c3: '平板终端',
          p6c4: '定制化硬件集成',
        },
        avatars: {
          title: '数字人形象库',
          sub: '500+数字人角色库，支持2D真人级复刻、3D写实高保真、Q版卡通等全风格定制',
        },
        cta: {
          bannerTitle: '预约产品定制',
          bannerDesc: '无论是单点产品采购，还是多产品组合的行业解决方案，我们都可以为您量身定制',
          bannerBtn1: '预约定制',
          bannerBtn2: '免费体验',
        },
      },
      productTerminal: {
        hero: {
          label: 'XIAOXING BOX',
          title1: '小星盒子',
          title2: '口袋级AI数字人设备',
          desc: '让AI更有温度，随时随地与历史名人对话。内置45款数字人角色，陪伴3~12岁孩子快乐成长。',
          btn1: '立即咨询',
          metricsLabel: '核心参数 · KEY SPECS',
          m1v: '45款',
          m1l: '数字人角色',
          m2v: '85g',
          m2l: '整机重量',
          m3v: '4小时',
          m3l: '连续对话续航',
          m4v: '3~12岁',
          m4l: '适用年龄',
        },
        features: {
          label: '产品概览',
          title: '三大核心价值',
          sub: '口袋级AI数字人设备，重新定义孩子的学习陪伴方式',
          f1t: 'AI数字人',
          f1d: '内置45款数字人角色，涵盖诗词文人、历史名人、神话形象等六大类别，与千古名人面对面交流。',
          f2t: '口袋级便携',
          f2d: '掌心大小，仅85g，放进口袋随时带走。无论在家、学校、旅行，都能随时开始对话。',
          f3t: '智能交互',
          f3d: '语音唤醒，自然对话，支持多轮交互。听懂小朋友的奇思妙想，给出有温度的回答。',
        },
        showcase: {
          label: 'DESIGN',
          title: '小机身，装下大世界',
          sub: '仅85g的掌心设备，内置完整AI数字人系统',
          m1v: '45款',
          m1l: '数字人角色',
          m2v: '85g',
          m2l: '整机重量',
          m3v: '4小时',
          m3l: '连续对话续航',
          m4v: '7天',
          m4l: '超长待机',
        },
        functions: {
          label: '核心功能',
          title: '五大核心功能，陪伴孩子成长',
          sub: '不仅是玩具，更是孩子的AI学习伙伴',
          f1t: '智能对话',
          f1d: '语音唤醒，自然对话，多轮交互，有温度的回答',
          f2t: '知识问答',
          f2d: '百科知识，历史故事，解答小朋友的十万个为什么',
          f3t: '多模态交互',
          f3d: 'LED屏表情动画，生动形象，更有代入感',
          f4t: '翻译模式',
          f4d: '中英互译，自动识别，支持多语言翻译学习',
          f5t: '学习模式',
          f5d: '聊天中学英语，无感融入成长',
        },
        compare: {
          label: '版本对比',
          title: '两个版本，满足不同需求',
          sub: '选择最适合你的版本',
          tag: '推荐',
          unit: '/台',
          wifiName: 'WiFi版',
          g4Name: '4G版',
          priceW: '¥129',
          priceG: '¥199',
          w1: '支持2.4GHz WiFi连接',
          w2: '在家、学校WiFi环境使用',
          w3: '完整AI对话功能',
          w4: '45款数字人角色',
          w5: '知识融入学习系统',
          w6: 'LED表情动画显示',
          g1: '内置eSIM，三大运营商覆盖',
          g2: '随时随地联网，无需WiFi',
          g3: '全国流量，即买即用',
          g4: '顶部按键一键切换4G/WiFi',
          g5: '完整AI对话功能',
          g6: '45款数字人角色+知识融入系统',
        },
        flow: {
          label: '使用流程',
          title: '四步上手，简单易用',
          sub: '开机即用，无需复杂设置',
          s1t: '开机',
          s1d: '长按左侧按键开机，LED屏亮起',
          s2t: '配网',
          s2d: 'WiFi版连接WiFi，4G版自动联网',
          s3t: '对话',
          s3d: '语音唤醒，选择喜欢的数字人角色，开始对话',
          s4t: '成长',
          s4d: '知识融入系统，聊天中自然学习成长',
        },
        knowledge: {
          label: '特色功能',
          title1: '知识融入系统',
          title2: '聊天中自然学知识',
          desc: '像朋友聊天时顺嘴一提，让孩子在不知不觉中学习。不打断、不硬拐、不展开、不考试、不说教。',
          t1: '百科知识',
          t2: '国学经典',
          t3: '外语学习',
          t4: '科学探索',
          p1: '先接住孩子的话',
          p2: '自然带出知识点',
          p3: '不打断不说教',
          p4: '无感融入学习',
        },
        specs: {
          label: '技术规格',
          title: '技术参数与硬件规格',
          s1l: '尺寸',
          s1v: '65×65×45mm',
          s2l: '重量',
          s2v: '约85g',
          s3l: '电池',
          s3v: '500mAh锂电',
          s4l: '续航',
          s4v: '连续对话约4小时',
          s5l: '待机',
          s5v: '约7天',
          s6l: '充电',
          s6v: 'Type-C 约1.5小时',
          s7l: '麦克风',
          s7v: '双麦克风阵列降噪',
          s8l: '适用年龄',
          s8v: '3-12岁儿童',
        },
        cta: {
          title: '让孩子的成长，有AI陪伴',
          desc: '立即咨询，了解小星盒子更多详情',
          btn: '立即咨询',
        },
      },
      solutionCenter: {
        banner: {
          title: '四大行业解决方案',
          sub: '按客群分层，每个方案含定位、痛点、价值与实施路径',
        },
        ov: {
          title1: '用AI数字人',
          title2: '赋能企业数字化转型',
          sub: '融合多国产大模型与多智能体架构，数字人IP定制、实时对话、知识管理全栈能力，默认SaaS交付，支持私有化部署',
          btn1: '免费试用',
          btn2: '查看产品',
          metricsLabel: 'CORE METRICS · 核心指标',
          m1n: '4',
          m1t: '大行业解决方案',
          m1d: '数字店长 · 数字员工 · 数字导览员 · 数字老板',
          m2n: '6',
          m2t: '项国家发明专利',
          m2d: '全栈自研 · 大模型+Agent+Serverless',
          m3n: '8',
          m3t: '大客户场景',
          m3d: '连锁零售 · 央国企 · 文博景区 · 教育 · 金融 · 媒体 · 政企 · 中小商户',
          m4n: '50+',
          m4t: '家行业标杆客户',
          m4d: '杜甫草堂 · 苏州地铁 · 千年舟 · 立邦 · 科利华 · 金陵小学',
          solsLabel: 'SOLUTIONS · 四大解决方案',
          sol1n: 'AI数字店长',
          sol1t: '连锁集团门店数字化',
          sol1d: '面向厨卫/家居/建材/电器/服装连锁集团，千店一面部署，门店迎宾+产品讲解+促销引导',
          sol2n: 'AI数字员工',
          sol2t: '央国企政务智能服务',
          sol2d: '面向央国企/政府事业单位，政务引导+业务查询+内部服务+运维支持，7×24小时在线',
          sol3n: 'AI数字导览员',
          sol3t: '文博景区沉浸式讲解',
          sol3d: '面向景区/博物馆/展厅，互动讲解+多语言导览+AR虚实结合，提升游客体验',
          sol4n: 'AI数字老板',
          sol4t: '中小商户多语种经营',
          sol4d: '面向义乌小商品城/零散商铺/餐厅，多语种接待+产品介绍+下单引导',
        },
        common: {
          painTitle: '核心痛点',
          valueTitle: '方案价值',
          pathTitle: '实施路径',
          caseTitle: '标杆案例',
          demoBtn: '预约演示',
          featuresTitle: '核心功能',
          othersTitle: '探索其他解决方案',
          detailBtn: '了解详情',
          roleBefore: '原来',
          roleAfter: '现在',
        },
        sol1: {
          tag: 'SOLUTION 01',
          name: '数字店长 · 大型连锁集团',
          pos: '面向连锁零售集团的门店智能化方案，让每一家门店都拥有一位永不下线的金牌店长，把客户从进店到复购的每一个环节都变成可跟进的服务。',
          tagsLabel: '适用场景',
          t1: '厨卫',
          t2: '家居',
          t3: '建材',
          t4: '电器',
          t5: '服装',
          p1: '高峰期导购忙不过来、午休闭店无人值守，约 30% 意向客户进店后无人理睬，转身离开',
          p2: '客户问过什么、想要什么、顾虑什么全靠导购脑记，人一离职信息就彻底丢失',
          p3: '一句「我考虑考虑」离店之后再无人跟进，约 70% 慢决策客户在对比期被竞品抢走',
          p4: '钱付完就「失联」，安装、保养、出问题找不到人，复购与转介绍无从谈起',
          v1: '7×24 接待 + 九大节点自动触达，闭店后客户仍可在线交互，进店到复购全程不漏人',
          v2: '360° 客户画像 + 个性化 H5 专属方案，决策效率提升 3 倍',
          v3: '金牌店长经验批量复制；不动存量、只分增量，导购、店长、工人收入只增不减',
          v4: '客户满意度提升 40%、复购率提升 25%，售后从「失联」变长期经营',
          s1n: '8%-30%',
          s1l: '营收增长区间',
          s2n: '400%+',
          s2l: '单店投入产出比',
          s3n: '2-3个月',
          s3l: '平均回本周期',
          s4n: '7×24小时',
          s4l: '全天候在线服务',
          crumb: '解决方案 · AI数字店长',
          bf1: '集团总部统一管理，千店一面数字人部署',
          bf2: '门店智能迎宾+产品讲解+促销引导',
          bf3: '7×24小时不间断服务，降低人力成本',
          bf4: '实时数据回传，总部掌握每家门店运营状况',
          bf5: '支持多门店差异化内容配置',
          bc1t: '三端信息采集',
          bc1d: '一体机+手持端+H5，8类客户信息沉淀',
          bc2t: '九大节点跟进',
          bc2d: '进店到复购全流程自动触达，不漏客户',
          bc3t: '员工激励机制',
          bc3d: '服务质量奖+增量提成，收入只增不减',
          bc4t: '360°客户画像',
          bc4d: '基于真实信息生成专属个性化服务方案',
          st1n: '先止损 · 接待上线',
          st1d: '第 1-2 月',
          st2n: '跑通激励 · 主动使用',
          st2d: '第 2-3 月',
          st3n: '规模化 · 飞轮自转',
          st3d: '第 3 月起',
          c1: '某家居零售连锁品牌：展厅数字人提供智能导购与产品讲解',
          c2: '试点机制：首批 6-10 家门店、单店年投入 3-5 万元，3 个月验证真实 ROI，不达预期可停',
          f1t: '三端信息采集',
          f1d: '门店一体机像朋友聊天一样自然采集、不推销不施压，导购手持终端随时补录，客户离店后 H5/小程序持续交互，三端汇入统一客户画像。',
          f2t: '360° 客户画像',
          f2d: '自动记录基本画像、基本需求、真实痛点、预算范围、时间计划、关键决策人、顾虑担忧与竞品对比 8 类信息。',
          f3t: '九大节点自动触达',
          f3d: '售前方案解读与 3 天/7 天决策提醒，售中施工进度实时同步，售后 7 天回访、保养提醒与周年关怀——微信、短信、H5 全渠道触达。',
          f4t: '个性化 H5 专属方案',
          f4d: '产品推荐、配套方案、风险提示、工序流程、费用清单、维护服务六大模块一次配齐，AI 店长常驻答疑。',
          f5t: '员工增量激励体系',
          f5d: '服务质量奖 + 增量提成 + 利润分红：导购月收入 +20-30%、店长年收入 +30-50%、工人月收入 +15-25%，不动存量、只分增量。',
          f6t: '店长数据看板',
          f6d: '客流、转化、客单三根杠杆各提升 10%，乘法叠加撬动营收；一屏看清每个门店的薄弱环节。',
          loopTitle: '核心逻辑：从采集到复购的服务闭环',
          loopSub: '本质不是生成方案，而是四步递进的闭环体系——前三步是地基，第四步才有灵魂',
          l1n: '信息采集',
          l1d: '客户进店开始，所有信息自动采集沉淀，不靠导购脑子记',
          l2n: '全流程跟进',
          l2d: '从进店到复购，每个节点系统自动跟进，不漏一个客户',
          l3n: '员工店长配合',
          l3d: '不是管人，是帮人；利益一致，一线从抵触变主动用',
          l4n: '个性化服务',
          l4d: '基于真实信息生成专属方案，真正帮客户避坑、建立信任',
          ledgerTitle: '单店账本 · 增长是可计算的结果',
          ledgerSub: '以年营收 500 万门店、增长 15% 保守测算',
          b1n: '+75万',
          b1d: '营收增长（15% 保守取值）',
          b2n: '+22.5万',
          b2d: '毛利增量（毛利率 30%）',
          b3n: '+3-5万',
          b3d: '客诉、退单、返工损耗下降',
          b4n: '20-22万',
          b4d: '单店年净增收益，标杆门店约 37-40 万',
          ledgerNote: '口径说明：30% 为具备条件的标杆门店冲刺目标，非保底承诺；乘法叠加为理论空间，统一采用保守可落地口径。',
          nodesTitle: '九大节点自动触达 · 环环不断',
          nodesSub: '微信 + 短信 + H5 + 小程序全渠道触达，慢决策客户持续在线、不再丢失',
          ph1t: '售前 · 持续培育',
          ph1r: '节点 01-05 · 进店到对比',
          ph1d: '感谢消息与方案链接、方案解读答疑、3 天/7 天决策提醒、限时优惠推送',
          ph2t: '售中 · 进度透明',
          ph2r: '节点 06-07 · 下单到安装',
          ph2d: '订单确认与工期安排、施工进度实时同步、完工验收确认与使用指南',
          ph3t: '售后 · 长期经营',
          ph3r: '节点 08-09 · 售后到复购',
          ph3d: '7 天使用回访、保养提醒、周年关怀、延保权益与复购转介绍推荐',
          n1: '进店',
          n2: '咨询',
          n3: '出方案',
          n4: '离店',
          n5: '对比',
          n6: '下单',
          n7: '安装',
          n8: '售后',
          n9: '复购',
          rolesTitle: '不是管人，是帮人赚钱',
          rolesSub: '以前上系统推不动，是因为系统在管人；这套系统帮人赚钱，人人都想用',
          r1n: '导购',
          r1r: '一线成交主力',
          r1g: '+20-30%',
          r1gl: '月收入提升',
          r1b: '靠脑子记客户，一忘就丢单，老客跟进全凭自觉、没有章法',
          r1a: 'AI 记住一切、自动跟进，导购只带温度成交；增量提成 2%→3%，另设服务质量奖',
          r2n: '店长',
          r2r: '门店经营负责人',
          r2g: '+30-50%',
          r2gl: '年收入提升',
          r2b: '靠感觉管门店，谁干得好全靠猜，问题暴露慢，天天当救火队长',
          r2a: '数据看板看清每个薄弱环节、精准抓管理；享增量利润分红，转型经营教练',
          r3n: '工人',
          r3r: '交付与服务一线',
          r3g: '+15-25%',
          r3gl: '月收入提升',
          r3b: '工序靠催、靠等、靠协调，空等耗时间，结算不透明、不及时',
          r3a: '系统智能排程、按计划干活少空等；好评决定接单优先级，金牌单价上浮 10-20%',
          lv1n: '客流杠杆',
          lv1d: '7×24 接待、闭店留资，打捞流失与转介绍客流',
          lv2n: '转化杠杆',
          lv2d: '个性化方案、费用透明、全周期触达、人机协同',
          lv3n: '客单杠杆',
          lv3d: '配套连带、服务包增值、合理升级（增值而非加价）',
          lvResult: '1.1 × 1.1 × 1.1 = 1.33，即营收 +33%（保守口径：基线 8%-20%，标杆门店 20%-30%）',
          st1a: '验收：客流流失 -20%、档案完整度 ≥70%、使用率 ≥80%',
          st2a: '验收：转化率、客单价、NPS 明显提升，一线主动使用',
          st3a: '验收：单店 ROI 达标、可复制 SOP 成型、启动规模化',
        },
        sol2: {
          tag: 'SOLUTION 02',
          name: '数字员工 · 央国企政府',
          pos: '标准化可审计的智能劳动力——面向央国企与政府机构的私有化部署 AI 员工体系，让 AI 真正上岗，成为会思考、能执行、越用越能干的数字同事。',
          tagsLabel: '典型岗位',
          t1: '智能客服',
          t2: '财务报销',
          t3: '运维值守',
          t4: '办公助手',
          p1: '客服热线、财务报销、数据录入等高频重复事务占用大量人力，人力成本逐年上升',
          p2: '服务质量因人而异，业务口径不一，标准化难',
          p3: '值守类岗位 7×24 在线压力大，夜间与节假日难保障',
          p4: '新人培训周期长，知识沉淀难传承',
          v1: '数字员工端到端接管高频重复业务，人力成本节约 30%+',
          v2: '7×24 不间断服务，业务效率提升 50%+，主动预警、数据找人',
          v3: '服务 100% 标准化，全程可审计',
          v4: '私有化部署 + 信创国产化适配，买断制授权，数据不出内网',
          s1n: '30%+',
          s1l: '人力成本节约',
          s2n: '50%+',
          s2l: '业务效率提升',
          s3n: '100%',
          s3l: '服务标准化',
          crumb: '解决方案 · AI数字员工',
          bf1: '政务大厅智能引导，办事流程指引与申请材料清单查询',
          bf2: '企业内部服务数字人，IT/人事/财务咨询一站式支持',
          bf3: '标杆项目落地经验，服务全程标准化、可审计',
          bf4: '私有化部署，数据不出域，安全可控',
          bf5: '多语种服务，适配国际化场景需求',
          bc1t: '政务服务引导',
          bc1d: '办事流程指引，申请材料清单查询',
          bc2t: '业务智能查询',
          bc2d: '政策法规与办事进度实时问答',
          bc3t: '内部服务支持',
          bc3d: 'IT 运维/人事/财务内部咨询一站式',
          bc4t: '运营数据看板',
          bc4d: '服务数据可视化，管理决策有依据',
          st1n: '小范围试点',
          st1d: '3 个月',
          st2n: '规模推广',
          st2d: '6-12 个月',
          st3n: '全企业覆盖',
          st3d: '持续深化',
          c1: '某地铁智能客服：2026 年 5 月上线，整合沿线近 200 处文旅景点，中英文双语 7×24 服务，全国城轨首个交文商旅融合数字员工',
          f1t: '智能客服',
          f1d: '7×24 小时接电话、回消息，常见问题自动解答，复杂问题无缝转人工。',
          f2t: '财务报销',
          f2d: '发票识别、报销审核、费用校验全流程自动化，自动验真查重准确率 99% 以上，财务人员从单据审核中解放。',
          f3t: '运维值守',
          f3d: '深夜巡检、故障预警、应急响应全天候在线，知识检索效率提升 70%+、故障处置效率提升 50%+。',
          f4t: '办公助手',
          f4d: '写材料、查资料、做会议纪要，自然语言交互，零学习成本。',
          f5t: '私有化部署 + 信创适配',
          f5d: '支持昇腾算力、鲲鹏/飞腾 CPU、麒麟/统信系统与国产大模型；买断制一次授权、终身使用，数据全程不出企业内网。',
          f6t: '等保三级安全合规',
          f6d: '传输存储全链路加密，操作全程可审计，按组织角色精细化权限管控。',
          loopTitle: '长期价值：数据飞轮效应',
          loopSub: '一次性投入、持续受益——数据越积累，AI 越聪明，这是数字员工的长期复利',
          l1n: '数据积累',
          l1d: '每一笔业务数据持续沉淀进企业私有知识库，每一次服务都在喂养系统',
          l2n: 'AI 持续进化',
          l2d: '数据越积累，AI 越聪明，越用越能干',
          l3n: '服务更精准',
          l3d: '响应越来越精准，业务口径与服务质量始终稳定一致',
          l4n: '用户更满意',
          l4d: '满意度提升带来更多使用与数据，飞轮循环加速',
          ledgerTitle: '价值账本 · 降本增效提质可量化',
          ledgerSub: '基于已上线央国企项目实际成效——小步快跑，先验证再推广',
          b1n: '30%+',
          b1d: '高频岗位人力成本节约',
          b2n: '50%+',
          b2d: '业务效率提升，7×24 全天候在线',
          b3n: '99%+',
          b3d: '发票验真查重准确率',
          b4n: '12-18个月',
          b4d: '投资回收期，之后每年持续产生净收益',
          ledgerNote: '口径说明：先用小范围试点验证实际效果，3 个月看到结果后再决定推广规模，投入与风险完全可控。数据安全保障：私有化部署（数据不出域）+ 权限分级管理 + 全链路操作审计，让数据比放在公有云更安全。',
          rolesTitle: '不是替代人，是把人从重复劳动中解放出来',
          rolesSub: 'AI 承担标准化、高频次、7×24 的工作，人去做更有价值的判断和创造',
          r1n: '客服岗',
          r1r: '高频接待一线',
          r1g: '-30%',
          r1gl: '人力成本',
          r1b: '8 小时工作制、响应有延迟，服务质量因人而异，新人培训周期长',
          r1a: '7×24 接电话回消息，常见问题自动解答，复杂问题无缝转人工',
          r2n: '财务岗',
          r2r: '单据审核主力',
          r2g: '99%+',
          r2gl: '验真查重准确率',
          r2b: '发票识别、报销审核、费用校验全靠人工，成本高、易出错',
          r2a: '审核全流程自动化，财务人员从单据审核中解放，专注高价值判断',
          r3n: '运维岗',
          r3r: '7×24 值守一线',
          r3g: '+50%',
          r3gl: '故障处置效率',
          r3b: '深夜巡检与值守压力大，夜间与节假日难保障',
          r3a: '巡检、预警、应急响应全天候在线，知识检索效率提升 70%+',
          st1a: '验收：1-2 个高频场景端到端跑通，成本与效率指标达预期，数据全程不出内网',
          st2a: '验收：多岗位多部门复制成功，标准化方案成型，准确率与服务稳定性达标',
          st3a: '验收：全企业覆盖，数据飞轮持续运转，AI 能力越用越强',
        },
        sol3: {
          tag: 'SOLUTION 03',
          name: '数字导览员 · 文博景区展厅',
          pos: '专属 IP 讲好文化故事——面向文博场馆、景区与展厅的数字导览方案，不是替代讲解员，而是 7×24 小时在线的专属文化导游。',
          tagsLabel: '核心功能',
          t1: '专属 IP 定制',
          t2: '位置触发讲解',
          t3: '大模型语音问答',
          t4: '个性化路线规划',
          t5: '运营数据看板',
          t6: 'AR 虚实融合',
          p1: '专业讲解员年均成本 8-15 万元/人，旺季排队超 30 分钟，淡季人力闲置',
          p2: '传统语音导览「背课文」式输出，无法回答个性化提问，儿童、老人、外国游客需求难满足',
          p3: '人工讲解仅覆盖开放时段，夜间与闭馆日无法服务，偏远展区覆盖不足',
          p4: '游客关注点、停留时长、高频问题无法采集，运营决策缺乏依据',
          v1: '专属文化 IP 数字人，一馆一面，7×24 小时在线',
          v2: 'AR + 数字人虚实融合导览，游客停留时长提升 40% 以上',
          v3: '全链路运营数据看板，游客行为沉淀为运营资产',
          v4: '蓝牙定位 / 小程序 / AR / 32 寸一体机四种部署模式，标准功能最快 7 天上线',
          s1n: '60-70%',
          s1l: '人工讲解成本降低',
          s2n: '+28%',
          s2l: '二次消费转化',
          s3n: '92%+',
          s3l: '游客满意度',
          s4n: '7×24小时',
          s4l: '全天候导览服务',
          crumb: '解决方案 · AI数字导览员',
          bf1: '数字人互动讲解，多语言多语种导览',
          bf2: 'AR 导览，虚实结合的沉浸式体验',
          bf3: '杜甫草堂等标杆场馆落地经验',
          bf4: '自定义导览路线和讲解内容',
          bf5: '提升游客体验，减轻讲解员压力',
          bc1t: '蓝牙定位导览',
          bc1d: 'Beacon 信标 1-3 米精度，走到哪讲到哪，即贴即用',
          bc2t: '小程序扫码导览',
          bc2d: '微信扫一扫即唤醒，零门槛接入',
          bc3t: 'AR 虚实融合',
          bc3d: 'AR 眼镜/手机 AR，文物 3D 复原、历史场景叠加',
          bc4t: '移动屏一体机',
          bc4d: '32 寸可移动终端，接待/互动/引导/翻译/讲解一体',
          st1n: '展项梳理',
          st1d: '2 周',
          st2n: 'AR 内容制作',
          st2d: '2-3 周',
          st3n: '联调测试',
          st3d: '1 周',
          st4n: '试运营',
          st4d: '2 周',
          st5n: '正式开放',
          st5d: '持续运营',
          c1: '杜甫草堂：年接待 720 万人次，「杜甫数字人」入选国家 2025 文旅数字化创新示范案例',
          c2: '大同花木兰：入选山西文博会十大典型案例',
          c3: '瑷珲历史陈列馆：历史人物数字人讲解，让文化遗产「活」起来',
          f1t: '专属数字人 IP 定制',
          f1d: '基于景区文化基因打造专属数字人，3D 超写实、卡通、历史人物等多种风格可选，一馆一面讲好专属文化故事。',
          f2t: '智能位置触发讲解',
          f2d: '蓝牙 5.0 信标 + GPS 双模定位，精度 1-3 米，即贴即用、续航 12 个月，走到哪讲到哪，分龄分兴趣自适应。',
          f3t: '大模型语音问答',
          f3d: '景区专属知识库支撑自由对话，中英法俄等多语言实时翻译——不是预录音，是真 AI 交互。',
          f4t: '个性化路线规划',
          f4d: '按时间、兴趣、体力生成最优游览路线，智能避峰并推荐餐饮、文创等二消点位。',
          f5t: '运营数据看板',
          f5d: '热度图、停留时长、高频问题、满意度全可视化，游客数据沉淀为运营资产。',
          f6t: 'AR 虚实融合导览',
          f6d: 'AR 眼镜与手机 AR 双端支持，文物 3D 复原、历史场景叠加，带来沉浸式体验。',
          loopTitle: '核心逻辑：讲解 + 交互 + 数据 + 运营一体化闭环',
          loopSub: '以 AI 数字人为入口构建智慧导览体系，游客行为沉淀为运营资产',
          l1n: '智能讲解',
          l1d: '位置触发、分龄分兴趣自适应，走到哪讲到哪',
          l2n: '自由交互',
          l2d: '大模型语音问答、多语言实时翻译，千人千面个性化响应',
          l3n: '数据沉淀',
          l3d: '停留时长、高频问题、热度图全链路采集',
          l4n: '运营优化',
          l4d: '看板驱动展陈优化与精准营销，反哺讲解体验持续升级',
          ledgerTitle: '场馆账本 · 可量化的价值回报',
          ledgerSub: '降本、增效、增收、提质——每个价值点都有数据支撑',
          b1n: '60-70%',
          b1d: '人工讲解成本降低，年均运维仅为人工团队 1/5',
          b2n: '+28%',
          b2d: '二次消费转化率提升，文创餐饮收入显著增长',
          b3n: '92%+',
          b3d: '游客满意度稳定，停留时长提升 40% 以上',
          b4n: '6-12个月',
          b4d: '标准单馆项目投资回收期',
          ledgerNote: '数据来源：敦煌研究院、故宫博物院、河南博物院等项目公开运营数据整理。三种灵活报价模式：一次性买断+年度运维（13-75 万）/ SaaS 订阅制（3-15 万/年）/ 联合运营分成制（零部署费，二消流水分成），6-12 个月投资回收。',
          rolesTitle: '一个数字讲解员，每种游客都被照顾好',
          rolesSub: '统一讲稿曾让儿童、老人和外国游客无所适从，现在讲解因人而异',
          r1n: '儿童与家庭游客',
          r1r: '小小探索者',
          r1g: '63%',
          r1gl: '文化知识即时吸收率',
          r1b: '「背课文」式讲解孩子听不懂、没兴趣，看完就忘',
          r1a: '卡通化语言讲故事、分龄讲解，孩子主动追问文物背后的故事',
          r2n: '外国游客',
          r2r: '国际访客',
          r2g: '中英法俄等',
          r2gl: '多语言实时互译',
          r2b: '讲解语种有限，只能靠翻译软件，体验差、看不懂',
          r2a: '母语界面与语音问答零障碍，走到哪讲到哪',
          r3n: '专业研究者',
          r3r: '深度知识访客',
          r3g: '+40%',
          r3gl: '游客平均停留时长',
          r3b: '统一讲稿满足不了深度追问，文物知识吸收率低',
          r3a: '专属知识库支撑多轮追问，考古细节与工艺纹样深度解锁',
          st1a: '验收：展项清单与知识库内容确认完成',
          st2a: '验收：数字人形象与 AR 内容通过风格与准确性审核',
          st3a: '验收：定位精度 1-3 米，问答准确率与系统稳定性达标',
          st4a: '验收：试运营期间游客满意度与系统稳定性达标',
          st5a: '验收：正式开放，持续运营与数据复盘机制就位',
        },
        sol5: {
          tag: 'SOLUTION 05',
          name: '智能终端 · 小星盒子与蜜蜜盒子',
          pos: '依托自研私有化数字人平台的双硬件终端矩阵，一套引擎覆盖政企研学批量采购与全家庭长效陪伴。',
          tagsLabel: '终端与能力',
          t1: '小星盒子 · 便携 AI 终端',
          t2: '蜜蜜盒子 · 裸眼 3D 全息',
          t3: '中华书局国风 IP 库',
          t4: '多方言语音交互',
          t5: '私有化部署',
          t6: '养老看护与家庭陪伴',
          t7: '硬件管理平台',
          t8: 'OTA 远程升级',
          p1: '数据安全合规要求高，公有云方案难以落地',
          p2: '硬件与内容重复开发，成本高、周期长，IP 资产无法复用',
          p3: '单一场景终端难以覆盖户外研学与居家陪伴全周期',
          p4: '内容安全不可控，儿童与老人场景对不良内容零容忍',
          v1: '一套数字人引擎双终端复用，IP 资产无需重复开发',
          v2: 'Serverless 弹性算力架构，算力成本降至行业 1/10，研发效率提升 10 倍',
          v3: '自研实时对口型技术，服务成本降低 75%',
          v4: '渠道分层覆盖：小星盒子走规模，蜜蜜盒子拉高客单，户外+居家生态互补',
          s1n: '200元内',
          s1l: '小星盒子硬件成本',
          s2n: '75%',
          s2l: '服务成本降低',
          s3n: '50+',
          s3l: '政企客户验证',
          s4n: '3000元内',
          s4l: '蜜蜜盒子硬件成本',
          crumb: '产品中心 · 智能终端',
          bf1: '小星盒子：普惠轻量终端，专为儿童教育与研学场景设计',
          bf2: '蜜蜜盒子：高端全息终端，专注家庭陪伴与养老看护',
          bf3: '一套自研数字人引擎，双终端复用，一次制作多端发布',
          bf4: '私有化部署，数据不出内网，满足等保及政务安全要求',
          bf5: '中华书局国风 IP 库独家授权，全年龄段内容生态',
          bc1t: '小星盒子 · 中华先贤',
          bc1d: '内置孔子/李白/杜甫等先贤形象，传统文化知识库深度问答',
          bc2t: '小星盒子 · 花木兰',
          bc2d: '城市文化 IP 定制，文旅推介/多语种服务/互动拍照',
          bc3t: '蜜蜜盒子 · 家人数字人',
          bc3d: '真人照片重建家人全息数字人，远程亲情互动',
          bc4t: '全场景内容风控',
          bc4d: '智能过滤幻觉与不良内容，老人孩子放心用',
          st1n: '模式选择',
          st1d: '直客定制 / 渠道标准化',
          st2n: 'IP 与内容定制',
          st2d: '2-4 周',
          st3n: '硬件联调部署',
          st3d: '1-2 周',
          st4n: '批量交付运营',
          st4d: '硬件 + SaaS 订阅',
          c1: '某地铁智能客服：站内智能引导与咨询服务终端',
          c2: '南京科利华中学等多所学校：持续续费，验证客户粘性',
          c3: '中版集团等世界 500 强企业：内部智能问答终端',
          c4: '某国有大行北京分行：智能化、高效率的金融服务窗口',
          f1t: '小星盒子 · 便携 AI 终端',
          f1d: '锂电便携设计，可随身佩戴或嵌入玩具作为 AI 机芯；依托云端 AI 推理低延迟交互，海量 IP 角色库，硬件成本 200 元以内，适合批量采购。',
          f2t: '蜜蜜盒子 · 裸眼 3D 全息',
          f2d: '专利光学膜组呈现悬浮立体人像，高清裸眼 3D 全息大屏；真人照片即可重建家人专属数字人，内置高性能 NPU 支持本地离线算力。',
          f3t: '独居老人智能看护',
          f3d: '听觉感知模块实时识别老人跌倒并自动报警推送子女手机，支持健康咨询、远程全息通话与一键求助。',
          f4t: '中华书局国风 IP 库',
          f4d: '独家中华先贤、国风数字人 IP 授权，一套 IP 双终端复用，无需重复开发。',
          f5t: '私有化平台底座',
          f5d: '数据不出内网，满足等保与政务数据安全要求，内置内容风控阻断幻觉与不良内容。',
          f6t: '多模态语音交互',
          f6d: '多方言识别、智能环境降噪、多轮对话，与火山引擎、阿里云深度协同。',
          f7t: '硬件管理平台',
          f7d: '设备统一管理、状态远程监控、内容远程下发、OTA 自动升级与故障告警，规模化部署无忧。',
          f8t: '双轮驱动商业模式',
          f8d: '直客定制（私有化平台+批量终端定制，数十万至百万级）与渠道标准化（标准硬件+SaaS 订阅，3-20 万开箱即用）双轨并行。',
          ledgerTitle: '技术底座账本 · 一套引擎双终端复用',
          ledgerSub: 'Serverless 弹性算力 + 自研实时对口型，成本与效率全面领先',
          b1n: '1/10',
          b1d: '算力成本降至行业十分之一',
          b2n: '75%',
          b2d: '自研实时对口型技术，服务成本大幅降低',
          b3n: '10倍',
          b3d: '研发效率提升，拥有 6 项核心发明专利',
          b4n: '50+',
          b4d: '政企客户验证，覆盖交通、金融、文旅、能源、教育',
          ledgerNote: '盈利体系：硬件销售 + SaaS 订阅 + 定制开发三元驱动——小星盒子 200 元内走量，蜜蜜盒子 3000 元内主打高端家庭，数字人内容与功能持续订阅。',
          loopTitle: '协同价值：构建完整数字人终端生态',
          loopSub: '渠道分层 × IP 复用 × 场景互补——双终端不是两款孤立产品，而是一套生态',
          l1n: '渠道分层覆盖',
          l1d: '中小文旅、学校采购小星盒子走规模；高端家庭、养老机构落地蜜蜜盒子拉高客单',
          l2n: 'IP 资产复用降本',
          l2d: '同一套先贤、国风 IP 同步适配两款终端，无需重复开发，大幅降低制作与运营成本',
          l3n: '场景互补完整生态',
          l3d: '小星盒子适配户外研学与随身场景，蜜蜜盒子主打居家长期陪伴，户外+居家互补',
          l4n: '持续订阅收益',
          l4d: '硬件出货之外，数字人内容与功能 SaaS 持续订阅，客户生命周期价值不断延展',
          st1a: '验收：交付模式（直客定制 / 渠道标准化）与目标场景确认',
          st2a: '验收：专属 IP 形象与知识库内容确认通过',
          st3a: '验收：硬件联调完成，在线与离线交互稳定达标',
          st4a: '验收：批量交付完成，内容订阅与运维机制正常运转',
        },
        sol4: {
          tag: 'SOLUTION 04',
          name: '数字老板 · 中小商户',
          pos: '一个智能体搞定询盘报价——面向中小商户的轻量级数字老板方案，接待、报价、跟单、沉淀一个不漏，数字人是员工不是花瓶。',
          tagsLabel: '核心功能',
          t1: '7×24 在线',
          t2: '多语种交互',
          t3: '极速报价',
          t4: '客户管理',
          t5: 'WhatsApp 接入',
          t6: '本地化适配',
          t7: 'AI 直播带货',
          t8: '硬件双形态',
          p1: '海外时差导致询盘响应慢，深夜与节假日的询盘无人承接',
          p2: '多语种沟通成本高，外商母语接待难',
          p3: '人工报价效率低，翻册查价易出错、易丢单',
          p4: '客户随业务员流动而流失，报价与跟进记录无法沉淀',
          v1: '7×24 不打烊智能外贸助手，夜间成交提升 30%',
          v2: '30+ 语种实时交互，双语同屏，秒级报价',
          v3: 'WhatsApp 接入，本地化运营',
          v4: '客户资产全部沉淀在企业系统，人走客户不走',
          s1n: '7×24',
          s1l: '全天候在线',
          s2n: '30+',
          s2l: '语种实时切换',
          s3n: '300%+',
          s3l: '接单效率提升',
          s4n: '2万内',
          s4l: '单店投入门槛',
          crumb: '解决方案 · AI数字老板',
          bf1: '多语种自动接待，服务全球客商',
          bf2: '产品介绍+价格咨询+下单引导一体化',
          bf3: '低成本快速部署，无需专业技术人员',
          bf4: '7×24 小时不间断营业，不错过任何客户',
          bf5: '支持微信小程序等轻量端接入',
          bc1t: '多语种实时沟通',
          bc1d: '30+ 语种双语同屏，外商母语操作无障碍',
          bc2t: '24 小时智能客服',
          bc2d: '夜间自动回复询价与库存，引导留资',
          bc3t: 'AI 数字人直播',
          bc3d: '克隆商户形象声音，7×24 不间断带货',
          bc4t: '智能接待与推介',
          bc4d: '人体感应主动迎宾，商品图册+电子名片',
          st1n: '需求沟通',
          st1d: '1 周',
          st2n: '知识库与报价配置',
          st2d: '1-2 周',
          st3n: '渠道接入联调',
          st3d: '1 周',
          st4n: '上线运营',
          st4d: '持续优化',
          c1: '某涂料行业标杆客户：WhatsApp 多语种智能体 7×24 在线，印度等海外市场本地化适配',
          c2: '义乌商户：深夜 5 轮 AI 对话，拿下 2200 万美元中东大单',
          c3: '义乌 23 家档口试点：营销成本 -58%，出口额 +52%',
          f1t: '7×24 全天候在线',
          f1d: '跨时区询盘秒级响应，深夜与节假日照常接待，自动回复询价与库存、引导留资，夜间成交提升 30%。',
          f2t: '30+ 语种实时交互',
          f2d: '30+ 语种界面级切换、双语同屏显示，外商母语操作无障碍，与全球客户沟通零障碍。',
          f3t: '极速智能报价',
          f3d: '询盘即报价，秒级生成专业报价单，告别人工核算的等待与出错。',
          f4t: '客户关系管理',
          f4d: '询盘、报价、跟进记录全程沉淀，客户资产不再随人员流动而流失。',
          f5t: 'WhatsApp 深度接入',
          f5d: '客户在哪里，服务就在哪里，海外主流沟通渠道一站式打通。',
          f6t: '本地化运营适配',
          f6d: '贴合目标市场的语言习惯与商业文化，让出海服务更接地气。',
          f7t: 'AI 数字人直播',
          f7d: '克隆商户形象与声音，7×24 小时不间断直播带货，低成本高稳定，多平台推流。',
          f8t: '业务复盘与经营简报',
          f8d: '每日自动推送询盘、转化与客户分层，手机端 1 分钟掌握生意动态。',
          f9t: '硬件矩阵 · 双形态终端',
          f9d: '入门款 32 寸移动屏即插即用，档口接待/展会巡展/门店迎宾；旗舰款 43 寸光场 3D 屏，178° 裸眼 3D 震撼可视，高端档口首选。',
          loopTitle: '核心逻辑：从询盘到沉淀的接单闭环',
          loopSub: '视频把人引来，数字老板把人接住——接待、报价、跟单、沉淀一个不漏',
          l1n: '询盘接待',
          l1d: '7×24 多语种秒级响应，深夜与时差时段的询盘一个不漏',
          l2n: '智能报价',
          l2d: 'AI 3 秒生成精准专业报价单，告别翻册查价的人工核算',
          l3n: '自动跟单',
          l3d: '按 SOP 自动推进跟进，人睡觉时机器在跟进，决策期内持续触达',
          l4n: '客户沉淀',
          l4d: '客户资产全部沉淀在企业系统，人走客户不走',
          ledgerTitle: '单店账本 · 一笔账算清楚值不值',
          ledgerSub: '以年营收 150 万元批发档口、净利率 15% 保守测算',
          b1n: '+12万',
          b1d: '夜间与时差询盘承接（年增营收）',
          b2n: '+15万',
          b2d: '30+ 语种客户拓展，营收增长约 10%',
          b3n: '+4.5万',
          b3d: '客户档案系统化，复购率从 20% 提升到 25%',
          b4n: '≈4.7万',
          b4d: '合计年增利润；首年投入不到 2 万，约 5 个月回本',
          ledgerNote: '口径说明：先正推营收增量，再统一按 15% 净利率折算利润，避免场景重叠重复计算；内容制作与人力成本节省 8-15 万/年未计入。三种灵活报价：硬件买断（2 万内，次年运维 3000-5000 元）/ 托管订阅（999 元/月）/ 结果付费（按有效询盘与直播时长计费），支持 7 天免费测试，看到效果再付费。',
          st1a: '验收：目标市场与核心场景确认，商品与报价资料齐备',
          st2a: '验收：知识库问答准确，报价单秒级生成无差错',
          st3a: '验收：WhatsApp 等渠道收发全链路跑通，多语种翻译验证通过',
          st4a: '验收：7×24 自动接待稳定运行，询盘留资与成交数据可复盘',
        },
        cta: {
          title: '不确定哪个方案适合您？',
          desc: '预约一对一演示，解决方案专家将根据您的行业与业务场景，量身定制数字化转型路径。',
          btn1: '预约演示',
          btn2: '免费体验',
        },
      },
      caseCenter: {
        banner: {
          label: 'CASES',
          title: '标杆客户案例',
          sub: '已服务文旅、零售、金融、教育、政企、媒体等50+标杆客户，覆盖数字人全场景落地',
          btn1: '预约演示',
          btn2: '免费体验',
          metricsLabel: '核心数据 · KEY METRICS',
          m1n: '50+',
          m1t: '标杆客户',
          m1d: '覆盖文旅/零售/金融/教育/政企/媒体',
          m2n: '8大',
          m2t: '覆盖行业',
          m2d: '文博/政务/零售/教育等全场景落地',
          m3n: '6大',
          m3t: '落地场景',
          m3d: '导览/客服/营销/教学等数字人场景',
          m4n: '99%',
          m4t: '客户满意度',
          m4d: '交付质量与运维服务保障',
          tagsLabel: '覆盖行业 · INDUSTRIES',
          t1: '文旅展馆',
          t2: '城市文化',
          t3: '轨道交通',
          t4: '体育场馆',
          t5: '智慧教育',
          t6: '出版传媒',
          t7: '金融银行',
          t8: '零售门店',
          g1: '全流程交付陪伴',
          g2: '7×24小时运维响应',
          g3: '支持私有化部署',
          g4: '效果可量化可审计'
        },
        cases: {
          c1tag: '零售门店',
          c1n: '某家居零售连锁品牌',
          c1s: '数字店长：企业展厅Q版数字人，产品讲解+互动问答，重塑门店接待体验',
          c1v1: '8%-30%',
          c1l1: '营收增长区间',
          c2tag: '文旅展馆',
          c2n: '杜甫草堂博物馆',
          c2s: '李白、杜甫数字人互动讲解，多语言诗词问答，让千年诗圣"活"在展馆',
          c2v1: '+60%',
          c2l1: '游客停留时长提升',
          c3tag: '城市文化',
          c3n: '大同市 · 木兰文化',
          c3s: '花木兰数字人城市代言人，历史文化互动讲解，打造城市文化新名片',
          c3v1: '+40%',
          c3l1: '游客打卡率提升',
          c4tag: '轨道交通',
          c4n: '某地铁 · 智能客服',
          c4s: '交通数字员工：智能导乘+文旅推介+多语种服务+工单流转，多渠道全域触达',
          c4v1: '65%+',
          c4l1: '站内人工咨询分流',
          c4v2: '90%+',
          c4l2: '外籍游客响应效率提升',
          c5tag: '体育场馆',
          c5n: '北京工人体育场',
          c5s: '场馆智能导览：赛事信息互动查询，赛事日大客流服务智能保障',
          c5v1: '5万+',
          c5l1: '赛事日单场服务观众',
          c6tag: '智慧教育',
          c6n: '科利华中学',
          c6s: '历史名人数字人进课堂+高校展厅数字人，AI融合教学双场景落地',
          c6v1: '3年',
          c6l1: '期高校合作项目',
          c6v2: '示范项目',
          c6l2: '教育局智慧校园建设',
          c7tag: '文化出版',
          c7n: '中华书局 · 国家级文化出版机构',
          c7s: '15位中华先贤数字人+古籍OCR智能修复系统',
          c7v1: '5000+',
          c7l1: '活动现场互动人次',
          c7v2: '100万+',
          c7l2: '社交媒体传播量',
          c8tag: '金融 · 银行',
          c8n: '某金融行业标杆客户',
          c8s: '数字员工：链博会展台数字人讲解员，供应链金融/跨境服务/数字金融/绿色金融咨询，中英法俄等多语言讲解',
          c8v1: '7400',
          c8l1: '展会单日对话峰值（次）',
          c9tag: '文旅展馆',
          c9n: '瑷珲历史博物馆 · 萨布素',
          c9s: '萨布素将军数字人讲解，历史文化互动问答，沉浸式参观体验',
          c9v1: '首位',
          c9l1: '瑷珲历史名人数字讲解员'
        },
        logos: {
          label: 'TRUSTED BY INDUSTRY LEADERS',
          titlePre: '已服务',
          titleAccent: '50+',
          titlePost: '标杆客户的共同选择',
          l1n: '某金融行业标杆客户',
          l1i: '金融 · 银行',
          l2n: '杜甫草堂博物馆',
          l2i: '文旅 · 博物馆',
          l3n: '某轨道交通标杆客户',
          l3i: '交通 · 轨道交通',
          l4n: '中华书局',
          l4i: '文化 · 出版',
          l5n: '大同市 · 木兰文化',
          l5i: '文旅 · 历史文化',
          l6n: '惠州市 · 东坡文化',
          l6i: '文旅 · 历史名人',
          l7n: '北京工人体育场',
          l7i: '体育 · 场馆',
          l8n: '科利华中学',
          l8i: '教育 · 中学',
          l9n: '邵阳学院',
          l9i: '教育 · 高校',
          l10n: '瑷珲历史博物馆 · 萨布素',
          l10i: '文旅 · 历史文化'
        },
        cta: {
          title: '让您的品牌拥有专属数字人',
          desc: '从形象定制、知识库搭建到终端部署，一站式交付可立即投入使用的数字人方案，下一个标杆案例就是您。',
          btn1: '预约演示',
          btn2: '免费体验'
        }
      },
      techCenter: {
        banner: {
          label: 'TECHNOLOGY',
          titlePre: '全栈自研',
          titleAccent: '技术底座',
          desc: '大模型 + Agent + Serverless，从感知到决策到执行的全链路技术能力，为企业级AI应用打造坚实的技术底座。',
          demo: '预约演示',
          trial: '免费体验',
          imageAlt: '星汉未来全栈技术架构图'
        },
        chain: {
          label: 'TECH CHAIN',
          title: '全链路技术链路',
          sub: '从语音感知到智能决策再到形象执行，五大环节环环相扣，支撑自然流畅的人机交互体验。',
          f1t: '语音识别 ASR',
          f1d: '多语言、多方言精准识别',
          f2t: '语义理解 NLU',
          f2d: '意图识别、多轮对话管理',
          f3t: '智能决策',
          f3d: '大模型推理、多智能体协作',
          f4t: '语音合成 TTS',
          f4d: '情感化语音表达',
          f5t: '虚拟人驱动',
          f5d: '2D / 3D / Q版渲染',
          m1v: '低延时',
          m1l: '交互响应速度',
          m2v: '50+',
          m2l: '并发对话路数',
          m3v: '2K',
          m3l: '超清拟真画质'
        },
        platform: {
          label: 'PLATFORM',
          title: '平台底座三大能力',
          sub: '以平台化能力沉淀技术底座，让企业AI应用交付更安全、更懂业务、更具品牌辨识度。',
          pf1n: 'PLATFORM 01',
          pf1t: '安全私有化',
          pf1d: '支持私有化与云端双模式部署，数据隔离与权限管理按需配置，保障企业数据资产安全。',
          pf2n: 'PLATFORM 02',
          pf2t: '懂业务',
          pf2d: '融合多款国产大模型，企业知识库RAG增强，深度理解行业业务场景，交付可直接使用的业务结果。',
          pf3n: 'PLATFORM 03',
          pf3t: '专属品牌IP',
          pf3d: '3D写实高保真、2.5D真人级复刻数字人形象，自研口型同步技术，一次制作多终端发布。'
        },
        core: {
          label: 'CORE TECHNOLOGY',
          title: '五大核心技术',
          sub: '覆盖模型、算力、运维、成本与生态的全栈自研技术体系，支撑企业AI应用规模化落地。',
          c1t: '大模型 + Agent',
          c1d: '智能体按需编排，复杂任务自动拆解、协同执行，多源交叉验证保障结果可靠。',
          c2t: 'Serverless',
          c2d: '弹性伸缩、按需付费、秒级扩容，让企业专注业务创新而非基础设施。',
          c3t: '智能运维',
          c3d: 'AIOps故障预测与自愈，全链路可观测，保障系统持续稳定运行。',
          c4t: 'FinOps',
          c4d: '成本可视化与优化建议，持续提升资源利用率，让每一分算力投入都有回报。',
          c5t: 'AI应用市场',
          c5d: '开箱即用的行业智能体应用生态，加速企业AI能力规模化落地。'
        },
        patents: {
          label: 'QUALIFICATIONS',
          title: '专利与资质',
          sub: '核心技术全部自研，已获国家授权发明专利与多项软件著作权，知识产权体系完善。',
          patentn: '6项',
          patentt: '国家授权发明专利',
          patentd: '覆盖资源调度、性能压测、跨云数据流转等云原生与AI基础设施核心领域。',
          patenti1: '精准度量',
          patenti2: '算力共享池',
          patenti3: '快速规格压测',
          patenti4: '快速流量压测',
          patenti5: '跨云数据物流',
          softn: '8项',
          softt: '软件著作权',
          softd: '自主平台与核心引擎软件著作权，构筑完整的产品知识产权壁垒。',
          softi1: 'AIPilot大模型应用平台',
          softi2: 'InfraPilot Serverless平台',
          softi3: '数据物流引擎'
        },
        security: {
          label: 'SECURITY',
          title: '信息安全体系',
          sub: '从合规认证到加密算法，从数据边界到权限管控，构建企业级信息安全防线。',
          s1t: '等保三级合规',
          s1d: '通过国家信息安全等级保护三级认证',
          s2t: '国密算法加密',
          s2d: '采用国密算法对数据全程加密',
          s3t: '数据不出域',
          s3d: '私有化部署保障数据留在企业内网',
          s4t: '租户隔离与权限管理',
          s4d: '多租户数据隔离，细粒度权限管控'
        },
        cta: {
          bannerTitle: '让全栈自研技术为您的业务赋能',
          bannerDesc: '无论是私有化部署还是云端服务，我们都能为您提供安全、稳定、可扩展的AI技术底座，欢迎预约演示深入了解。',
          bannerBtn1: '预约演示',
          bannerBtn2: '免费体验'
        }
      },
      aboutCenter: {
        banner: {
          label: 'ABOUT US',
          title: '关于星汉未来',
          sub: '专注AI数字人技术，让每个企业都拥有自己的数字员工'
        },
        intro: {
          label: 'COMPANY PROFILE · 公司简介',
          title: '让AI技术真正落地到企业真实业务场景',
          p1: '星汉未来是一家专注于AI数字人、数字员工、数字人导览等企业级解决方案的科技公司，融合多国产大模型与多智能体架构，致力于让AI技术真正落地到企业真实业务场景。',
          p2: '核心团队来自头部互联网公司与AI实验室，已服务文旅、零售、金融、教育、政企等行业的50+标杆客户，以稳定可靠的交付能力赢得长期信赖。',
          indTitle: '服务行业',
          ind1: '文旅',
          ind2: '零售',
          ind3: '金融',
          ind4: '教育',
          ind5: '政企',
          imgAlt: '星汉未来AI数字人形象'
        },
        structure: {
          label: 'DUAL ENTITY · 双主体架构',
          title: '双主体协同架构',
          sub: '技术研发与商业化双轮驱动，既保障底层技术持续创新，也保障项目高质量交付与长期运营。',
          s1tag: '技术研发主体',
          s1name: '星汉未来',
          s1desc: '专注AI数字人底层技术研究与产品创新，构建核心技术壁垒。',
          s1i1: 'AI数字人底层技术',
          s1i2: '大模型研发与融合',
          s1i3: 'AR交互技术',
          s2tag: '商业化主体',
          s2name: '星汉弄潮',
          s2desc: '面向政企客户的商业化落地，覆盖从商务拓展到长期运营的全周期服务。',
          s2i1: '政企客户拓展',
          s2i2: '项目交付实施',
          s2i3: '运营服务支持'
        },
        history: {
          label: 'MILESTONES · 发展历程',
          title: '发展历程',
          sub: '从教育场景起步，到文博文旅深耕，再到数字人产品化，星汉未来持续进化。',
          y1: '2024',
          y1t: '教育起步',
          y1d: '从教育场景切入，落地AI数字人助教与互动教学应用，完成产品雏形与市场验证。',
          y2: '2025',
          y2t: '文博深耕',
          y2d: '深耕文博文旅场景，打造数字人导览与AR交互标杆项目，沉淀行业Know-how与交付方法论。',
          y3: '2026',
          y3t: '数字人产品化',
          y3d: '推出标准化数字人SaaS产品与场景化解决方案矩阵，开启企业级规模化交付。'
        },
        stats: {
          s1v: '500+',
          s1l: '数字人角色库',
          s2v: '90%+',
          s2l: '制作成本降低',
          s3v: '50+',
          s3l: '标杆客户',
          s4v: '6项',
          s4l: '发明专利'
        },
        team: {
          label: 'CORE TEAM · 核心团队',
          title: '来自头部互联网公司的核心团队',
          desc: '核心团队来自微博、字节跳动等头部互联网企业与AI实验室，兼具深厚的技术研发功底与大规模商业化落地经验，懂技术，更懂企业真实业务。',
          srcTitle: '团队来源',
          src1: '微博',
          src2: '字节跳动',
          src3: '头部AI实验室',
          capTitle: '核心能力矩阵',
          cap1: '3D数字人建模与驱动',
          cap2: 'AI大模型研发与融合',
          cap3: 'AR空间交互',
          cap4: 'SaaS系统研发',
          cap5: '商业化落地与运营'
        },
        ip: {
          label: 'INTELLECTUAL PROPERTY · 知识产权',
          title: '知识产权与资质',
          sub: '核心技术全栈自研，知识产权体系完善，为企业级合作提供坚实保障。',
          i1n: '6项',
          i1t: '国家授权发明专利',
          i1d: '覆盖数字人生成、驱动与交互等核心技术领域。',
          i2n: '8项',
          i2t: '软件著作权',
          i2d: '覆盖数字人SaaS平台与场景化产品矩阵。',
          i3n: '全链路',
          i3t: '数据安全保障体系',
          i3d: '支持私有化部署与数据隔离，全链路保障企业数据资产安全。'
        },
        office: {
          label: 'OFFICES · 办公环境',
          title: '办公环境',
          sub: '北京、杭州双城布局，贴近客户，快速响应。',
          o1tag: '北京总部',
          o1name: '望京凯德茂',
          o1d: '集团总部，承载核心研发、产品设计与运营管理职能。',
          o2tag: '杭州分公司',
          o2name: '黄龙未来中心',
          o2d: '华东区域中心，承载项目交付、客户服务与生态合作职能。'
        },
        contact: {
          label: 'CONTACT · 联系我们',
          title: '联系方式',
          phoneLabel: '商务电话',
          emailLabel: '商务邮箱',
          addrLabel: '公司地址',
          addr: '北京市望京凯德茂903室',
          trialTitle: '免费试用SaaS版',
          trialDesc: '数字人SaaS版现已开放免费试用，注册即可体验数字人创建、知识库配置与多终端发布全流程。',
          demo: '预约演示',
          trial: '免费体验'
        }
      },
      menu: {
        home: '首页',
        products: '产品中心',
        productsOverview: '产品中心',
        cases: '客户案例',
        tech: '技术能力',
        techArch: '数字人技术架构',
        resources: '知识',
        contact: '联系我们',
        interactiveDigitalHumanSaaS: '互动数字人平台(SaaS)',
        interactiveDigitalHumanPrivate: '互动数字人平台(私有化)',
        aiPlatform: 'AI应用平台AIPilot',
        aiHostingPlatform: 'AI托管平台InfraPilot',
        saasServices: 'SaaS服务',
        aiDigitalHuman: 'AI互动数字人',
        aiAppMarket: 'AI应用市场',
        solutions: '解决方案',
        solutionsOverview: '解决方案总览',
        solutionRetail: '数字店长 · 连锁零售',
        solutionGovernment: '数字员工 · 央国企政府',
        solutionMuseum: '数字导览员 · 文博景区',
        solutionMerchant: '数字老板 · 中小商户',
        productTerminal: '智能终端 · 小星盒子',
        operationTrusteeship: '运维托管',
        costOptimization: '成本优化',
        documentation: '资料文档',
        productManual: '产品手册',
        schedulxManual: 'SchedulX产品说明书(PDF)',
        aiPlatformManual: 'AI应用平台AIPilot',
        aiHostingPlatformManual: 'AI托管平台InfraPilot',
        aiDigitalHumanManual: '蜜蜜盒子产品手册',
        whitepapers: '白皮书',
        serverlessWhitepaper: 'Serverless白皮书',
        costOptimizationWhitepaper: 'IT成本优化白皮书',
        devOpsWhitepaper: '运维方案白皮书',
        hybridDeploymentWhitepaper: '在离线混部白皮书',
        about: '关于我们',
        companyProfile: '公司简介',
        news: '最新动态'
        ,
        personal: '个人版',
        more: '更多',
        minijump: '小程序跳转'
      },
      menuDesc: {
        productsOverview: '六大底层能力产品总览',
        solutionsOverview: '四大行业解决方案总览',
        solutionRetail: '永不下线的金牌店长',
        solutionGovernment: '标准化可审计的智能劳动力',
        solutionMuseum: '专属IP讲好文化故事',
        solutionMerchant: '一个智能体搞定询盘报价',
        productTerminal: '口袋级AI数字人设备，随时随地陪伴成长',
        interactiveDigitalHumanSaaS: 'SaaS订阅，开箱即用',
        interactiveDigitalHumanPrivate: '私有化部署，数据不出域',
        personal: '蜜蜜盒子全息数字人一体机',
        techArch: '全栈自研技术底座总览',
        aiDigitalHuman: '在线体验AI互动数字人',
        aiAppMarket: '开箱即用的行业智能体',
        aiPlatform: '大模型应用开发平台',
        aiHostingPlatform: 'Serverless托管平台',
        operationTrusteeship: 'AIOps智能运维托管',
        costOptimization: 'FinOps成本优化方案',
        schedulxManual: '产品说明书PDF下载',
        aiDigitalHumanManual: '蜜蜜盒子使用手册',
        aiPlatformManual: 'AIPilot平台手册',
        aiHostingPlatformManual: 'InfraPilot平台手册',
        serverlessWhitepaper: 'Serverless行业白皮书',
        costOptimizationWhitepaper: 'IT成本优化白皮书',
        devOpsWhitepaper: '运维方案白皮书',
        hybridDeploymentWhitepaper: '在离线混部白皮书',
        companyProfile: '公司介绍与团队',
        news: '最新动态与资讯'
      },
      productAidigitalHuman: {
        title: '星汉未来AI互动数字人平台',
        titleNext: '下一代AI互动数字人平台',
        subtitle1: '基于多项专利技术，打通 AI数字人打造、运营、商业化全链路，让AI数字人成为可复用的数字资产。',
        subtitle1Next: '实时语音对话 · 低成本IP制作 · 多场景智能交互',
        description1: `星汉未来实时交互数字人，基于多项专利技术，以**AI大模型+多智能体架构为数字大脑**，**低成本生成高拟真IP**，全终端即用，

                      **打通"制作-运营-增值"全链路**，

                      让营销、服务、教育等场景即刻拥有可复用、可增长的数字资产。`,
        description1Next: '星汉未来实时交互数字人，基于AI大模型与多智能体架构，支持语音/文字/图像多模态实时交互，低成本打造高拟真IP，广泛适配多终端，赋能IP 运营、文旅、教育等多场景智慧升级。',
        freeTrial: '免费试用(SaaS)',
        downloadEnterprise: '下载客户端(企业版)',
        downloadPersonal: '下载客户端(个人版)',
        downloadCloud: '下载客户端(云算力)',
        contactUs: '联系我们',
        jumpToPersonal: '个人版网站',
      },
      homeAnchor: {
        coreProducts: '核心产品',
        highlightFeatures: '亮点功能',
        patentTech: '专利技术',
        commercialSolutions: '商业化方案'
      },
      homeCore: {
        digitalHumanTitle: 'AI互动数字人平台',
        digitalHumanSubtitle: '提供高拟真、可定制的AI数字人',
        digitalHumanText: '支持智能对话、情感识别与多模态交互。适用于展厅、营销、讲解、教育等多种场景，有效提升用户体验与参与度。AI数字人不仅是形象创新，更是高效生产力工具。',
        learnMore: '了解更多',
        aiPlatformTitle: 'AI应用平台',
        aiPlatformSubtitle: '提供完整开发工具链与开放API',
        aiPlatformText: '支持快速构建、部署AI驱动型应用。支持灵活集成和二次开发，助力企业高效落地定制化AI解决方案。'
      },
      homeHighlight: {
        title: '核心优势',
        ipOperation: 'IP全场景运营',
        ipOperationList: [
          '一套数字人系统无缝应用于客服、直播、营销等多类场景',
          '具备高度复用性与跨行业适配能力',
          '提供从形象设计到运营的一站式服务'
        ],
        completeFeatures: '功能完备',
        completeFeaturesList: [
          '支持语音识别、情感表达、多轮对话',
          '高度可定制的智能体开发平台',
          '支持多种交互模式和业务逻辑',
          '提供从语音识别到情感计算的全栈技术能力'
        ],
        richExpressions: '形象动作丰富',
        richExpressionsList: [
          '支持眨眼、点头、手势，自然流畅',
          '支持数百种基础动作库',
          '可定制专属表情与肢体语言，生动自然',
          '提供丰富的预设形象库，支持个性化定制'
        ],
        powerfulPlatform: '强大的智能体平台',
        powerfulPlatformList: [
          '可定制、可扩展，智能程度高',
          '支持多模型与API对接、自定义智能体',
          '支持多场景适配与升级'
        ],
        fastDelivery: '快速交付',
        fastDeliveryList: [
          '标准化流程和完备的管理后台',
          '项目交付周期可缩短至天级'
        ],
        selfService: '自主交付',
        selfServiceList: [
          '可自行管理、独立配置，提供可视化配置工具',
          '非技术人员也能轻松完成日常运营',
          '支持客户自主管理和维护数字人系统，降低运营成本'
        ],
        easyExpansion: '易扩展',
        easyExpansionList: [
          '模块化设计支持灵活扩展',
          '满足不同场景需求'
        ],
        costEffective: '高性价比',
        costEffectiveList: [
          '单个数字人服务年费最低仅数千元',
          '让各行各业用得起AI数字人',
          '灵活的服务模式，提供高性价比的AI解决方案'
        ],
        patentedTech: '基于专利技术',
        patentedTechList: [
          '依托六项国家发明专利',
          '技术领先性有保障'
        ],
        freeTrial: '免费试用(SaaS)',
        downloadEnterprise: '下载客户端(企业版)',
        downloadPersonal: '下载客户端(个人版)',
        downloadCloud: '下载客户端(云算力)',
        contactUs: '联系我们'
      },
      homePlan: {
        title: '专利技术能力',
        preciseMeasurement: '精准度量',
        computingPool: '算力共享池',
        rapidBenchmark: '快速规格压测',
        trafficTesting: '快速流量压测',
        crossCloudData: '跨云数据物流',
        preciseMeasurementText: [
          '业务决策指标提取',
          '实时精准度量',
          '提高计算机资源调整的便捷性',
          '节约计算资源的使用成本'
        ],
        computingPoolText: [
          '在离线混部',
          '实现对服务集群的动态调度',
          '提升服务集群的资源利用率'
        ],
        rapidBenchmarkText: [
          '快速查找到性能匹配最优的目标服务器',
          '提升软件的运行效率',
          '节约服务器成本'
        ],
        trafficTestingText: [
          '使用线上实时服务的流量对服务器集群进行测试',
          '准确度较高的测试结果',
          '将流量压测活动周期由数月降低到一周以内'
        ],
        crossCloudDataText: [
          '海量数据公网传输',
          '10TB数据10分钟',
          '降低数据迁移成本'
        ]
      },
      homeCase: {
        case_title: "商业化方案",
        case_title_1: "数字IP服务运营",
        case_1_1: "使用对象：文旅部门、品牌方、MCN机构",
        case_1_2: "从形象定位、内容策划到商业变现全托管，助力数字IP指数级增值。",
        case_1_3: "数字IP世界观与故事线设计",
        case_1_4: "提供托管服务",
        case_1_5: "专业运营支持",
        case_1_6: "付费订阅",
        case_btn_1: "免费试用",

        case_title_2: "SaaS订阅服务",
        case_2_1: "使用对象：企事业单位、中小企业",
        case_2_2: "SaaS订阅模式（基础版/专业版/企业版）",
        case_2_3: "按月/年计费灵活选择",
        case_2_4: "定制化服务包",
        case_btn_2: "预约咨询",

        case_title_3: "渠道商合作机制",
        case_3_1: "使用对象：技术服务商、内容运营商、渠道代理商",
        case_3_2: "提供渠道商机制，渠道商可自主定价，共享技术红利，共同服务市场。",
        case_3_3: "互动量越高，优惠越多",
        case_btn_3: "立即体验",
      },
      homePartners: {
        title: '战略合作伙伴',
        subtitle: '携手行业领先企业，共创AI数字人新未来',
        partners: {
          dtkj: '谛听视界',
          yrzn: '匀熵智能'
        }
      },
      becomePartner: {
        title_1_1: '成为渠道商',
        subtitle_1_1: '成为我们的合作伙伴',
        description_1_1: '无论你是技术服务商、渠道商还是内容运营商，我们都欢迎你加入。',
        applyButton: '立即申请合作',
        benefit_1_title: '专属代理政策',
        benefit_2_title: '技术培训支持',
        benefit_3_title: '渠道折扣体系',
        benefit_4_title: '品牌联合推广'
      },
      footer: {
        businessConsult: '商务咨询：',
        emailConsult: '邮件咨询：',
        address: '联系地址：',
        addressDetail: '北京市望京凯德茂903室',
        categories: {
          product: '产品中心',
          saas: 'SaaS服务',
          solutions: '解决方案',
          about: '关于我们'
        },
        links: {
          interactiveDigitalHumanSaaS: '互动数字人平台(SaaS)',
          interactiveDigitalHumanPrivate: '互动数字人平台(私有化)',
          aiPlatform: 'AI应用平台AIPilot',
          aiHostingPlatform: 'AI托管平台InfraPilot',
          aiDigitalHuman: 'AI互动数字人',
          aiAppMarket: 'AI应用市场',
          operationTrusteeship: '运维托管',
          costOptimization: '成本优化',
          companyIntro: '公司介绍',
          contactUs: '联系我们',
          joinUs: '加入我们'
        },
        qr: {
          businessConsult: '商务咨询',
          videoChannel: '微信视频号',
          miniProgram: '微信小程序'
        },
        social: {
          weibo: '星汉未来官微',
          zhihu: '星汉未来官方知乎',
          bilibili: '星汉未来官方B站',
          github: '星汉未来GitHub',
          gitee: '星汉未来Gitee'
        }
      },
      nav: {
        register: '注册',
        login: '登录',
        loginRegister: '登录/注册',
        freeTrial: '免费体验',
        aiAppMarket: 'AI应用市场',
        aiAppHosting: 'AI应用托管',
        backToV1: '返回旧版',
        logout: '退出登录'
      },
      upgrade: {
        guide: '新手引导',
        guideTip: '点击「返回旧版」可随时切回经典版官网。',
        guideKnow: '我知道了'
      },
      productAidigitalHumanRole: {
        featuredTitle: "IP数字人形象展示",
        human_1: "李白",
        human_2: "露娜",
        human_3: "悟空",
        human_4: "清柠Sunny",
        animal_1: "小猫花影",
        animal_2: "萌宝墩",
        human_5: "孙思邈",
        human_6: "孔子",
        human_7: "嫦娥",
        human_8: "露比",
        human_9: "林汐月",
        animal_3: "小鸭豆豆",
        human_10: "艾莉娅星梦",
        human_11: "亘瞳",
        human_12: "霓虹羽",
        human_13: "赤焰",
        human_14: "虹焰",
      },
      coreFeatures: {
        title: '核心功能',
        subtitle: '领先技术架构 ▸ 极致互动体验 ▸ 人机交互新范式',
        feature1: {
          title: '实时语音对话',
          text1: '自然语言交流，支持多语言、方言、多轮对话、对话打断、多模态交互',
          text2: '数百种音色供选择，提供高拟真实时互动体验'
        },
        feature2: {
          title: '低成本数字人制作',
          text1: '数字人制作成本降低 90% 以上，提供数百种预置角色',
          text2: '支持 2K 高清，数十种表情动作'
        },
        feature3: {
          title: '领先的AI智能体与知识库支持',
          text1: '支持复杂意图识别，支持数十种互动模式',
          text2: '支持RAG + 联网搜索 + 自定义知识库，支持记忆与多轮对话'
        }
      },
      verticalIP: {
        title: '垂直IP运营',
        subtitle: '聚焦垂直场景，打造可持续运营、可商业化的数字IP矩阵',
        subtitle2: '多样定制 × 强表现力 × 高效低成本 = 可持续增长的超级数字资产',
        feature1: {
          title: '2D/3D 数字人制作',
          text1: '风格多样：写实、卡通、二次元，随心定制',
          text2: '专业支持：角色设定、声音复刻、自定义知识库',
          text3: '应用广泛：垂直IP、虚拟形象、吉祥物'
        },
        feature2: {
          title: '丰富的动作与表情',
          text1: '丝滑表现：神情-手势-身法完美联动',
          text2: '海量资源：丰富动作库+微表情定制',
          text3: '才艺全开：成语诗词+唱歌跳舞+换装'
        },
        feature3: {
          title: '低成本高效运营',
          text1: '一站式服务：数字人互动、内容运营、商业化',
          text2: '门槛降低：赋能千行百业轻量化运营',
          text3: '专业支持：内容创作、活动策划、运营培训'
        }
      },
      intelligentInteraction: {
        title: '智能体互动',
        subtitle1: '「让AI对话有温度：可定制知识库×趣味互动×开放平台」',
        subtitle2: '「全能AI伙伴：会学习·能玩梗·懂进化」',
        subtitle3: '「教学闯关×营销互动×文化传承：一平台激活全场景智能体」',
        feature1: {
          title: '产品化、易用的知识库',
          text1: '支持自定义知识库，支持知识库白名单',
          text2: '支持角色与团队知识库',
          text3: '支持数百种音色，提供高拟真实时互动体验'
        },
        feature2: {
          title: '丰富多样的互动模式',
          text1: '直播/问卷/闯关/飞花令/成语接龙/教学等多种互动模式',
          text2: '支持文化、营销、教学等多种场景'
        },
        feature3: {
          title: '灵活可扩展的智能体平台',
          text1: '支持多模型与API对接、自定义智能体',
          text2: '支持多场景适配与升级'
        }
      },
      verticalSolutions: {
        title: '垂直行业解决方案',
        subtitle: '深度适配各行业场景，提供专业化解决方案',
        features: {
          business: {
            title: '商业',
            text1: '直播带货，24小时线下虚拟主播',
            text2: '数百种IP均可做主播'
          },
          education: {
            title: '教育',
            text1: 'AI互动体验，校园答疑，AI助教、虚拟讲师、互动课堂',
            text2: '让学习更有趣、更高效'
          },
          cultureMuseum: {
            title: '文博',
            text1: '历史人物复现、文物活化、数字讲解员',
            text2: '让文化遗产"活"起来，提供沉浸式文化体验'
          },
          cultureTravel: {
            title: '文旅',
            text1: '文化IP代言人、景区导览员，全息沉浸式体验',
            text2: '提升游客体验，传播地域文化'
          },
          exhibition: {
            title: '展厅',
            text1: '博物馆、科技馆、展厅等智能导览与互动',
            text2: '打造科技感十足的展示空间'
          },
          companionship: {
            title: '陪伴',
            text1: '家庭陪伴、情感交互、老年关怀、儿童教育伙伴',
            text2: '提供温暖的人工智能陪伴'
          }
        },
        buttons: {
          freeTrial: '免费试用(SaaS)',
          downloadEnterprise: '下载客户端(企业版)',
          downloadPersonal: '下载客户端(个人版)',
          downloadCloud: '下载客户端(云算力)',
          contactUs: '联系我们'
        }
      },
      featuredCases: {
        title: '标杆客户案例',
        list_title_1: '大同木兰数字人',
        list_description_1: '历史名人鲜活呈现，赋能IP打造赢得人心',
        list_sub_title_1: '文旅宣传',
        list_sub_content_1: '线上推广与线下景区互动结合，数字人导览、文化故事讲解、拍照互动，提升文旅传播力。',

        list_title_2: '校园数字人',
        list_description_2: 'AI数字人赋能文教新场景，校园治理与教学智辅融合',
        list_sub_title_2: '校园应用',
        list_sub_content_2: '校园广播、学生日常释疑、德育精髓讲解。提升校园管理效率与互动性。',

        list_title_3: '工体格里奥',
        list_description_3: '赛场数字吉祥物，助燃宣传、解答赛事疑问',
        list_sub_title_3: '赛事服务',
        list_sub_content_3: '实时赛事播报与互动问答，增强观众参与感与智能体验。',

        list_title_4: '瑷珲历史陈列馆',
        list_description_4: '历史文化展馆数字讲解员',
        list_sub_title_4: '文博导览',
        list_sub_content_4: '多语种文物解说与历史重现。互动式参观导览与教育体验。提升文化传播力与观众沉浸感',

        list_title_5: '岭南东坡数字人',
        list_description_5: '历史名人复现赋能文化景区',
        list_sub_title_5: '文化推广',
        list_sub_content_5: '岭南文化宣传结合地方活动，讲解苏东坡与岭南文化，助力地方品牌建设。'
      },
      interactiveDevices: {
        title: '多样互动设备支持',
        subtitle: '全场景覆盖，满足不同行业与场景的高端数字人需求',
        table: {
          productName: '产品名称',
          productDescription: '产品描述'
        },
        devices: {
          mobileScreen: {
            name: '闺蜜机移动屏',
            description: '适合移动场景陪伴与导览'
          },
          cabinetDigitalHuman: {
            name: '立柜式数字人一体机',
            description: '立式一体化设计'
          },
          holographicDigitalHuman: {
            name: '全息数字人一体机',
            description: '裸眼3D全息投影，打造未来感交互体验'
          },
          transparentScreen: {
            name: '透明屏数字人一体机',
            description: '透明屏幕技术，创造未来科技体验'
          },
          aiBuddhaShrine: {
            name: 'AI佛龛机',
            description: '传统文化+AI科技融合，专为宗教/祈福场景定制'
          },
          projectorSolution: {
            name: '投影仪方案',
            description: '大型投影解决方案，大尺寸、沉浸式展示'
          },
          holographicFan: {
            name: '全息风扇方案',
            description: '全天候、无边框、高亮度'
          }
        },
        buttons: {
          freeTrial: '免费试用(SaaS)',
          downloadEnterprise: '下载客户端(企业版)',
          downloadPersonal: '下载客户端(个人版)',
          downloadCloud: '下载客户端(云算力)',
          contactUs: '联系我们'
        }
      },
      productPrivateAidigitalHuman: {
        banner: {
          title_1_1: '企业级数字人私有化部署方案',
          text_1_1: '安全可控',
          text_1_2: '深度定制',
          text_1_3: '灵活扩展',
          button_1_1: '立即获取方案',
          button_1_2: '预约技术演示'
        }
      },
      productPrivateAidigitalHumanProduct: {
        feature: {
          advantage: {
            title_1_1: '全链路数据安全',
            text_1_1: '通过国密算法加密存储,支持GDPR/等保2.0合规,数据不出企业内网',
            title_1_2: '100%企业专属',
            text_1_2: '支持形象/知识库/交互逻辑深度定制,独立部署专属数字人系统',
            title_1_3: '多模式灵活部署',
            text_1_3: '支持本地服务器/私有云/混合云部署,满足不同规模企业需求'
          },
          framework: {
            title_2_1: '应用层',
            text_2_1: '数字人交互界面',
            title_2_2: '能力层',
            text_2_2: 'Al大模型+RAG+Agent引擎',
            title_2_3: '基础设施层',
            text_2_3: '私有化部署环境'
          },
          deploy: {
            title_3_1: '轻量版',
            textArray_3_1_1: '单服务器部署',
            textArray_3_1_2: '支持100并发会话',
            textArray_3_1_3: '适合中小企业',
            title_3_2: '企业版',
            textArray_3_2_1: '分布式集群部署',
            textArray_3_2_2: '支持万级并发会话',
            textArray_3_2_3: '适合大型集团',
            title_3_3: '混合云版',
            textArray_3_3_1: '本地+云端协同',
            textArray_3_3_2: '弹性扩展资源',
            textArray_3_3_3: '适合跨国企业'
          }
        }
      },
      productContrast: {
        title: '私有化部署 vs SaaS版核心差异',
        columns: {
          function: '功能纬度',
          private: '私有化版本',
          saas: 'SaaS版本'
        },
        data: {
          function_1_1: '数据存储',
          private_1_1: '企业自主管理',
          saas_1_1: '云端集中存储',
          function_1_2: '定制权限',
          private_1_2: '源码级开放',
          saas_1_2: '基础功能配置',
          function_1_3: '响应速度',
          private_1_3: '本地毫秒级响应',
          saas_1_3: '云端1-3秒响应',
          function_1_4: '合规性',
          private_1_4: '支持行业特殊认证',
          saas_1_4: '通用合规标准'
        }
      },
      product: {
        sectionTitles: {
          title_1_1: '核心优势',
          title_1_2: '三维技术架构',
          title_1_3: '灵活部署模式'
        }
      },
      productAiPilotBanner: {
        title_1_1: '下一代Serverless技术驱动的',
        title_1_2: '星汉未来AI应用平台——AIPilot',
        description_1_1: '轻松管理不断涌现的AI应用与大模型，统一调度云端及本地的GPU、CPU等计算资源。AIPilot支持大型模型推理，并已对接八家以上大模型厂商API，助力企业快速、高效、低成本的将AI融入多元生产场景。基于众多专利技术，AIPilot能在一台8核16G的笔记本电脑上部署20个热门AI应用，企业只需万元成本，即可构建专属的AI应用引擎。',
        button_1_1: '免费部署'
      },
      productAiPilotWorth: {
        title_1_1: '桌面级生成式AI应用平台',
        description_1_1: '提供丰富的热门AI应用和适配国内主流AI大模型，实现即插即用的便捷体验',
        button_1_1: '免费部署',
        feature: {
          title_1_1: '精选AI应用',
          text_1_1: 'AI应用平台持续更新，涵盖热门AI工具，如知识库、智能客服、BI数据分析、图标设计、PDF内容摘要等多场景应用。支持即装即用，助力团队迅速提升AI办公效率。',
          title_1_2: '多模型支持',
          text_1_2: '通过单一账号，您可以接入多家大型模型供应商的各类模型版本，如文本模型、多模态模型、Embedding模型等。您可以根据实际效果挑选最合适的模型，以实现最佳效果。',
          title_1_3: '多环境支持',
          text_1_3: '支持个人电脑安装，兼容信创电脑及服务器安装。支持WindowOS、MacOS、Linux平台。'
        }
      },
      productAiPilotFeatured: {
        title_1_1: '精选AI应用',
        button_1_1: '免费部署',
        category: {
          title_1_1: '写作助手类',
          title_1_2: '学术教育类',
          title_1_3: '数据分析类',
          title_1_4: '知识库智能体',
          title_1_5: '开源大模型'
        },
        apps: {
          name_1_1: 'AlBot',
          text_1_1: '文档助手，对话问答',
          name_1_2: 'Novel',
          text_1_2: 'Notion风格写作助手',
          name_1_3: 'WordFlow',
          text_1_3: '写作助手、AI翻译、Al提示',
          name_1_4: 'AIAcademic',
          text_1_4: '学术论文写作助手',
          name_1_5: 'AlTutor',
          text_1_5: '全能AI导师，个性化规划课程',
          name_1_6: 'yakGPT',
          text_1_6: '专家角色问答',
          name_1_7: 'DBGPT',
          text_1_7: '可直连数据库的BI分析工具',
          name_1_8: 'ChartGPT',
          text_1_8: '文本转图表',
          name_1_9: 'Dify',
          text_1_9: '轻松构建AI原生应用',
          name_1_10: 'Baichuan-7B',
          text_1_10: '支持中英双语，上下文窗口长度为4096',
          name_1_11: 'Llama2_7B',
          text_1_11: 'Meta发布的大语言模型',
          name_1_12: 'DevOps-Model',
          text_1_12: 'DevOps 生命周期问答'
        },

      },
      productAiPilotPrice: {
        title_1_1: 'AIPilot产品定价',
        about: '约',
        discount: '优惠',
        freeDeployment: '免费部署',
        note_1_1: '注：托管版费用以云服务器实际定价为准',
        plans: {
          title_1_1: '单机部署版',
          title_1_2: '集群部署版',
          title_1_3: '信创一体机',
          title_1_4: '单机托管版',
          title_1_5: '集群托管版'
        },
        features: {
          license: 'License',
          permanentUpgrade: '永久升级',
          users: '用户数',
          users_1_1: '3',
          users_1_2: '100',
          apps: '应用',
          apps_1_1: '10',
          apps_1_2: '50',
          models: '大模型对接',
          models_1_1: '9',
          models_1_2: '9',
          cpu: 'CPU规格',
          cpu_1_1: '8核',
          cpu_1_2: '8核',
          cpu_1_3: '8核*3',
          memory: '内存',
          memory_1_1: '16GB',
          memory_1_2: '16GB',
          memory_1_3: '16GB*3',
          storage: '硬盘',
          storage_1_1: '500G',
          storage_1_2: '500G',
          storage_1_3: '500G*3',
          software: 'AIPilot软件单机版',
          software_1_1: '',
          network: '网络',
          network_1_1: '5Mbps',
          network_1_2: '5Mbps*3',
          validity: '服务器有效期',
          validity_1_1: '1年',
          validity_1_2: '1年'
        }
      },
      productInfraPilotBanner: {
        titleLine1: 'InfraPilot',
        titleLine2: '星汉未来AI托管平台',
        description: '依托多项专利技术，无需改造即可实现AI应用与大模型推理的Serverless化。InfraPilot支持分钟级应用部署、GPU/CPU自动调度、无人化运维以及自动化成本治理。一站式管理企业内各类自研AI应用与大模型，构建高效的AI应用开发及大模型训练推理平台，显著提升研发效率。',
        registerButton: '立即注册体验',
        openSourceButton: '体验开源版',
        deploymentButton: '预约私有化部署'
      },
      productInfraPilotFeature: {
        title_1_1_1: '产品价值',
        feature_title_1_1_1_1: '零改造',
        feature_text_1_1_1_1: '提供无侵入日志采集专利技术，使开发者不受编程语言限制，无需框架适配或代码改造，只需提交Release的代码，即可低成本搭建具备自动扩缩容、按量计费、故障自愈等能力的分布式自治理系统。',
        feature_title_1_1_1_2: '免运维',
        feature_text_1_1_1_2: '实现部署、发布、性能、稳定性治理的全自动化，开发者无需对日志采集、算力规格、算力规模等进行配置，减少90%以上的手工运维、配置、发布等工作。',
        feature_title_1_1_1_3: '低成本',
        feature_text_1_1_1_3: '全流程自动化，基于发明专利的压测技术，自动识别成本最低的算力资源规格，实现高度弹性、按需付费，时刻保持算力资源高利用率，做到云资源成本最优化。',
        registerButton_1_1_1: '立即注册体验',
        deploymentButton_1_1_1: '预约私有化部署'
      },
      productInfraPilotCore: {
        title_1_1: '核心功能',
        feature_title_1_1: '自动部署',
        feature_text_1_1: '开发者只需提交Release的代码，InfraPilot便会自动构建镜像，自动按照模板配置并完成应用部署。',
        feature_title_1_2: '快速压测',
        feature_text_1_2: '评估能让应用稳定运行的最佳规格，保持较高资源利用率。自动配置弹性策略，实现自动弹性伸缩功能。',
        feature_title_1_3: '应用监控',
        feature_text_1_3: '通过监控应用可用性指标，识别故障类型，并及时进行干预，实现故障自治理。',
        feature_title_1_4: '故障自愈',
        feature_text_1_4: '支持重启、降级、回滚、切流量等故障自愈操作，使应用系统实现无需监管的自运转能力。',
        button_experience: '立刻在线体验',
        button_deployment: '预约私有化部署'
      },
      productInfraPilotWhy: {
        title_1_1: '为什么选择星汉未来InfraPilot?',
        feature_title_1_1: '全场景',
        feature_text_1_1: '适用于Web后端服务、音视频、数据处理、物联网等各种场景，无需进行函数化改造、容器和微服务改造，即可低成本部署Serverless平台。',
        feature_title_1_2: '故障自愈',
        feature_text_1_2: '通过提供故障自愈能力，帮助企业轻松构建无需监管的应用系统，不仅能提升系统稳定性，同时还节省了大量人力。',
        feature_title_1_3: '开放中立',
        feature_text_1_3: '自动适配阿里云、华为云、AWS等多个常用云平台，并且支持跨云跨地域快速迁移业务数据，打造开放的业务环境。',
        button_experience: '立刻在线体验',
        button_deployment: '预约私有化部署'
      },
      trusteeshipBanner: {
        title_1_1: '运维托管解决方案',
        description: '基于领先的全链路Serverless技术及丰富的亿级混合云算力大盘治理经验，Galaxy Future推出"混合云算力治理"服务，无需架构改造即可将算力成本降至当前的8折。基础架构托管后，借助免费的Galaxy Future Serverless化改造服务，可将算力成本降至当前价格的7折。',
        button_consult: '预约咨询'
      },
      trusteeshipValue: {
        title_1_1: '方案价值',
        description_1_1: '随着企业数字化业务的不断膨胀，云成本迅速增长，亟需对云上成本进行优化管理。',
        description_1_2: '麦肯锡的一份调查则显示：与单纯利用公有云的方案相比，混合云可以帮助客户提高2.5倍的业务价值，这进一步加强了企业迈向混合云部署的期待。',
        description_2_1: 'Galaxy Future应市场需求，推出运维托管解决方案。',
        description_2_2: '通过提供"混合云托管"、"Serverless托管"等两种模式，全面帮助企业大幅降低IT成本。',
        solution_title: 'Galaxy Future运维托管解决方案',
        hybrid_title: '混合云托管方案',
        hybrid_text: '算力成本降至当前的',
        hybrid_discount: '8',
        hybrid_list_1: '迁移至Galaxy Future混合云平台，结合公有云丰富的产品线和私有云低廉的服务器成本；',
        hybrid_list_2: '无论您月度云消耗是一万，十万，还是一百万，都可让算力成本降至当前的8折。',
        serverless_title: 'Serverless托管方案',
        serverless_text: '算力成本降至当前的',
        serverless_discount: '7',
        serverless_list_1: '迁移至Galaxy Future Serverless平台，实现分钟级应用部署、无人化运维保障、自动化成本治理；',
        serverless_list_2: '一站式管理企业内各类开源、自研、商业化应用，打造智能高效的企业云操作系统，可让算力成本降至当前的7折。',
        service_scope_title: '服务范围',
        service_scope_text: 'Galaxy Future提供综合算力服务，提供独立的VPC，以及虚拟机、容器的算力，服务周期默认为一年，预付费模式，以公有云一年期算力折扣价为价格基准。',
        service_customer_title: '服务客户',
        service_customer_list_1: '采用公有云或者混合云架构的客户；',
        service_customer_list_2: '需要大幅降低IT成本的客户。',
        discount_unit: '折'
      },
      trusteeshipHighlights: {
        title_1_1: '方案亮点功能',
        feature_1_title: '安全性保障',
        feature_1_text: '公有云上资源，为企业提供独立的VPC，保障业务独立性；专有云上，采用标准的虚拟化技术进行租户隔离，可为企业提供独占的物理机资源。',
        feature_2_title: '稳定性保障',
        feature_2_text: '企业也可选择将业务全部托管在Galaxy Future的运维平台，由平台提升保障业务稳定性。',
        feature_3_title: '全托管一站式',
        feature_3_text: '经过充分评估和企业许可，Galaxy Future的专家团队为企业提供一站式业务的改造和迁移；迁移过程中，业务无损，无需停服，实现一站式无缝全托管。',
        button_free: '免费体验'
      },
      relevant: {
        defaultTitle: '相关内容',
        buttonDefault: '查看详情',
        buttonFree: '免费领取',
        products: {
          product_1_title: '云原生智能运维平台SchedulX',
          product_1_text: '具备先进Serverless能力的智能运维平台，通过全自动化部署发布、性能维护、稳定性治理，减少90%以上的运维工作，整体IT成本节省可达60%以上。',
          product_2_title: '一站式企业云成本管家CostPilot',
          product_2_text: '通过对成本的深入洞察，快速生成成本报告，并从多种角度提供定制化成本优化建议，以及一体化的优化功能。',
          product_3_title: '通用Serverless平台InfraPilot',
          product_3_text: '免运维、高可用、按需付费的弹性算力调度平台，帮助各类Web系统零改造实现Serverless化。'
        },
        solutions: {
          plan_1_title: '智能运维解决方案',
          plan_1_text: '基于业务指标精准度量、算力极速调度等核心能力，实现自动化智能运维，降低运维操作门槛，助力企业提升运维效率高达10倍。',
          plan_2_title: '成本优化解决方案',
          plan_2_text: '提供深入成本洞察、精细化算力治理，在维持业务稳定性的前提下，帮助企业降低IT成本高达50%。',
          plan_3_title: '东数西算解决方案',
          plan_3_text: '支持将对网络要求不高的业务数据传输至西部数据中心，减少数据中心投资运营成本，提升数据中心整体效率，更好地赋能业务数字化发展。'
        },
        news: {
          news_1_title: '重磅揭秘！10分钟10TB数据跨云跨地域传输的技术实践',
          news_1_text: '本文详细解读基于云原生技术的海量数据搬迁技术。'
        },
        whitepapers: {
          book_1_title: '成本优化白皮书',
          book_1_text: '以运维负责人视角全面阐释IT资源降本增效的方法，分阶段步骤实现最多70%的成本节省。',
          book_2_title: '智能运维解决方案白皮书',
          book_2_text: '提供云原生时代的新一代 DevOps 工具全景图，打造适配不同体量、不同阶段企业的工程效能及智能运维综合解决方案。'
        },
        others: {
          other_1_title: 'SchedulX 版本更新',
          other_1_text: '在原有快速压测、对象存储、集成管理等功能基础上，新增K8s成本拆分、ECS规格压测、成本周报、成本预算和体检等功能。',
          other_2_title: 'Serverless解决方案',
          other_2_text: '无需关注基础设施或业务容量，便可实现快速部署、按需申请资源等。您只需关注业务开发，实现更高业务价值。'
        }
      },
      planCostBanner: {
        title_1_1: '成本优化解决方案',
        description: '通过成本可视化实现深入成本洞察，并提供精细化的算力治理，在维持业务稳定性的前提下，帮助企业降低IT成本高达50%。',
        button_free: '免费试用'
      },
      planCostFlow: {
        title_line1: '全流程成本管理',
        title_line2: '保障云资源利用率最大化',
        tab_1_title: '成本洞察',
        tab_1_sub: '多云成本可视化，迅速定位优化点',
        tab_1_text: 'Galaxy Future通过多云环境成本数据统一全景展示，帮助您深入全面洞察云上成本，为成本优化提供有力依据，并提供日度、月度、季度、年度成本预测，帮助您合理分配资源。',
        tab_2_title: '算力治理',
        tab_2_sub: '多维度体系化降本，保障稳定性',
        tab_2_text: 'Galaxy Future提供整套算力治理方案，通过多种先进技术手段，从多个维度提高资源利用率、提升资源调度效率，在保障业务高可用性的前提下，实现成本的大幅优化！',
        tab_3_title: '持续运营',
        tab_3_sub: '成本运营流程化，降本效果可持续',
        tab_3_text: '覆盖成本管理全流程，从业务规划、成本预算、到资源申请、业务上线、例行监测，持续评估业务成本现状与优化目标之间的差距，并采取运营措施，保障成本优化效果的持续性。',
        button_free: '免费试用'
      },
      planCostWhy: {
        title_line1: '为什么选择Galaxy Future',
        title_line2: '成本优化解决方案?',
        feature_1_title: '成本全景可视化',
        feature_1_text: '从云平台、云产品、业务线、应用等多维度分析并展示成本现状，高效洞察成本问题。',
        feature_2_title: '成本精细化拆分',
        feature_2_text: '将成本精细化拆分到具体应用，快速精准定位资源消耗最多的业务，明确优化方向。',
        feature_3_title: '多维度优化手段',
        feature_3_text: '提供服务器层、容器层、业务层等多个维度的成本优化功能，轻松达成优化目标。',
        feature_4_title: '定制化优化方案',
        feature_4_text: '基于成本洞察结果，为企业量身定制高效优化方案，实现体系化且有针对性的成本优化。',
        button_demo: '预约演示'
      },
      floatConnect: {
        phoneTitle: '欢迎来电咨询',
        fcAssistant: 'AI助理',
        fcPhone: '电话咨询',
        fcDemo: '预约演示',
        fcWechat: '扫码获取',
        qmPhoneTitle: '预约回电',
        qmPhoneDesc: '专家顾问将在预约时间内向您致电',
        qmDemoTitle: '预约演示',
        qmDemoDesc: '专家顾问会在3小时内致电讲解',
        qmPhonePlaceholder: '请输入手机号码',
        qmSubmit: '立即预约',
        qmSuccess: '预约成功，顾问将尽快与您联系',
        qmPhoneError: '请输入正确的手机号码',
        qmNow: '立即回电',
        qmNowDesc: '等待时间：30分钟内',
        qmLater: '稍后回电',
        qmLaterDesc: '选择日期与时间段',
        qmToday: '今天',
        qmTomorrow: '明天',
        qmDayAfter: '后天',
        phoneNumber: '[AI CEO]0592-3396506',
        emailTitle: '欢迎邮件咨询',
        wechatTitle: '微信扫码 在线咨询',
        saasService: 'SaaS服务',
        aiAssistant: '星汉道哥(AI助理)',
        digitalHuman: 'AI数字人',
        digitalHumanTitle: 'AI数字人互动',
        digitalHumanShow: '和AI数字人语音对话',
        digitalHumanHide: '隐藏数字人',
        dhHint: '我是AI数字人，点击和我语音对话吧',
        dhLoading: '数字人加载中，请稍候…',
        dhTimeout: '加载较慢，请检查网络后重试',
        dhRetry: '重新加载',
        dhPermissionDenied: '麦克风权限未开启，暂无法语音对话，可在浏览器设置中允许后刷新'
      },
      chatbot: {
        title: '星汉道哥(AI助理)',
        history: '历史记录',
        newChat: '新建对话',
        historyChat: '历史对话',
        replying: '正在回答...',
        copy: '复制内容',
        inputPlaceholder: '输入消息...',
        replyingPlaceholder: '机器人回复中...',
        copySuccess: '已复制到剪贴板',
        retryLater: '当前访问人数过多，请稍后重试。',
        newChatTitle: '新对话',
        greeting: '您好！我是星汉道哥(AI助理)，很高兴为您服务。请问有什么我可以帮您的吗？',
        suggestTitle: '你可以问我：',
        suggest1: 'AI数字人有哪些应用场景？',
        suggest2: '有哪些行业落地案例？',
        suggest3: '如何接入或合作？'
      }
    }
  }
}
